[
  {
    "key": "txt_NewSurvey_366",
    "text": "New Survey",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "pulse_select_sections",
    "text": "Select Drivers",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DRIVER_MOD_SCORE",
    "text": "Driver Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة عامل الاندماج"
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "Impact / Driver",
    "translations": [
      {
        "language": "AR",
        "text": "التأثير / العامل"
      },
      {
        "language": "EN",
        "text": "Impact / Driver"
      }
    ]
  },
  {
    "key": "ENPS_INFO_NEG",
    "text": "Most employees do not recommend your business as a good workplace",
    "translations": [
      {
        "language": "AR",
        "text": "غالبية الموظفين لا يوصون بمؤسستكم كمكان جيد للعمل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ENPS_INFO_NEU",
    "text": "Most employees are neutral towards the workplace",
    "translations": [
      {
        "language": "AR",
        "text": "غالبية الموظفين يتخذون موقفًا محايدًا تجاه بيئة العمل في مؤسستكم"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ENPS_INFO_POS",
    "text": "Most employees recommend your business as a good workplace",
    "translations": [
      {
        "language": "AR",
        "text": "غالبية الموظفين يوصون بمؤسستكم كمكان جيد للعمل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_eNPSScore_947",
    "text": "eNPS Score by Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "درجة صافي نقاط ترويج الموظفين حسب المعايير"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_HideBreak_950",
    "text": "Hide Breakdown",
    "translations": [
      {
        "language": "AR",
        "text": "إخفاء التفاصيل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ScoreByCr_756",
    "text": "Score By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة حسب المعيار"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ShowBreak_712",
    "text": "Show Breakdown",
    "translations": [
      {
        "language": "AR",
        "text": "إظهار التفاصيل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_19_DESCRIPTION_P",
    "text": "Switch to the eNPS tab to compare scores across your superior teams and see how they measure against each other.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى تبويب صافي نقاط ترويج الموظفين لمقارنة نتائج فرق المدراء ومعرفة كيف تتقارن فيما بينها."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION_P",
    "text": "Go beyond the overall scores, select a specific engagement driver to see how your superior teams are scoring on each area of engagement.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج الاندماج الوظيفي الكلية واختر عاملاً محددًا للاندماج الوظيفي لمعرفة درجات فرق المدراء في كل عامل من عوامل الاندماج الوظيفي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION_P",
    "text": "Sort superior team scores in ascending or descending order to quickly identify your top and lowest engaged superiors. ",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج فرق المدراء تصاعديًا أو تنازليًا لتحديد المدراء الأعلى والأقل اندماجًا."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION_P",
    "text": "Compare scores across multiple superiors and see how they perform against the organization’s overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن النتائج بين المدراء والفرق التابعة لهم واطّلع على أدائهم مقارنة بالنتائج الكلية للمؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION_P",
    "text": "See how your superior teams stack up against each other. Use Multi-Compare to compare engagement scores across multiple superiors at once, or Peer-to-Peer to put two superiors' side by side by checking the boxes, making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت درجات الاندماج الوظيفي بين فرق المدراء المختلفة. استخدم المقارنة المتعددة لمقارنة درجات الاندماج الوظيفي بين المدراء دفعة واحدة، أو المقارنة بين مديرين لوضع المدراء وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_2",
    "text": "Switch to the positional view to explore the org chart based on superiors and their teams, helping you understand engagement dynamics at the team level and identify where leadership is making an impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى العرض حسب الهيكل الوظيفي لعرض أداء كل مدير مباشر والفريق التابع له. يمكنك من خلاله فهم مستويات الاندماج الوظيفي على مستوى الفرق، وتحديد مدى تأثير القيادة على النتائج."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_20_DESCRIPTION",
    "text": "Download the multi-compare report to easily review or share the comparison results. Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة المتعددة لمراجعة نتائج المقارنة أو مشاركتها بسهولة. ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_20_TITLE",
    "text": "Multi-Compare Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة المتعددة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_19_DESCRIPTION",
    "text": "Switch to the eNPS tab to compare Employee Net Promoter Scores across your entities and see how they measure up against each other. ",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى تبويب صافي نقاط ترويج الموظفين لمقارنة نتائج الوحدات ومعرفة كيف تتقارن فيما بينها."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_19_TITLE",
    "text": "eNPS View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض صافي نقاط ترويج الموظفين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION",
    "text": "Go beyond the overall scores, select a specific engagement driver to see how your entities are scoring on each area of engagement.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج الاندماج الوظيفي الكلية واختر عاملاً محددًا للاندماج الوظيفي لمعرفة درجات الوحدات في كل عامل من عوامل الاندماج الوظيفي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_TITLE",
    "text": "Driver Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار العوامل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION",
    "text": "Sort entity scores in ascending or descending order to quickly identify your top and lowest engaged entities.",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج الوحدات تصاعديًا أو تنازليًا لتحديد الوحدات الأعلى والأقل اندماجًا."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_17_TITLE",
    "text": "Sorting",
    "translations": [
      {
        "language": "AR",
        "text": "الترتيب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION",
    "text": "Compare scores across multiple entities and see how they perform against the organization’s overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن درجات الاندماج الوظيفي عبر عدة وحدات واطّلع على أدائها مقارنة بالنتائج الكلية للمؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_TITLE",
    "text": "Multi Compare",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة المتعددة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_15_DESCRIPTION",
    "text": "Download the peer-to-peer comparison report to easily review or share the comparison results. Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة بين مديرين لمراجعة نتائج المقارنة أو مشاركتها بسهولة. ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_15_TITLE",
    "text": "Peer-to-Peer Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة بين مديرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_14_DESCRIPTION",
    "text": "Use the dropdown to switch between superiors and explore different superior teams’ comparisons.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم القائمة المنسدلة لتغيير المدراء واستعرض المقارنات بين الفرق التابعة لهم."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_14_TITLE",
    "text": "Change Superiors",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير المدراء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_13_DESCRIPTION",
    "text": "Easily spot differences in engagement scores, key drivers, and eNPS between superiors — all displayed side by side.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف الفروقات في درجات الاندماج الوظيفي والعوامل الرئيسية وصافي نقاط ترويج الموظفين بين المدراء والفرق التابعة لهم بسهولة — معروضة جنبًا إلى جنب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_13_TITLE",
    "text": "Peer-to-Peer Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة بين مديرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION",
    "text": "See how your entities stack up against each other. Use Multi-Compare to compare engagement scores across multiple entities at once, or Peer- to-Peer to put two entities side by side by checking the boxes — making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت الوحدات فيما بينها. استخدم المقارنة المتعددة لمقارنة درجات الاندماج الوظيفي بين عدة وحدات دفعة واحدة، أو المقارنة بين وحدتين لوضع وحدتين وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_TITLE",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_10_DESCRIPTION",
    "text": "Customize your view by changing the layout, displaying key analysis, or selecting a specific driver to explore deeper insights. Note: A maximum of 3 options can be selected",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير طريقة عرض النتائج من خلال تعديل التخطيط، أو إظهار أبرز التحليلات، أو اختيار عامل محدد للتعمّق في التحليلات. ملاحظة: يمكن اختيار 3 خيارات كحد أقصى."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_10_TITLE",
    "text": "Customize View",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_1",
    "text": "View your org chart by function to see how your entities are structured and how engagement scores are distributed across them, giving you a clear picture of performance at every level of your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض الهيكل التنظيمي حسب الإدارات لترى كيف يتم تنظيم الوحدات داخل مؤسستك وكيف تتوزع درجات الاندماج الوظيفي بينها، مما يمنحك صورة واضحة عن الأداء على مختلف مستويات المؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_1",
    "text": "Functional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_2",
    "text": "Positional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_8_DESCRIPTION",
    "text": "Click here to re-center the org chart and bring it back to the default view.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أيقونة التمركز لإعادة الهيكل التنظيمي فورًا إلى منتصف الشاشة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_8_TITLE",
    "text": "Center",
    "translations": [
      {
        "language": "AR",
        "text": "التمركز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_7_DESCRIPTION",
    "text": "Switch to full-screen mode for a wider, more immersive view of your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى وضع ملء الشاشة للحصول على عرض أوسع وأشمل للهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_7_TITLE",
    "text": "Fullscreen",
    "translations": [
      {
        "language": "AR",
        "text": "ملء الشاشة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_6_DESCRIPTION",
    "text": "Want to see the full picture? Expand the org chart to reveal all levels and details across your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "هل تريد رؤية الصورة الكاملة؟ قم بتوسيع الهيكل التنظيمي لاستعراض جميع المستويات والتفاصيل في مؤسستك."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_6_TITLE",
    "text": "Expand",
    "translations": [
      {
        "language": "AR",
        "text": "توسيع"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_5_DESCRIPTION",
    "text": "Collapse the entire org chart at once to reset the view and start fresh from the top level.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بطي الهيكل التنظيمي بالكامل لإعادة ضبط العرض والبدء من المستوى الأعلى."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_5_TITLE",
    "text": "Collapse",
    "translations": [
      {
        "language": "AR",
        "text": "طيّ"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_4_DESCRIPTION",
    "text": "Zoom out to see the bigger picture of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتصغير العرض لرؤية الصورة الأشمل لهيكل مؤسستك."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_4_TITLE",
    "text": "Zoom Out",
    "translations": [
      {
        "language": "AR",
        "text": "تصغير العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_3_DESCRIPTION",
    "text": "Zoom in to take a closer look at specific areas of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتكبير العرض لإلقاء نظرة أقرب على مناطق محددة في الهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_3_TITLE",
    "text": "Zoom In",
    "translations": [
      {
        "language": "AR",
        "text": "تكبير العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_2_DESCRIPTION",
    "text": "Quickly find what you need using the search bar — search by entity or superior and navigate directly to the right spot in your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم شريط البحث للوصول السريع إلى ما تحتاجه — ابحث حسب الوحدة أو المسؤول المباشر وانتقل فورًا إلى موقعه في الهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_2_TITLE",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "البحث"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_1_DESCRIPTION",
    "text": "In the \"Org chart\" page, you can explore your organization's structure — whether by function or position — and see how each level is performing at a glance, making it easier to spot strengths and areas for growth.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"الهيكل التنظيمي\"، يمكنك استعراض هيكل مؤسستك — سواء التنظيمي أو الوظيفي — والاطّلاع على أداء كل مستوى بنظرة واحدة، مما يسهّل عليك تحديد نقاط القوة وفرص التطوير."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_1_TITLE",
    "text": "Org chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_survey_score",
    "text": "Engagement Score:",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DriverEng_784",
    "text": "Driver Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Inthe“Act_184",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost engagement.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى الاندماج الوظيفي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "EXPIRED",
    "text": "Expired",
    "translations": [
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Descendin_511",
    "text": "Descending",
    "translations": [
      {
        "language": "AR",
        "text": "تنازلياً"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Ascending_621",
    "text": "Ascending",
    "translations": [
      {
        "language": "AR",
        "text": "تصاعدياً"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Pleasesel_422",
    "text": "Please select the respondent(s)",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تحديد المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Notavaila_420",
    "text": "Not available when extra driver is turned on.",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير غير متاحة عند تشغيل العامل الإضافي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "neutral",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "positive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "negative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "NEGATIVE",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "sentiment_positive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "sentiment_negative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "sentiment_neutral",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_module_score",
    "text": "Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_by_driver",
    "text": "By Driver",
    "translations": [
      {
        "language": "AR",
        "text": "حسب العامل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_section",
    "text": "Driver",
    "translations": [
      {
        "language": "AR",
        "text": "العامل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_for_survey",
    "text": "For Engagement Survey:",
    "translations": [
      {
        "language": "AR",
        "text": "لاستبيان الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectOrd_776",
    "text": "Select Order",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الترتيب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EngagedHi_149",
    "text": "Engaged High",
    "translations": [
      {
        "language": "AR",
        "text": " مندمج مرتفع"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EngagedMid",
    "text": "Engaged Mid",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج معتدل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Driver:s_700",
    "text": "Driver: <span class=\"\"font-medium text-zen-primaryDark\">{{0}}</span>",
    "translations": [
      {
        "language": "AR",
        "text": "العامل: <span class=\"\"font-medium text-zen-primaryDark\">{{0}}</span>"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Driver:<s_700",
    "text": "Driver: <span class=\"\"font-medium text-zen-primaryDark\">{{0}}</span>",
    "translations": [
      {
        "language": "AR",
        "text": "العامل: <span class=\"\"font-medium text-zen-primaryDark\">{{0}}</span>"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_OverallEm_152",
    "text": "Overall Employee Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية للاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EngagedLo_498",
    "text": "Engaged Low",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج منخفض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_#ofRespon_617",
    "text": "# of Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Engagemen_614",
    "text": "Engagement Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Planning&_973",
    "text": "Planning & Action",
    "translations": [
      {
        "language": "AR",
        "text": "التخطيط والعمل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Analysis&_518",
    "text": "Analysis & insights",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_POS_MeanScore",
    "text": "Team Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة اندماج الفريق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "CompanyMeanScore",
    "text": "Company Avg.",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط المؤسسة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "RespondentCount",
    "text": "Number of Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_completed_622",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Tasks:_692",
    "text": "Tasks:",
    "translations": [
      {
        "language": "AR",
        "text": "المهام:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_LowesttoH_976",
    "text": "Lowest to Highest eNPS",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين من الأقل للأعلى"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Highestto_667",
    "text": "Highest to Lowest eNPS",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين من الأعلى للأقل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SortBy_857",
    "text": "Sort By",
    "translations": [
      {
        "language": "AR",
        "text": "ترتيب حسب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CompanyeN_925",
    "text": "Company eNPS",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين للمؤسسة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_eNPSCompa_388",
    "text": "eNPS Compare",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة صافي نقاط ترويج الموظفين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_Eng_Comp",
    "text": "Engagement Compare",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AllDriver_743",
    "text": "All Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "جميع العوامل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_NUMBEROFR_232",
    "text": "NUMBER OF  RESPONDENTS",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Engagemen_603",
    "text": "Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Pleasereu_180",
    "text": "Please reupload the file after you’ve fixed the validation errors mentioned above.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إعادة رفع الملف بعد إصلاح أخطاء التحقق المذكورة أعلاه."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "RespondentsValidationErorrs",
    "text": "<span>{{0}}</span> Respondents have the following validation errors:",
    "translations": [
      {
        "language": "AR",
        "text": "<span>{{0}}</span> يوجد لدى المستجيبين أخطاء التحقق التالية:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_<span>{{0_912",
    "text": "<span>{{0}}</span> Respondents have the following validation errors:",
    "translations": [
      {
        "language": "AR",
        "text": "<span>{{0}}</span> يوجد لدى المستجيبين أخطاء التحقق التالية:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_<spanclas_295",
    "text": "<span class=\"font-medium\">{{0}}</span> Respondents detected as valid!",
    "translations": [
      {
        "language": "AR",
        "text": "<span class=\"font-medium\">{{0}}</span> تم العثور على مستجيبين صالحين!"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Respondentsdetected",
    "text": "<span class=\"font-medium\">{{0}}</span> Respondents detected!",
    "translations": [
      {
        "language": "AR",
        "text": "<span class=\"font-medium\">{{0}}</span> تم العثور على مستجيبين!"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Click<spa_754",
    "text": "Click <span class=\"font-medium\">Next</span> to continue",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط <span class=\"font-medium\">التالي</span> للمتابعة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Responden_213",
    "text": "Respondents detected!",
    "translations": [
      {
        "language": "AR",
        "text": "تم العثورعلى مستجيبين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_UploadCom_429",
    "text": "Upload Completed!",
    "translations": [
      {
        "language": "AR",
        "text": "تم رفع الملف بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Uploading_993",
    "text": "Uploading in progress...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري رفع الملف..."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Uploading_588",
    "text": "Uploading file...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري رفع الملف..."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Abort_895",
    "text": "Abort",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_UploadTem_339",
    "text": "Upload File",
    "translations": [
      {
        "language": "AR",
        "text": "رفع الملف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "DownloadTemplate",
    "text": "Download File",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل الملف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DownloadT_288",
    "text": "Download File",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل الملف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Toaddresp_423",
    "text": "<span class=\"text-exp\">STEP 1:</span>  <br /> <br />  Click \"Download file\" to download the premade spreadsheet (.xlsx). <br /> <br />              <span class=\"text-exp\">STEP 2:</span>  <br /> <br />  Fill out the premade template and save it. <br /> <br />  <span class=\"text-exp\">STEP 3:</span>  <br /> <br />  Click \"Upload File\" to upload the filled-out spreadsheet.",
    "translations": [
      {
        "language": "AR",
        "text": "<span class=\"text-exp\">خطوة 1: </span>  <br /> <br />  اضغط على زر \"تحميل الملف\" لتحميل جدول بيانات فارغ (.xlsx) <br /> <br />              <span class=\"text-exp\">خطوة 2: </span>  <br /> <br />  املأ جدول بيانات الذي تم تحميله واحفظه <br /> <br />  <span class=\"text-exp\">خطوة 3: </span>  <br /> <br />  اضغط على زر \"رفع الملف\" لرفع جدول البيانات الذي تم تعبئته (.xlsx)"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Youreasking",
    "text": "You’re asking for feedback on this initiative’s impact:",
    "translations": [
      {
        "language": "AR",
        "text": "يتم الآن طلب تغذية راجعة لمدى تأثير المبادرة المحددة على مكان العمل:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "send_using_whatsapp_desc",
    "text": "Send Invites Using WhatsApp",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات عبر الواتساب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "send_using_whatsapp",
    "text": "Send Invites By WhatsApp",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات عبر الواتساب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Last{{0}}_783",
    "text": "Last {{0}} Days",
    "translations": [
      {
        "language": "AR",
        "text": "آخر{{0}} يوم"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Account Manager",
    "text": "Account Manager",
    "translations": [
      {
        "language": "AR",
        "text": "مسؤول الحساب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Expiry Date",
    "text": "Expiry Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ انتهاء الصلاحية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Units Balance",
    "text": "Units Balance",
    "translations": [
      {
        "language": "AR",
        "text": "رصيد الوحدات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Last Login",
    "text": "Last Login",
    "translations": [
      {
        "language": "AR",
        "text": "آخر تسجيل دخول"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Country",
    "text": "Country",
    "translations": [
      {
        "language": "AR",
        "text": "الدولة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Alphabetical",
    "text": "Alphabetical",
    "translations": [
      {
        "language": "AR",
        "text": "الأبجدية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Show_197",
    "text": "Show",
    "translations": [
      {
        "language": "AR",
        "text": "عرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_All_484",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Pleaseent_769",
    "text": "Please enter a valid task before saving.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال مهمة صالحة قبل الحفظ."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Completed_892",
    "text": "Completed on: {{0}}",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال: {{0}}"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "IN_PROGRESS",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_202",
    "text": "Initiative Completed",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة مكتملة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_425",
    "text": "Initiative Expired",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة منتهية الصلاحية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_863",
    "text": "Initiative In progress",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرة قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Pleaseass_873",
    "text": "Please assign owners to all selected initiatives before launching the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعيين مسؤولين لكل المبادرات المختارة قبل إطلاق خطة العمل."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Overdue_155",
    "text": "Overdue",
    "translations": [
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_OverallPr_227",
    "text": "Overall Progress",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الإنجاز الكلي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "COMPLETED",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "DRAFT",
    "text": "Draft",
    "translations": [
      {
        "language": "AR",
        "text": "مسودة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "IN PROGRESS",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Initiativ_381",
    "text": "Initiative Deleted Successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف المبادرة بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Areyousur_105",
    "text": "Are you sure you want to delete this initiative? <br/> This action cannot be undone and all related data may be permanently removed.",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من رغبتك في حذف هذه المبادرة <br/> لا يمكن التراجع عن هذا الإجراء، وقد يتم حذف جميع البيانات المرتبطة بها نهائياً."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TaskDelet_687",
    "text": "Task Deleted Successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف المهمة بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_EditIniti_710",
    "text": "Edit Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المبادرة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CreateIni_591",
    "text": "Create Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مبادرة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Discard_387",
    "text": "Discard",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ActionPla_283",
    "text": "Action Plan Deleted Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف خطة العمل بنجاح!"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Yes,Delet_331",
    "text": "Yes, Delete",
    "translations": [
      {
        "language": "AR",
        "text": "نعم، حذف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Areyousur_693",
    "text": "Are you sure you want to delete this action plan? <br/> This action cannot be undone and all related data may be permanently removed.",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من رغبتك في حذف خطة العمل هذه؟ <br/> لا يمكن التراجع عن هذا الإجراء، وقد يتم حذف جميع البيانات المرتبطة بها نهائياً."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Permissio_309",
    "text": "Permission",
    "translations": [
      {
        "language": "AR",
        "text": "الصلاحيات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Inactive",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعّال"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Expired",
    "text": "Expired",
    "translations": [
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "In Progress",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Draft",
    "text": "Draft",
    "translations": [
      {
        "language": "AR",
        "text": "مسودة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Departmen_944",
    "text": "Department-specific",
    "translations": [
      {
        "language": "AR",
        "text": "خاص بالإدارة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Company-w_292",
    "text": "Company-wide",
    "translations": [
      {
        "language": "AR",
        "text": "على مستوى المؤسسة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DateClose_751",
    "text": "Date Closed",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإغلاق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_OverallEn_950",
    "text": "Overall Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي الكلي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_closed_730",
    "text": "Closed",
    "translations": [
      {
        "language": "AR",
        "text": "مغلق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BacktoSur_902",
    "text": "Back to Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع إلى الاستبيانات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AddTask_557",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مهمة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Teams:_916",
    "text": "Teams:",
    "translations": [
      {
        "language": "AR",
        "text": "الفريق:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Departmen_835",
    "text": "Department:",
    "translations": [
      {
        "language": "AR",
        "text": "الإدارة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Company:_522",
    "text": "Company:",
    "translations": [
      {
        "language": "AR",
        "text": "المؤسسة:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SelectedB_211",
    "text": "Selected Business Entity(s) will be automatically applied to the scope of this action plan as follow:",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم تطبيق وحدات العمل المختارة تلقائياً على نطاق خطة العمل هذه كما يلي:"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Scope_580",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DeselectC_209",
    "text": "Deselect Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد إلغاء التحديد"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUnLikely",
    "text": "Unlikely",
    "translations": [
      {
        "language": "AR",
        "text": "غير مُرجح"
      },
      {
        "language": "EN",
        "text": "Unlikely"
      },
      {
        "language": "FR",
        "text": " peu probable"
      }
    ]
  },
  {
    "key": "txtLikely",
    "text": "Likely",
    "translations": [
      {
        "language": "AR",
        "text": "مُرجّح"
      },
      {
        "language": "EN",
        "text": "Likely"
      },
      {
        "language": "FR",
        "text": "très probable"
      }
    ]
  },
  {
    "key": "txt_EntitiesC_484",
    "text": "Entities Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الوحدات"
      }
    ]
  },
  {
    "key": "txt_Workplace_308",
    "text": "Workplace Engagement Scores",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي في مكان العمل"
      }
    ]
  },
  {
    "key": "txt_Division_900",
    "text": "Division",
    "translations": [
      {
        "language": "AR",
        "text": "القسم"
      }
    ]
  },
  {
    "key": "txtWorkplaceEngagementScore",
    "text": "Workplace Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي في مكان العمل"
      }
    ]
  },
  {
    "key": "txt_DriverSco_560",
    "text": "Driver Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العامل"
      }
    ]
  },
  {
    "key": "txt_end_date",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      }
    ]
  },
  {
    "key": "txt_Setthesta_318",
    "text": "Set the start and end dates during which the feedback survey will be active and open for responses:",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخي البداية والنهاية لفترة صلاحية الاستبيان واستقبال الردود:"
      }
    ]
  },
  {
    "key": "txt_Start&Com_839",
    "text": "Start & Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء والإكمال"
      }
    ]
  },
  {
    "key": "txt_BulkUploa_742",
    "text": "Bulk Upload",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل على دفعة واحدة"
      }
    ]
  },
  {
    "key": "txt_Howeffect_770",
    "text": "How effective was this initiative for you?",
    "translations": [
      {
        "language": "AR",
        "text": "ما مدى فعالية هذه المبادرة بالنسبة لك؟"
      }
    ]
  },
  {
    "key": "txt_Question:_818",
    "text": "Question:",
    "translations": [
      {
        "language": "AR",
        "text": "السؤال:"
      }
    ]
  },
  {
    "key": "txt_Responses_976",
    "text": "Responses are anonymous and help assess impact. The following question will be sent to selected respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "الردود مجهولة المصدر وتساعد في تقييم الأثر. سيتم إرسال السؤال التالي إلى المستجيبين المحددين."
      }
    ]
  },
  {
    "key": "txt_Establish_746",
    "text": "Establish innovation awareness campaigns",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_You’reask_512",
    "text": "You’re asking for feedback on this initiative’s impact:",
    "translations": [
      {
        "language": "AR",
        "text": "يتم الآن طلب تغذية راجعة لمدى تأثير المبادرة المحددة على مكان العمل:"
      }
    ]
  },
  {
    "key": "txt_RequestFe_413",
    "text": "Request Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب آراء الموظفين"
      }
    ]
  },
  {
    "key": "txt_Completed_450",
    "text": "Completed on:",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال:"
      }
    ]
  },
  {
    "key": "txt_Markallas_851",
    "text": "Mark all as complete",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل كمكتمل"
      }
    ]
  },
  {
    "key": "txt_days_636",
    "text": "days",
    "translations": [
      {
        "language": "AR",
        "text": "يوم"
      }
    ]
  },
  {
    "key": "txt_TimeRemai_140",
    "text": "Time Remaining:",
    "translations": [
      {
        "language": "AR",
        "text": "الوقت المتبقي:"
      }
    ]
  },
  {
    "key": "txt_LastUpdat_546",
    "text": "Last Updated:",
    "translations": [
      {
        "language": "AR",
        "text": "آخر تحديث:"
      }
    ]
  },
  {
    "key": "txt_EndDate:_515",
    "text": "End Date:",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      }
    ]
  },
  {
    "key": "txt_Started:_931",
    "text": "Started:",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء:"
      }
    ]
  },
  {
    "key": "txt_Topics_628",
    "text": "Topics",
    "translations": [
      {
        "language": "AR",
        "text": "الموضوعات"
      }
    ]
  },
  {
    "key": "txt_Initiativ_528",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "txt_FocusArea_748",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "txt_Status:_670",
    "text": "Status:",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة:"
      }
    ]
  },
  {
    "key": "txt_ActionPla_611",
    "text": "Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "txt_Open_675",
    "text": "Open",
    "translations": [
      {
        "language": "AR",
        "text": "فتح"
      }
    ]
  },
  {
    "key": "txt_Typetosea_606",
    "text": "Type to search...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب للبحث..."
      }
    ]
  },
  {
    "key": "txt_Owner_978",
    "text": "Owner",
    "translations": [
      {
        "language": "AR",
        "text": "المسؤول"
      }
    ]
  },
  {
    "key": "txt_SelectDue_300",
    "text": "Select Due Date",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد تاريخ الانتهاء"
      }
    ]
  },
  {
    "key": "txt_Typeashor_778",
    "text": "Type a short description here...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب الوصف هنا..."
      }
    ]
  },
  {
    "key": "txt_Typeanini_239",
    "text": "Type an initiative title here...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب عنوان المبادرة هنا..."
      }
    ]
  },
  {
    "key": "Due_Date",
    "text": "Due Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      }
    ]
  },
  {
    "key": "txt_DueDate_546",
    "text": "Due Date",
    "translations": [
      {
        "language": "AR",
        "text": "موعد الانتهاء"
      }
    ]
  },
  {
    "key": "txt_Initiativ_478",
    "text": "Initiative Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان المبادرة"
      }
    ]
  },
  {
    "key": "txt_NewInitia_374",
    "text": "New Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة جديدة"
      }
    ]
  },
  {
    "key": "txt_Generatin_932",
    "text": "Generating Initiatives...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري إنشاء المبادرات..."
      }
    ]
  },
  {
    "key": "txt_Suggested_382",
    "text": "Suggested by:",
    "translations": [
      {
        "language": "AR",
        "text": "مقترحة من:"
      }
    ]
  },
  {
    "key": "txt_GenerateI_968",
    "text": "Generate Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مبادرات"
      }
    ]
  },
  {
    "key": "txt_Gettailor_360",
    "text": "Get tailored initiatives for each Topic with Zenithr AI.",
    "translations": [
      {
        "language": "AR",
        "text": "احصل على مبادرات مصممة خصيصًا لكل موضوع مع زينيثر AI."
      }
    ]
  },
  {
    "key": "txt_GenerateT_948",
    "text": "Generate Task",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مهمة"
      }
    ]
  },
  {
    "key": "txt_AddCustom_378",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مهمة"
      }
    ]
  },
  {
    "key": "txt_Typeatask_606",
    "text": "Type a task here....",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب المهمة هنا..."
      }
    ]
  },
  {
    "key": "txt_Tasks_853",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      }
    ]
  },
  {
    "key": "txt_TasksSele_383",
    "text": "Tasks Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المختارة"
      }
    ]
  },
  {
    "key": "txt_Predefine_961",
    "text": "Predefined Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مُعرفة مسبقاً"
      }
    ]
  },
  {
    "key": "txt_TotalTask_831",
    "text": "Total Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "مجموع المهام"
      }
    ]
  },
  {
    "key": "txt_TotalInit_975",
    "text": "Total Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "مجموع المبادرات"
      }
    ]
  },
  {
    "key": "txt_FocusArea_810",
    "text": "Focus Areas Selected",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز المختارة"
      }
    ]
  },
  {
    "key": "txt_Initiativ_883",
    "text": "Initiatives Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المختارة"
      }
    ]
  },
  {
    "key": "txt_ByTopic_402",
    "text": "By Topic",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الموضوع"
      }
    ]
  },
  {
    "key": "txt_ByDriver_400",
    "text": "By Driver",
    "translations": [
      {
        "language": "AR",
        "text": "حسب العامل"
      }
    ]
  },
  {
    "key": "txt_GenerateI_257",
    "text": "Generate Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مبادرات"
      }
    ]
  },
  {
    "key": "txt_AddCustom_219",
    "text": "Add Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مبادرة"
      }
    ]
  },
  {
    "key": "txt_SelectIni_699",
    "text": "Select Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "txt_SelectFoc_496",
    "text": "Select Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "txt_Launch_119",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "txt_SaveasDra_700",
    "text": "Save as Draft",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ كمسودة"
      }
    ]
  },
  {
    "key": "txt_NewAction_702",
    "text": "New Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة عمل جديدة"
      }
    ]
  },
  {
    "key": "txt_CreateAct_104",
    "text": "New Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة عمل جديدة"
      }
    ]
  },
  {
    "key": "txt_Startanac_763",
    "text": "Start an action plan to address key focus areas, set measurable goals, and drive meaningful improvements across your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "بدأ بوضع خطة عمل لمعالجة مجالات التركيز الرئيسية، وتحديد أهداف قابلة للقياس، ودفع عجلة التحسينات الملموسة في جميع أنحاء المؤسسة."
      }
    ]
  },
  {
    "key": "txt_Thissurve_315",
    "text": "This survey revealed important insights about your team’s engagement.",
    "translations": [
      {
        "language": "AR",
        "text": "لقد كشف هذا الاستبيان عن رؤى ومؤشرات هامة عن مستوى الاندماج الوظيفي للفريق."
      }
    ]
  },
  {
    "key": "txt_TurnInsig_176",
    "text": "Turn Insights Into Action",
    "translations": [
      {
        "language": "AR",
        "text": "تحويل نتائج الاستبيان إلى خطوات قابلة للتنفيذ"
      }
    ]
  },
  {
    "key": "txt_Switch_196",
    "text": "Switch",
    "translations": [
      {
        "language": "AR",
        "text": "تحويل"
      }
    ]
  },
  {
    "key": "txt_ActiveBus_111",
    "text": "Active Business Entity:",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة العمل النشطة:"
      }
    ]
  },
  {
    "key": "txt_Therearen_326",
    "text": "There are no Action Plans available for the active business entity",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد خطة عمل للوحدة المختارة"
      }
    ]
  },
  {
    "key": "txt_ActionPla_663",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "txt_Thebelowc_176",
    "text": "The below chart displays the recent 5 survey results",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض الرسم البياني أدناه نتائج آخر 5 استبيانات"
      }
    ]
  },
  {
    "key": "txt_Phone_693",
    "text": "Phone",
    "translations": [
      {
        "language": "AR",
        "text": "الهاتف"
      }
    ]
  },
  {
    "key": "txt_CompanyAv_519",
    "text": "Company Avg.",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط الدرجة للشركة"
      }
    ]
  },
  {
    "key": "txt_TeameNPSS_715",
    "text": "Team eNPS Score",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين للفريق"
      }
    ]
  },
  {
    "key": "txt_TeamEngag_965",
    "text": "Team Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي للفريق"
      }
    ]
  },
  {
    "key": "txt_Positiona_403",
    "text": "Positional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل الوظيفي"
      }
    ]
  },
  {
    "key": "EmployeeEngagementSurvey",
    "text": "Employee Engagement Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان الاندماج الوظيفي"
      }
    ]
  },
  {
    "key": "txt_HRAssessm_180",
    "text": "HR Assessment Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير تقييم الموارد البشرية"
      }
    ]
  },
  {
    "key": "txt_ResetAll_603",
    "text": "Reset All",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين"
      }
    ]
  },
  {
    "key": "txt_Left-to-r_702",
    "text": "Left-to-right view of the org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "عرض هيكل المؤسسة من اليسار إلى اليمين"
      }
    ]
  },
  {
    "key": "txt_Top-downv_239",
    "text": "Top-down view of the org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "عرض هيكل المؤسسة من الأعلى إلى الأسفل"
      }
    ]
  },
  {
    "key": "txt_Horizonta_640",
    "text": "Horizontal",
    "translations": [
      {
        "language": "AR",
        "text": "أفقي"
      }
    ]
  },
  {
    "key": "txt_Vertical_169",
    "text": "Vertical",
    "translations": [
      {
        "language": "AR",
        "text": "عمودي"
      }
    ]
  },
  {
    "key": "txt_n_248",
    "text": "n",
    "translations": [
      {
        "language": "AR",
        "text": "العدد"
      }
    ]
  },
  {
    "key": "txt_Layout_774",
    "text": "Layout",
    "translations": [
      {
        "language": "AR",
        "text": "المخطط"
      }
    ]
  },
  {
    "key": "txt_Expandall_796",
    "text": "Expand all  entities",
    "translations": [
      {
        "language": "AR",
        "text": "فرز جميع الوحدات"
      }
    ]
  },
  {
    "key": "txt_Collapsea_767",
    "text": "Collapse all entities",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق جميع الوحدات"
      }
    ]
  },
  {
    "key": "txt_Zoomout_736",
    "text": "Zoom out",
    "translations": [
      {
        "language": "AR",
        "text": "تصغير"
      }
    ]
  },
  {
    "key": "txt_Zoomin_186",
    "text": "Zoom in",
    "translations": [
      {
        "language": "AR",
        "text": "تكبير"
      }
    ]
  },
  {
    "key": "txt_CompanyAv_492",
    "text": "Company Average",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط درجة الشركة"
      }
    ]
  },
  {
    "key": "txt_Gap_213",
    "text": "Gap",
    "translations": [
      {
        "language": "AR",
        "text": "الفجوة"
      }
    ]
  },
  {
    "key": "txt_Current_582",
    "text": "Current",
    "translations": [
      {
        "language": "AR",
        "text": "الحالي"
      }
    ]
  },
  {
    "key": "txt_drivers",
    "text": "Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "العوامل"
      }
    ]
  },
  {
    "key": "txt_Engagemen_765",
    "text": "Engagement History",
    "translations": [
      {
        "language": "AR",
        "text": "سجل الاندماج الوظيفي"
      }
    ]
  },
  {
    "key": "txtPrevious",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      }
    ]
  },
  {
    "key": "txt_Average_101",
    "text": "Average",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "EnpsScore",
    "text": "eNPS SCORE",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين"
      }
    ]
  },
  {
    "key": "txt_SelectedN_313",
    "text": "Selected entities should be from the same level",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن تكون الوحدات المحددة من نفس المستوى"
      }
    ]
  },
  {
    "key": "txt_DisplayOp_893",
    "text": "Display Options",
    "translations": [
      {
        "language": "AR",
        "text": "خيارات العرض"
      }
    ]
  },
  {
    "key": "txt_SelectFac_343",
    "text": "Select Factors to be displayed",
    "translations": [
      {
        "language": "AR",
        "text": "اختر العوامل المراد عرضها"
      }
    ]
  },
  {
    "key": "txt_Customize_612",
    "text": "Customize Displayed Factors",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص العوامل المعروضة"
      }
    ]
  },
  {
    "key": "txt_Functiona_964",
    "text": "Functional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      }
    ]
  },
  {
    "key": "SurveyScore",
    "text": "Survey Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة الاستبيان"
      }
    ]
  },
  {
    "key": "ResponseRate",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      }
    ]
  },
  {
    "key": "eNPS Score",
    "text": "eNPS Score",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين"
      }
    ]
  },
  {
    "key": "Survey Score",
    "text": "Survey Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة الاستبيان"
      }
    ]
  },
  {
    "key": "NoOfChildEntities",
    "text": "Number of Child Entities",
    "translations": [
      {
        "language": "AR",
        "text": "عدد الوحدات الفرعية"
      }
    ]
  },
  {
    "key": "txt_Amaximumo_662",
    "text": "A maximum of 3 options can be selected.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن اختيار 3 خيارات كحد أقصى."
      }
    ]
  },
  {
    "key": "txt_Line_957",
    "text": "Line",
    "translations": [
      {
        "language": "AR",
        "text": "خط"
      }
    ]
  },
  {
    "key": "txtENPS",
    "text": "eNPS Score",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين"
      }
    ]
  },
  {
    "key": "txt_TopManage_578",
    "text": "Top Management",
    "translations": [
      {
        "language": "AR",
        "text": "الإدارة العليا"
      }
    ]
  },
  {
    "key": "txt_Workplace_103",
    "text": "Workplace Engagement Score’s",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج الوظيفي في مكان العمل"
      }
    ]
  },
  {
    "key": "txt_CompareEn_659",
    "text": "Compare Entities",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الوحدات"
      }
    ]
  },
  {
    "key": "txt_Compare_199",
    "text": "Compare",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة"
      }
    ]
  },
  {
    "key": "txt_Youselect_506",
    "text": "You select only 2",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك اختيار خيارين فقط"
      }
    ]
  },
  {
    "key": "txt_Orchart_440",
    "text": "Org chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      }
    ]
  },
  {
    "key": "txt_response_rate_status",
    "text": "RESPONDENTS BY STATUS",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الحالة"
      }
    ]
  },
  {
    "key": "txtOverallScore",
    "text": "Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      }
    ]
  },
  {
    "key": "txt_Theselect_919",
    "text": "The selected breakout requires more than 3 values to be visualized on a chart",
    "translations": [
      {
        "language": "AR",
        "text": "التقسيم المحدد يتطلب أكثر من 3 قيم ليتم عرضها على المخطط"
      }
    ]
  },
  {
    "key": "txt_Insuffici_103",
    "text": "Insufficient Data",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد بيانات كافية"
      }
    ]
  },
  {
    "key": "secure_landing_desc",
    "text": "Disable invitation emails and verify respondents access with company's email address.",
    "translations": [
      {
        "language": "AR",
        "text": "تعطيل رسائل الدعوة والتحقق من وصول المستجيبين باستخدام البريد الإلكتروني الخاص بالشركة."
      }
    ]
  },
  {
    "key": "secure_landing",
    "text": "Secure landing",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة دخول آمنة"
      }
    ]
  },
  {
    "key": "cloned",
    "text": "cloned",
    "translations": [
      {
        "language": "AR",
        "text": "منسوخ"
      }
    ]
  },
  {
    "key": "Clone",
    "text": "Clone",
    "translations": [
      {
        "language": "AR",
        "text": "نسخ"
      }
    ]
  },
  {
    "key": "txt_Workplace_731",
    "text": "Workplace Engagement By",
    "translations": [
      {
        "language": "AR",
        "text": "الاندماج الوظيفي في مكان العمل حسب"
      }
    ]
  },
  {
    "key": "txt_ViewAnaly_123",
    "text": "View Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التحليلات"
      }
    ]
  },
  {
    "key": "txtSingleSectioinForDemo",
    "text": "One Section is available for demo accounts",
    "translations": [
      {
        "language": "AR",
        "text": "قسم واحد فقط متاح للحسابات التجريبية"
      }
    ]
  },
  {
    "key": "txtNeutralAISection",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      }
    ]
  },
  {
    "key": "txtPositive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      }
    ]
  },
  {
    "key": "txtNegative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      }
    ]
  },
  {
    "key": "txtBy",
    "text": "by",
    "translations": [
      {
        "language": "AR",
        "text": "حسب"
      }
    ]
  },
  {
    "key": "txt_Togglethe_828",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the survey.<br><img class=\"mt-2\" src=\"assets/img/tours/res-info.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء الاستبيان.<br/><img class=\"mt-2\" src=\"assets/img/tours/res-info.gif\" />"
      }
    ]
  },
  {
    "key": "txt_Editordel_415",
    "text": "Edit or delete the new custom driver.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف العامل المخصص الجديد."
      }
    ]
  },
  {
    "key": "txt_EditCusto_114",
    "text": "Edit Custom Driver",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل العامل المخصص"
      }
    ]
  },
  {
    "key": "txt_Useouradv_421",
    "text": "Use our advanced AI tool to generate statements tailored to your need!",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم أداة الذكاء الاصطناعي المتطورة لإنشاء عبارات مصممة خصيصًا لاحتياجاتك!"
      }
    ]
  },
  {
    "key": "txt_GenerateS_455",
    "text": "Generate Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات"
      }
    ]
  },
  {
    "key": "txt_Clickonb_628",
    "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type.<br><br> Hint: Click “👁️” to preview the statement sample used in the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"عبارة جديدة\"</b> لإضافة عبارة مخصصة جديدة باستخدام نوع السؤال لمقياس الاتفاق. <br><br>تلميح: انقر على \"👁️\" لعرض نموذج السؤال الذي سيتم استخدامه في الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Youcanexp_624",
    "text": "You can export the comparison charts as per the current view. <br><br>Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل الرسوم البيانية للمقارنة وفقًا للعرض الحالي.<br><br> ملحوظة: متوفر في صيغة PDF."
      }
    ]
  },
  {
    "key": "txt_Selectthe_991",
    "text": "Select the companies (if any) you want to compare.<br><br> Hint: if you have multiple surveys, you have the option to view average scores or select surveys for a tailored analysis!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد الشركات (إن وُجد) التي ترغب في مقارنتها.<br><br> تلميح: إذا كانت لديك استبيانات متعددة، يُتاح لك خيار عرض متوسط الدرجات أو تحديد الاستبيانات التي ترغب في مقارنتها للحصول على تحليل مخصص."
      }
    ]
  },
  {
    "key": "txt_Selectthe_423",
    "text": "Select the start and end dates to view the analysis for a specific timeframe.",
    "translations": [
      {
        "language": "AR",
        "text": "لعرض نتائج الاندماج الوظيفي لفترة زمنية معينة، قم باختيار تواريخ البداية والنهاية."
      }
    ]
  },
  {
    "key": "txt_Readytoun_103",
    "text": "Ready to uncover your survey history's top engagement scores and compare them across years and companies (if any)? Discover the answer now!",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد للكشف عن أعلى نتائج الاندماج الوظيفي ومقارنتها عبر السنوات والشركات الخاصة بك (إن وُجد)؟ اكتشف الإجابة الآن!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_207",
    "text": "Click here to download all comments. <br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل جميع التعليقات.  <br><br>ملحوظة: متوفر في صيغة Excel."
      }
    ]
  },
  {
    "key": "txt_Unlockthe_286",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback!",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المستجيبين!"
      }
    ]
  },
  {
    "key": "txt_Expandthe_706",
    "text": "Expand the driver to view each statement score and the distribution of respondents’ answers.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عامل الاندماج لعرض متوسط كل عبارة وتوزيع إجابات المستجيبين."
      }
    ]
  },
  {
    "key": "txt_Statement_609",
    "text": "Statements’ Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العبارات"
      }
    ]
  },
  {
    "key": "txt_InStateme_752",
    "text": "In <b>\"Statements\"</b>, each driver’s score with its corresponding sub-driver is shown.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"العبارات\"</b>، يتم عرض متوسط كل عامل اندماج مع العبارات الخاصة به. "
      }
    ]
  },
  {
    "key": "txt_Changethe_415",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالنقر هنا."
      }
    ]
  },
  {
    "key": "txt_ChartType_390",
    "text": "Chart Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني"
      }
    ]
  },
  {
    "key": "txt_InRes_7169",
    "text": "In <b>“Respondent Analysis”</b>, the charts shown depend on the analytical criteria selected in the survey setup step.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"تحليل المستجيبون\"</b> تعتمد الرسوم البيانية المعروضة على المعايير التحليلية المخُتارة في خطوة إعداد الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Elevateyo_771",
    "text": "Elevate your insights with a click – download your heatmap! <br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "ارفع مستوى التحليلات بنقرة واحدة - قم بتحميل مخطط تمثيل البيانات بالألوان الخاصة بك!<br><br>ملحوظة: متوفرة في صيغة Excel."
      }
    ]
  },
  {
    "key": "txt_Export_828",
    "text": "Export ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txt_Clickonea_759",
    "text": "Click on each driver to expand the results of their statements.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على كل عامل اندماج لعرض نتائج العبارات الخاصة بهم."
      }
    ]
  },
  {
    "key": "txt_ExpandDri_767",
    "text": "Expand Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "عرض العوامل"
      }
    ]
  },
  {
    "key": "txt_Discovert_637",
    "text": "Discover the survey's highlights and insights in a summarized analysis! Compare the %difference between the overall score, eNPS, and drivers & statements to demographics and custom criteria by selecting from the breakout dropdown.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف أبرز نقاط التحليلات المُفصّلة في تحليل مُلخص! قارن الفرق في النسب بين درجة الاندماج الوظيفي الكلية وصافي نقاط ترويج الموظفين وعوامل الاندماج والعبارات بالنسبة إلى الجوانب الديموغرافية والمعايير المخصصة وذلك من خلال من خلال الاختيار من القائمة المنسدلة."
      }
    ]
  },
  {
    "key": "txt_Unlockthe_743",
    "text": "Unlock the power of your preferences! Revisit the criteria you chose in the survey setup and experience an analysis tailored to your specifications! <br><br>Hint: The system is interactive. Click on the chart legend to turn on/off options and have a clearer view of the results.<br/><img class=\"mt-2\" src=\"assets/img/tours/wb-engagement.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف قوة تحليلات زينثر مع اختياراتك في إعدادات الاستبيان! استمتع بتجربة مصممة ومفصّلة وفق مواصفاتك! <br><br>تلميح: النظام تفاعلي. انقر على مفتاح الرسم البياني لتفعيل/إيقاف الخيارات والحصول على رؤية أوضح للنتائج.<br/><img class=\"mt-2\" src=\"assets/img/tours/wb-engagement.gif\" />"
      }
    ]
  },
  {
    "key": "txt_Theemploy_828",
    "text": "The employee net promoter score “how likely your employees will recommend your company to their friends/relatives” is recommended to be above 30% as per the leading practice.",
    "translations": [
      {
        "language": "AR",
        "text": "من الموصى أن تكون درجة صافي نقاط ترويج الموظفين \"ما مدى احتمالية الموظفين بتوصية الشركة  لصديق أو قريب\" فوق ال 30% للتوافق مع الممارسات الرائدة."
      }
    ]
  },
  {
    "key": "txt_eNPS_567",
    "text": "eNPS",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين"
      }
    ]
  },
  {
    "key": "txt_Discoverh_474",
    "text": "Discover how your engagement scores stack up against the competition – are you leading the way? Click here and find out how your scores are compared to MENA Benchmark and Top Performers!",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفوق نتائج الاندماج الوظيفي الخاصة بك بالمقارنة مع الشركات المنافسة – هل تُعد شركتكم الرائدة في الاندماج الوظيفي؟ انقر هنا واكتشف كيف يتم مقارنة نتائجك مع معايير الشرق الأوسط والأداء الأفضل!"
      }
    ]
  },
  {
    "key": "txt_Clickhere_475",
    "text": "Click here to download the report and turn on the sections you want to include.<br><br> Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتحميل التقرير واختر الأقسام التي ترغب في تضمينها في التقرير.<br><br>تلميح: قم بالوصول بسهولة إلى تقارير الوحدات التنظيمية المفصلة عن طريق اختيار نوع الوحدة التنظيمية في قائمة <b>\"تصفح عن طريق\"</b> وابدأ بالتحميل الآن! - متوفر في صيغة PDF. "
      }
    ]
  },
  {
    "key": "txt_dowload_7867",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      }
    ]
  },
  {
    "key": "txt_Clickhere_458",
    "text": "Click here to filter the analysis by choosing the entity. <br><br>Note: The number of respondents must be at least 3 to view the analysis of each entity.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية. <br><br> ملحوظة: يجب ألا يقل عدد المستجيبين عن 3 لعرض تحليلات كل وحدة تنظيمية مختارة."
      }
    ]
  },
  {
    "key": "txt_TheOv_656",
    "text": "The <b>“Overview”</b> page shows the employee engagement scores, detailed comparison and other valuable insights.",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة <b>\"نظرة عامة\"</b> تعرض نتائج الاندماج الوظيفي وتحليل القراءات والبيانات بشكل مفصّل ومعمّق."
      }
    ]
  },
  {
    "key": "txt_Clickonb_378",
    "text": "Click on <b>“Close Now”</b> to close the survey. <br><br>Note: You cannot add or delete respondents once you close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"أغلق الآن\"</b> لإغلاق الاستبيان. <br><br>ملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين"
      }
    ]
  },
  {
    "key": "txt_CloseSurv_287",
    "text": "Close Survey",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Unlocksea_176",
    "text": "Unlock seamless employee engagement – Reach respondents, even without email, with our general survey link. Click here and start sharing!",
    "translations": [
      {
        "language": "AR",
        "text": "جميع المستجيبون يستطيعون المشاركة – يمكنك الوصول إلى المستجيبين حتى بدون بريد إلكتروني باستخدام رابط الاستبيان. انقر هنا وابدأ بالمشاركة!"
      }
    ]
  },
  {
    "key": "txt_Diditgobe_281",
    "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates.",
    "translations": [
      {
        "language": "AR",
        "text": "هل تجاوزت تاريخ الإكمال؟ انقر هنا لتحديث تاريخ الإكمال وتواريخ التذكيرالتلقائي."
      }
    ]
  },
  {
    "key": "txt_UpdateDat_196",
    "text": "Update Dates",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التواريخ"
      }
    ]
  },
  {
    "key": "txt_Youcandow_474",
    "text": "You can download the list of respondents with their survey status! <br><br>Note: Available in Excel format.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المستجيبين مع حالة الاستبيان الخاص بهم! <br><br>  ملحوظة: متوفر في صيغة Excel."
      }
    ]
  },
  {
    "key": "txt_ExportRes_503",
    "text": "Export Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المستجيبون"
      }
    ]
  },
  {
    "key": "txt_Forgottoa_237",
    "text": "Forgot to add a respondent? No worries, click here and start adding.",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مستجيب؟ لا تقلق انقر هنا وابدأ بالإضافة."
      }
    ]
  },
  {
    "key": "txt_Sendmanua_412",
    "text": "Send manual reminders or delete the respondent.",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات يدوية أو قم بحذف المستجيب."
      }
    ]
  },
  {
    "key": "txt_MoreActio_483",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      }
    ]
  },
  {
    "key": "txt_Trackyour_923",
    "text": "Track your respondents' progress! <br><br> Note: We recommend a 65% - 75% response rate for a better analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين. <br><br>ملحوظة: نوصي بمعدل استجابة يترواح بين 65% - 75% لتحليلات أفضل."
      }
    ]
  },
  {
    "key": "txt_AddRespon_499",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      }
    ]
  },
  {
    "key": "txt_CustomDri_240",
    "text": "Custom Driver",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل مخصصة"
      }
    ]
  },
  {
    "key": "txt_OptionalD_391",
    "text": "Optional Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل اختيارية"
      }
    ]
  },
  {
    "key": "txt_IMPACTDri_650",
    "text": "IMPACT Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل IMPACT"
      }
    ]
  },
  {
    "key": "txt_Translate_878",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنياية عنك!"
      }
    ]
  },
  {
    "key": "txt_Translati_542",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "txt_SurveyDet_244",
    "text": "Survey Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Clickhere_358",
    "text": "Click here to delete a draft survey. <br><br> Note: only draft surveys can be deleted",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لحذف الاستبيانات المسودة. <br><br>ملحوظة: يمكن حذف استبيانات المسودة فقط"
      }
    ]
  },
  {
    "key": "txt_DeleteSur_505",
    "text": "Delete Survey",
    "translations": [
      {
        "language": "AR",
        "text": "حذف استبيان"
      }
    ]
  },
  {
    "key": "txt_Pointthem_773",
    "text": "Point the mouse over the survey list to open draft, live, and closed surveys.",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة الاستبيانات لفتح الاستبيانات بحالة المسودة، المباشرة، والمنتهية."
      }
    ]
  },
  {
    "key": "txt_OpenSurve_493",
    "text": "Open Survey",
    "translations": [
      {
        "language": "AR",
        "text": "فتح استبيان"
      }
    ]
  },
  {
    "key": "txt_Tocreatea_252",
    "text": "To create a new survey, click on <b>“New Setup”</b>.",
    "translations": [
      {
        "language": "AR",
        "text": "انقرعلى <b>\"إعداد جديد\"</b> لإنشاء استبيان جديد."
      }
    ]
  },
  {
    "key": "txt_Onceyouse_662",
    "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the survey invitations and go live! ",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد <b>\"دعوة لاستكمال الاستبيان\"</b>، انقر هنا لإرسال دعوات الاستبيان وإطلاق الاستبيان مباشرةً!"
      }
    ]
  },
  {
    "key": "txt_Customize_926",
    "text": "Customize the invitation email template or use the default template generated by Zenithr.<br/><br/> Hint: Do not erase the survey link. If erased, click on the default button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة او استخدم النموذج الأساسي المُعرف من  زينثر.<br><br>ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على<b> \"النموذج الأساسي\"</b>."
      }
    ]
  },
  {
    "key": "txt_Invitatio_820",
    "text": "Invitation Template",
    "translations": [
      {
        "language": "AR",
        "text": "قالب الدعوة"
      }
    ]
  },
  {
    "key": "txt_InInvitat_797",
    "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the Respondents section through email.",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"دعوة لاستكمال الاستبيان\" </b>تقوم بدعوة المستجيبين المضافين في خطوة <b>\"المستجيبون\" </b>من خلال البريد الإلكتروني."
      }
    ]
  },
  {
    "key": "txt_Onceyouse_130",
    "text": "One more step, and you’re ready to go!",
    "translations": [
      {
        "language": "AR",
        "text": "تبقى خطوة أخرى وتنتهي من إعداد الاستبيان!"
      }
    ]
  },
  {
    "key": "txt_Customize_967",
    "text": "Customize the reminder template or use the default template generated by Zenithr. <br/><br/>Hint: Do not erase the survey link. If erased, click on the default button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص قالب التذكير أو استخدم القالب الافتراضي الذي تم إنشاؤه بواسطة زينثر. <br/><br/>ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على <b>\"النموذج الأساسي\"</b>."
      }
    ]
  },
  {
    "key": "txt_Addautoma_958",
    "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف 3 تذكيرات تلقائية كحد أقصى في تواريخ محددة لإرسال تذكيرات تلقائية للمستجيبين الذين لم يستكملوا الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Automated_343",
    "text": "Automated Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "التذكيرات التلقائية"
      }
    ]
  },
  {
    "key": "txt_Setthecom_304",
    "text": "Set the completion date of your survey! <br><br>Hint: You can extend the completion date after you send the invitations!",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ إكمال الاستبيان! <br><br> تلميح: يمكنك تمديد تاريخ الإكمال بعد إرسال الدعوات!"
      }
    ]
  },
  {
    "key": "txt_SurveyDea_560",
    "text": "Survey Deadline",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ إكمال الاستبيان"
      }
    ]
  },
  {
    "key": "txt_InTimefra_761",
    "text": "In <b>“Timeframe”</b>, you set the survey deadline in addition to automated reminders.",
    "translations": [
      {
        "language": "AR",
        "text": "في<b> \"المدة الزمنية\"</b>، يمكنك تحديد الإطار الزمني للاستبيان بالإضافة إلى تذكيرات تلقائية لاستكمال الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Onceyouse_437",
    "text": "You are ready to go to the next step!",
    "translations": [
      {
        "language": "AR",
        "text": "أنت جاهز للانتقال إلى الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_Tostartad_934",
    "text": "To start adding respondents, click on <b>“Add Respondent”</b>.<br/><br/> Hint: We recommend adding by using Excel to save time and simplify your experience!",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على <b>\"إضافة مستجيب\"</b>. <br/><br/>تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك!"
      }
    ]
  },
  {
    "key": "txt_InRespond_392",
    "text": "In <b>“Respondents”</b> page, you add the Respondents you want to invite to the survey manually, or by Excel file, or from your respondent pool.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"المستجيبون\"</b>، يمكنك إضافة المستجيبين الذين ترغب في دعوتهم للاستبيان يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      }
    ]
  },
  {
    "key": "txt_Onceyouse_817",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_InAnalyti_544",
    "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis. <br/><br/>Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!<br/><img class=\"mt-2\"  src=\"assets/img/tours/criteria.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"المعايير التحليلية\"</b>، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة. <br/><br/>تلميح: كلما قمت باختيار معايير أكثر كلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!<br/><img class=\"mt-2\"  src=\"assets/img/tours/criteria.gif\" />"
      }
    ]
  },
  {
    "key": "txt_Onceyouse_772",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_Nextstep!_559",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_ClickonPr_168",
    "text": "Click on <b>“Preview Survey”</b> to view your Survey's selected drivers and statements! <br/><br/>Note: Available in PDF format. To download click “📁”.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"عرض الاستبيان\" </b>لعرض العوامل والعبارات المختارة في الاستبيان الخاص بك!<br/><br/>ملحوظة: متوفر بصيغة PDF. للتحميل انقر على \"📁\""
      }
    ]
  },
  {
    "key": "txt_ClickonNe_965",
    "text": "Click on New Statement to add a new custom statement with the agreement scale type of question.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على \"إنشاء بيان جديد\" لإضافة بيان مخصص جديد بنوع مقياس الاتفاق في السؤال."
      }
    ]
  },
  {
    "key": "txt_ClickonNe_722",
    "text": "If you want to add more statements, first click <b>“New Custom Driver”</b>.<br/><br/> Note: Total drivers covering IMPACT, Optional and Custom Drivers shall not exceed 8 Drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة المزيد من العبارات، انقر على <b>\"عامل مخصص جديد\"</b>.<br/><br/>ملحوظة: يجب ألا يتجاوز إجمالي عوامل IMPACT  والعوامل الاختيارية والمخصصة عن 8 عوامل."
      }
    ]
  },
  {
    "key": "txt_Selectfro_541",
    "text": "Select additional drivers from the <b>Optional Drivers</b> (if needed).<br/><br/> Hint: Following the latest HR trends in the market, the diversity and inclusion driver has been commonly selected!",
    "translations": [
      {
        "language": "AR",
        "text": "قم باختيارعوامل إضافية من العوامل الاختيارية (إن لزم الأمر).<br/><br/>تلميح: استنادًا إلى أحدث اتجاهات إدارة الموارد البشرية في السوق، فإن عامل التنوع والشمول قد تم اختياره بشكل شائع!"
      }
    ]
  },
  {
    "key": "txt_Usetheful_133",
    "text": "<div class=\"flex flex-row gap-2\"><h5>Maximize your experience with the full <b>IMPACT</b>, or tailor it to your needs by selecting a minimum of 4 drivers.</h5> <img src=\"assets/img/tours/impact-en.png\">  </div>",
    "translations": [
      {
        "language": "AR",
        "text": "<div class=\"flex flex-row gap-2\"><h5> حقق أقصى استفادة من تجربة الاندماج الوظيفي مع نموذج IMPACT الكامل، أو قم بتخصيصه ليناسب احتياجاتك عن طريق اختيار 4 عوامل على الأقل.</h5><img src=\"assets/img/tours/impact-ar.png\"> </div>"
      }
    ]
  },
  {
    "key": "txt_Fillinyou_620",
    "text": "Fill in your<b> \"Survey Name\"</b>.<br/> You can add a description as well.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة اسم الاستبيان. <br/>يمكنك أيضاً إضافة وصف للاستبيان."
      }
    ]
  },
  {
    "key": "txt_survey_info_desc",
    "text": "In \"<b>Survey Information</b>\", you specify the main elements, including survey name and drivers & statements!",
    "translations": [
      {
        "language": "AR",
        "text": "في \"<b>معلومات الاستبيان</b>\" تُحدد العناصر الرئيسية، بما في ذلك اسم الاستبيان والعوامل والعبارات."
      }
    ]
  },
  {
    "key": "txtNoSentiment",
    "text": "No Sentiment",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      }
    ]
  },
  {
    "key": "txtCommentAiChartTitle",
    "text": "Comments’ Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات التعليقات"
      }
    ]
  },
  {
    "key": "Applied Filters",
    "text": "Applied Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر المُطبَّقة"
      }
    ]
  },
  {
    "key": "Performance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      }
    ]
  },
  {
    "key": "Tenure",
    "text": "Tenure",
    "translations": [
      {
        "language": "AR",
        "text": "الفئة"
      }
    ]
  },
  {
    "key": "HR Metrics",
    "text": "HR Metrics",
    "translations": [
      {
        "language": "AR",
        "text": "مقاييس الموارد البشرية"
      }
    ]
  },
  {
    "key": "Demographics",
    "text": "Demographics",
    "translations": [
      {
        "language": "AR",
        "text": "التركيبة السكانية"
      }
    ]
  },
  {
    "key": "Extra Criteria",
    "text": "Extra Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير اضافية"
      }
    ]
  },
  {
    "key": "Business Level",
    "text": "Business Level\t",
    "translations": [
      {
        "language": "AR",
        "text": "مستوى العمل"
      }
    ]
  },
  {
    "key": "JobGrade",
    "text": "Job Grades",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجات الوظيفية"
      }
    ]
  },
  {
    "key": "BandLevel",
    "text": "Band Levels",
    "translations": [
      {
        "language": "AR",
        "text": "المستويات الوظيفية"
      }
    ]
  },
  {
    "key": "PerformanceRate",
    "text": "Performance Rates",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات الأداء"
      }
    ]
  },
  {
    "key": "TenureGroup",
    "text": "Tenure Groups",
    "translations": [
      {
        "language": "AR",
        "text": "فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "AgeGroup",
    "text": "Age Groups",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      }
    ]
  },
  {
    "key": "Generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      }
    ]
  },
  {
    "key": "Gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      }
    ]
  },
  {
    "key": "Nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      }
    ]
  },
  {
    "key": "txtWellbeingHIGHLY_DISENGAGEDDriverRecommendationDesc_4",
    "text": "Train superiors to identify their team member’s strengths and abilities. Assign tasks to employees based on their skills, interests, and strengths to enhance well-being and reduce the chances of stress or burnout. Keep employees engaged by providing interesting stretch assignments to help them grow professionally.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتدريب الرؤساء على تحديد نقاط القوة والقدرات لأعضاء فريقهم. وقم بتعيين المهام للموظفين بناءً على مهاراتهم واهتماماتهم ونقاط قوتهم لتعزيز مفهوم الرفاهية وتقليل فرص الإجهاد أو الإرهاق. وحافظ على مشاركة الموظفين من خلال توفير مهام ممتدة ممتعة لمساعدتهم على تطوير مهاراتهم المهنية."
      }
    ]
  },
  {
    "key": "txtWellbeingHIGHLY_DISENGAGEDDriverRecommendationDesc_3",
    "text": "Encourage superiors to communicate with their team in a positive, supportive, and empathetic manner to help employees feel heard, valued, and supported. Encourage superiors to foster a positive workplace culture that values respect, trust, and open communication to ensure employees feel safe and optimistic at work.",
    "translations": [
      {
        "language": "AR",
        "text": "شجع الرؤساء على التواصل مع فريقهم بطريقة إيجابية وداعمة وعاطفية لمساعدة الموظفين على الشعور بأنهم مسموعون، وقديرون، ومدعومون. وشجع الرؤساء على تعزيز ثقافة مكان العمل الإيجابية التي تقدر الاحترام والثقة والتواصل المفتوح لضمان شعور الموظفين بالأمان والتفاؤل في العمل."
      }
    ]
  },
  {
    "key": "txtWellbeingHIGHLY_DISENGAGEDDriverRecommendationDesc_2",
    "text": "Help employees manage stress and maintain good mental health through employee assistance programs, counseling services, and mental health days. To pinpoint the precise sources of stress at work, conduct routine surveys or employee focus groups. Teach employees time management skills, relaxation techniques, and mindfulness exercises to manage stress.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بمساعدة الموظفين على كيفية التعامل مع الإجهاد والحفاظ على صحة نفسية جيدة من خلال برامج مساعدة الموظفين، وخدمات تقديم المشورة، وأيام الصحة النفسية. ولغرض تحديد مصادر التوتر في العمل بدقة، قم بإجراء استبيانات دورية أو بعمل مجموعات تركيز للموظفين. وقم بتدريب الموظفين على مهارات إدارة الوقت وتقنيات الاسترخاء وتمارين التركيز الذهني للتعامل مع التوتر."
      }
    ]
  },
  {
    "key": "txtWellbeingHIGHLY_DISENGAGEDDriverRecommendationDesc_1",
    "text": "Allow employees to work flexibly and remotely to improve work-life balance. Try to help employees to disconnect from work when on vacation and after working hours by discouraging others from reaching out to them unless it is highly urgent. Encourage employees to take frequent breaks and relax during off hours to reduce burnout and improve work-life balance.",
    "translations": [
      {
        "language": "AR",
        "text": ")  اسمح للموظفين بالعمل بمرونة وعن بعد لتحسين التوازن بين العمل والحياة. وحاول مساعدة الموظفين على قطع التواصل بالعمل أثناء قيامهم بإجازة وبعد ساعات العمل عن طريق إبلاغ الآخرين بعدم التواصل معهم ما لم يكن ذلك عاجلاً للغاية. وقم بتشجيع الموظفين على أخذ فترات راحة متكررة والاسترخاء خلال ساعات الراحة لتقليل الإرهاق وتعزيز التوازن بين العمل والحياة."
      }
    ]
  },
  {
    "key": "txtDiversity&InclusionHIGHLY_DISENGAGEDDriverRecommendationDesc_4",
    "text": "Establish a structured feedback mechanism that allows employees to provide input and ideas. This can include anonymous suggestion boxes, regular surveys, or dedicated feedback sessions. Actively listen to the feedback received, address concerns, and communicate the responses taken. This empowers employees to have a voice in shaping the organization and demonstrates that their opinions are valued.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء آلية منظمة لاستقبال ملاحظات الموظفين بحيث تسمح لهم بتقديم آرائهم وأفكارهم. ويمكن أن يشمل ذلك إنشاء صناديق اقتراحات مجهولة المصدر أو القيام بعمل استبيانات دورية أو عقد جلسات مخصصة لإبداء الملاحظات. ومن ثم، استمع بفاعلية إلى التعليقات الواردة من الموظفين، وقم بمعالجة مخاوفهم، وأبلغهم بالإجراءات التي تم اتخاذها. وهذا من شأنه أن يمكن الموظفين من أن يكون لهم رأي في تشكيل المنشأة ويظهر أن آرائهم محل تقدير."
      }
    ]
  },
  {
    "key": "txtDiversity&InclusionHIGHLY_DISENGAGEDDriverRecommendationDesc_3",
    "text": "Foster an appreciation for different languages, communities, and religions by encouraging open dialogue, team-building activities, and inclusive communication channels in the workplace. This can be achieved through honest and respectful communication initiatives, cultural competency training, employee resource groups, inclusive policies and practices, and leadership commitment to diversity. By taking these actions, employees will feel valued and accepted, irrespective of their language, cultural, ethnic, or religious backgrounds, creating a more inclusive and harmonious work environment.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعزيز احترام اللغات والمجتمعات والأديان المختلفة من خلال تشجيع الحوار المفتوح والأنشطة التي تعزز العمل الجماعي وإنشاء قنوات اتصال شاملة في مكان العمل. ويمكن تحقيق ذلك من خلال مبادرات اتصال صادقة وجادة، والتدريب على الكفاءة الثقافية، وعلى تشكيل مجموعات الموظفين، وعلى السياسات والممارسات الشاملة، والتزام القيادة بالتنوع. ومن خلال اتخاذ هذه الإجراءات، سيشعر الموظفون بالتقدير والقبول بغض النظر عن خلفياتهم اللغوية أو الثقافية أو العرقية أو الدينية، مما يخلق بيئة عمل أكثر شمولية وانسجاما."
      }
    ]
  },
  {
    "key": "txtDiversity&InclusionHIGHLY_DISENGAGEDDriverRecommendationDesc_2",
    "text": "Integrate Diversity, Equity, and Inclusion (DE&I) principles into every stage of the recruitment process, from sourcing to onboarding. This includes diversifying sourcing channels, implementing blind screening practices, training recruiters on DE&I best practices, establishing diverse interview panels, setting measurable diversity goals, and incorporating DE&I questions and considerations into interview assessments. By doing so, the company's recruitment will foster a more inclusive and equitable work environment.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتضمين مفاهيم التنوع والمساواة والشمولية (DE&I) في كل مرحلة من مراحل عملية التوظيف، بدءًا من مرحلة تحديد موارد التوظيف وحتى مرحلة الإعداد والتهيئة. وهذا يشمل تنويع قنوات موارد التوظيف، وتطبيق ممارسات الفرز العشوائي، وتدريب القائمين بالتوظيف على اتباع أفضل سبل الممارسات في مجال التنوع والمساواة والشمولية، وتشكيل لجان متنوعة في إجراء مقابلات التوظيف، ووضع أهداف متنوعة ملموسة، وتضمين أسئلة واعتبارات متعلقة بمفاهيم التنوع والمساواة والشمولية في تقييمات المقابلات. ومن خلال القيام بذلك، ستساهم عملية التوظيف في المنشأة في تعزيز بيئة عمل أكثر شمولية وإنصافًا."
      }
    ]
  },
  {
    "key": "txtDiversity&InclusionHIGHLY_DISENGAGEDDriverRecommendationDesc_1",
    "text": "Foster a culture of religious and cultural inclusivity by providing reasonable accommodations for employees' religious practices and observances. This includes flexible scheduling, designated prayer or meditation rooms, and sensitivity to dietary restrictions during company events.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعزيز ثقافة الشمول الديني والثقافي من خلال توفير وسائل الراحة المناسبة للموظفين لتسهيل ممارساتهم وأداء شعائرهم الدينية. ويتضمن ذلك وضع جدولة مرنة لأداء تلك الشعائر، وتجهيز غرف مخصصة للصلاة أو العبادة، ومعالجة حساسية القيود الغذائية أثناء الفعاليات التي تقوم بها المنشأة."
      }
    ]
  },
  {
    "key": "txtOwnershipHIGHLY_DISENGAGEDDriverRecommendationDesc_4",
    "text": "Create an environment where it is safe to experiment and learn from successes and failures by empowering employees to solve problems and to take ownership; instead of the manager solving their problems for them. Provide employees the chance to tackle and resolve challenges independently and foster a problem-solving mindset by encouraging employees to analyze issues, brainstorm solutions, and evaluate the potential impact of their decisions. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بخلق بيئة آمنة للتجربة والتعلم من النجاحات والفشل من خلال تمكين الموظفين من حل المشاكل وتحمل المسؤولية بدلا من قيام المدير بحل تلك المشاكل لهم. وقم بمنح الموظفين الفرصة للتعامل مع التحديات وحلها بشكل مستقل وتعزيز مفهوم حل المشاكل من خلال تشجيعهم على تحليل المشاكل وطرح الأفكار وتقييم التأثير المحتمل لقراراتهم."
      }
    ]
  },
  {
    "key": "txtOwnershipHIGHLY_DISENGAGEDDriverRecommendationDesc_3",
    "text": "Give monetary and non-monetary rewards and recognize employees for contributing to the workplace and its positive impact on the business’s outcomes. Also, share stories of how the company's products, services, or initiatives have positively impacted customers, communities, or society. Highlight how employees' efforts have contributed to these success stories. This helps employees connect their work to meaningful outcomes, fostering a sense of pride and purpose in their contributions.mployees for being a part of the success of the workplace. Give monetary and non-monetary rewards and ensure that employees understand that rewards are given based on the outcomes of their good work and its reflection on the business’s success. ",
    "translations": [
      {
        "language": "AR",
        "text": "امنح مكافآت نقدية وغير نقدية للموظفين، وقدر لهم مساهمتهم في مكان العمل والتأثير الإيجابي لتلك المساهمات على نتائج الأعمال. بالإضافة إلى ذلك، قم بمشاركة الموظفين بقصص عن كيفية تأثير منتجات المنشأة أو خدماتها أو مبادراتها بشكل إيجابي على العملاء أو الجمهور أو المجتمع. وقم بتسليط الضوء على كيفية مساهمة جهود الموظفين في هذه القصص الناجحة، حيث أن ذلك يساعد الموظفين على ربط عملهم بنتائج ذات مغزى، وتعزيز الشعور بالفخر والهدف من مساهماتهم."
      }
    ]
  },
  {
    "key": "txtOwnershipHIGHLY_DISENGAGEDDriverRecommendationDesc_2",
    "text": "Actively prioritize and implement feasible ideas that have the potential to enhance operations, productivity, or customer satisfaction. Involve employees in the implementation process to further engage them and provide ownership over their ideas. When implementing ideas, ensure that employees are credited for their contributions. Officially recognize and celebrate the individuals or teams whose ideas have been implemented to further engagement and participation.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد الأولويات بشكل فعال وتنفيذ الأفكار المجدية التي لديها القدرة على تعزيز العمليات، والإنتاجية، أو إرضاء العملاء. وقم بإشراك الموظفين في عملية التنفيذ لإشراكهم بشكل أكبر وفاعل، وتوفير ملكية لأفكارهم. وتأكد عند تنفيذ تلك الأفكار من تقدير الموظفين لمساهماتهم. وقم رسميا بتقدير الأفراد أو الفرق الذين تم تنفيذ أفكارهم، والاحتفال بهم من أجل تعزيز مشاركاتهم ومساهماتهم."
      }
    ]
  },
  {
    "key": "txtOwnershipHIGHLY_DISENGAGEDDriverRecommendationDesc_1",
    "text": "Ensure employees have the resources, tools, and support to meet their goals and expectations. Identify any training or development needs and provide opportunities for growth to help employees succeed. This demonstrates a commitment to their professional development and reinforces accountability. When expectations are unmet, addressing the issue promptly and firmly is essential. Engage in open and honest conversations with employees about the gaps in performance or outcomes. Communicate the impact of these shortcomings on the team and organization, and work collaboratively to develop an improvement plan.",
    "translations": [
      {
        "language": "AR",
        "text": "تأكد من حصول الموظفين على الموارد والأدوات والدعم لتحقيق أهدافهم وتوقعاتهم. وقم بتحديد أي احتياجات تدريبية أو تطويرية ووفر فرصًا للنمو لمساعدة الموظفين على النجاح. وهذا يدل على مدى التزامهم بتطوير أنفسهم مهنيا ويعزز المساءلة لديهم. وفي حال عدم تحقق التوقعات، فإنه يصبح من الضروري معالجة المشكلة بسرعة وبحزم. وقم بإجراء محادثات مفتوحة وصادقة مع الموظفين حول الفجوات في الأداء أو النتائج، وأبلغهم عن مدى تأثير هذه الفجوات على الفريق والمنشأة، واعمل بشكل تعاوني لوضع خطة لتحسين ذلك الأداء."
      }
    ]
  },
  {
    "key": "txtTransparent&ClarityHIGHLY_DISENGAGEDDriverRecommendationDesc_4",
    "text": "Recognize and appreciate employees who ask insightful and thought-provoking questions. This helps create a culture that values curiosity and encourages others to follow suit. When employees ask questions, ensure they receive timely and transparent answers. Even if an immediate response is not possible, it is good practice to notify that their questions have been received, and a response will be provided as soon as possible.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرف على الموظفين الذين يطرحون أسئلة ثاقبة ومثيرة للاهتمام، وأشعرهم بمدى تقديرك لذلك، حيث أن ذلك يساعد في خلق ثقافة تقدر الفضول وتشجع الآخرين على أن يحذو حذوها. وعندما يطرح الموظفون أسئلة، تأكد من حصولهم على إجابات شفافة وفورية. وحتى إذا لم يكن الرد الفوري ممكنًا، فمن الممارسات الجيدة إخطارهم بتلقي أسئلتهم، وأنه سيتم تقديم الرد عليها في أقرب وقت ممكن."
      }
    ]
  },
  {
    "key": "txtTransparent&ClarityHIGHLY_DISENGAGEDDriverRecommendationDesc_3",
    "text": "Leverage technology platforms to regularly update this platform with relevant information, such as company news, key milestones, and progress on goals and objectives. Encourage employees to actively participate by sharing their insights, best practices, and feedback through the platform. This can include project management tools, intranet portals, or dedicated communication platforms. These efforts enhance transparency, improve collaboration, and foster a sense of shared purpose and engagement within the organization.",
    "translations": [
      {
        "language": "AR",
        "text": "استفد من منصات التكنولوجيا لتحديث هذه المنصة بانتظام بالمعلومات ذات الصلة، مثل الأخبار المتعلقة بالمنشأة والأحداث الرئيسية والتقدم المحرز في الأهداف والغايات. وقم بتشجيع الموظفين على المشاركة بفاعلية من خلال مشاركة رؤاهم وأفضل تجاربهم وملاحظاتهم من خلال المنصة. ويمكن أن يشمل ذلك أدوات إدارة المشروع أو بوابات الإنترانت أو منصات التواصل المخصصة لذلك. وتعمل هذه الجهود على تعزيز الشفافية وتحسين التعاون وتعزيز الشعور بالهدف المشترك والمشاركة ضمن المنشأة."
      }
    ]
  },
  {
    "key": "txtTransparent&ClarityHIGHLY_DISENGAGEDDriverRecommendationDesc_2",
    "text": "Document the agreed-upon goals and objectives and share them with each employee. This serves as a reference point for clarity and helps employees track their progress over time. Ensure that the employee roles and responsibilities are well defined, and the goals are periodically reviewed to assess progress, provide feedback, and make necessary adjustments. This allows for a dynamic approach that adapts to changing circumstances and priorities.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتوثيق الأهداف والغايات المتفق عليها ومشاركتها مع كل موظف، حيث أن ذلك سيكون بمثابة علامة مرجعية لمدى وضوح تلك الأهداف، ويساعد الموظفين على تتبع تقدمهم بمرور الوقت. وقم بالتأكد من أن أدوار ومسؤوليات الموظف محددة بشكل واضح، وأن الأهداف تتم مراجعتها بشكل دوري لتقييم مدى التقدم، وقم بتقديم الملاحظات، وإجراء التعديلات اللازمة عليها، حيث أن هذا يسمح باتباع نهج ديناميكي يتكيف مع الظروف والأولويات المتغيرة."
      }
    ]
  },
  {
    "key": "txtTransparent&ClarityHIGHLY_DISENGAGEDDriverRecommendationDesc_1",
    "text": "Communicate the overall goals and objectives of the organization. Explain how each employee's work contributes to these goals, emphasizing the importance of their role within the bigger picture. Encourage open discussions about successes and failures related to goals and objectives. This may help create a safe space where employees can openly share their experiences, lessons learned, and best practices to gain trust, promote transparency, and improve workplace engagement and performance. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بالتواصل مع الموظفين بخصوص الأهداف والغايات العامة للمنشأة. اشرح لهم كيفية مساهمة عمل كل موظف منهم في تحقيق هذه الأهداف، مع التأكيد لهم على أهمية دورهم في تشكيل الصورة الأشمل للمنشأة. قم بتعزيز المناقشات المفتوحة حول النجاحات والإخفاقات المتعلقة بالأهداف والغايات. حيث أن ذلك قد يساعد في خلق مساحة آمنة حيث يمكن للموظفين على نحو منفتح مشاركة تجاربهم والدروس المستفادة منها واتباع أفضل الممارسات من أجل اكتساب الثقة وتعزيز الشفافية وتحسين المشاركة والأداء في مكان العمل."
      }
    ]
  },
  {
    "key": "txt_workplace_Wellbeing",
    "text": "Workplace Well-Being",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtNewQuestion",
    "text": "New question",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "preparingComments",
    "text": "Preparing Comments",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير التعليقات"
      }
    ]
  },
  {
    "key": "downloadComments",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليقات"
      }
    ]
  },
  {
    "key": "txtPreparingHeatmap",
    "text": "Preparing Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير المخطط"
      }
    ]
  },
  {
    "key": "txtDownloadHeatmap",
    "text": "Download Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المخطط"
      }
    ]
  },
  {
    "key": "txt_preview_sample_desc",
    "text": "Preview Sample",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      }
    ]
  },
  {
    "key": "txt_DriverCom_666",
    "text": "Driver Comments’ Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل تعليقات السائق"
      }
    ]
  },
  {
    "key": "txt_SelectaTo_226",
    "text": "Select a Topic from the list below:",
    "translations": [
      {
        "language": "AR",
        "text": "اختر موضوعًا من القائمة أدناه:"
      }
    ]
  },
  {
    "key": "txt_SelectTop_124",
    "text": "Select Topic",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الموضوع"
      }
    ]
  },
  {
    "key": "txt_AddTopic_764",
    "text": "Add Topic",
    "translations": [
      {
        "language": "AR",
        "text": "أضف الموضوع"
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "التوصييات"
      }
    ]
  },
  {
    "key": "txt_RemoveFil_850",
    "text": "Remove Filter",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtDriver/Question",
    "text": "DRIVER / STATEMENT",
    "translations": [
      {
        "language": "AR",
        "text": "عامل / عبارة"
      }
    ]
  },
  {
    "key": "txtRespondentsBy",
    "text": "Respondents By",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      }
    ]
  },
  {
    "key": "txt_Responden_728",
    "text": "Respondents Status Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات حالة المستجيبون"
      }
    ]
  },
  {
    "key": "txt_Initiativ_338",
    "text": "Initiatives & Training Programs:",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات وبرامج التدريب "
      }
    ]
  },
  {
    "key": "txtEngagementScaleBy",
    "text": "Employee Engagement Index by",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر الاندماج الوظيفي حسب"
      }
    ]
  },
  {
    "key": "txtDifference",
    "text": "Difference",
    "translations": [
      {
        "language": "AR",
        "text": "الفرق"
      }
    ]
  },
  {
    "key": "txtBenchmark",
    "text": "Benchmark",
    "translations": [
      {
        "language": "AR",
        "text": "المعيار"
      }
    ]
  },
  {
    "key": "txt_ResultsIn_891",
    "text": "Results Indication",
    "translations": [
      {
        "language": "AR",
        "text": "دلالة النتائج"
      }
    ]
  },
  {
    "key": "txtFactorsofWorkplaceEngagementDesc",
    "text": "The below indicates the scores for each of the [Drivers Count] factors of Workplace Employee Engagement at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح التالي النتيجة لكل من ال [Drivers Count] عوامل اندماج الموظفين من مكان العمل في [Company Name]:"
      }
    ]
  },
  {
    "key": "txtENPSScore",
    "text": "Employee Net Promoter Score (eNPS)",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين (eNPS)"
      }
    ]
  },
  {
    "key": "txtENPSDesc",
    "text": "eNPS measures employee loyalty by identifying them as promoters, passives, and detractors of your brand.",
    "translations": [
      {
        "language": "AR",
        "text": "eNPS يقيس ولاء الموظفين من خلال تحديدهم كمروجين أو سلبيين (غير مروجين) أو منتقدين لعلامتك التجارية."
      }
    ]
  },
  {
    "key": "txtDefinitions",
    "text": "Definitions",
    "translations": [
      {
        "language": "AR",
        "text": "التعريفات"
      }
    ]
  },
  {
    "key": "txtDetractorsDef",
    "text": "the employees who select a score between 0 – 6 are unhappy and disengaged employees who won't recommend your business as a good workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 0 إلى 6 لأنهم غير راضين عن العمل أو الشركة."
      }
    ]
  },
  {
    "key": "txtPassivesDef",
    "text": "the employees who select a score of 7 or 8; are neutral, maybe content, or even not fully dedicated to the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 7 إلى 8 لأنهم معجبون بالعمل أو الشركة ولكنهم غير راضين بشكل كافٍ للتوصية بها للآخرين."
      }
    ]
  },
  {
    "key": "txtPromotersDef",
    "text": "the employees who select a score of 9 or 10; are positive, motivated, and satisfied people.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 9 إلى 10 وهم المروجون والموظفون الأوفياء."
      }
    ]
  },
  {
    "key": "txtDriverScore",
    "text": "Drivers’ Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العوامل"
      }
    ]
  },
  {
    "key": "txtAnalysisSection",
    "text": "Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات"
      }
    ]
  },
  {
    "key": "txt_Share_survey",
    "text": "Share Survey",
    "translations": [
      {
        "language": "AR",
        "text": "شارك الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Share",
    "text": "Share",
    "translations": [
      {
        "language": "AR",
        "text": "شارك"
      }
    ]
  },
  {
    "key": "txt_NewCustom_633",
    "text": "New Custom Driver",
    "translations": [
      {
        "language": "AR",
        "text": "عامل مخصص جديد"
      }
    ]
  },
  {
    "key": "txt_Selectupt_460",
    "text": "Select up to 8 Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "حدد ما يصل إلى 8 عوامل"
      }
    ]
  },
  {
    "key": "txt_NewStatem_806",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_Addupto4s_600",
    "text": "Add up to 4 statements",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ما يصل إلى 4 عبارات"
      }
    ]
  },
  {
    "key": "txt_Drivernee_172",
    "text": "Driver needs have at least one statement",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة عبارة واحدة على الأقل للعامل"
      }
    ]
  },
  {
    "key": "txt_Alldriver_618",
    "text": "All drivers can't be more than 8!",
    "translations": [
      {
        "language": "AR",
        "text": " !يجب ألا يتخطى المجموع الكلي عن 8 عوامل"
      }
    ]
  },
  {
    "key": "txt_IMPACTdri_469",
    "text": "IMPACT drivers can't be less than 4!",
    "translations": [
      {
        "language": "AR",
        "text": "لا يمكن أن تكون عوامل IMPACT أقل من 4!"
      }
    ]
  },
  {
    "key": "txt_Atleast3r_677",
    "text": "At least 3 respondents should complete the survey in order to close it",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txt_DeleteQue_565",
    "text": "Delete Statement",
    "translations": [
      {
        "language": "AR",
        "text": "حذف العبارة"
      }
    ]
  },
  {
    "key": "txt_BACKTOSUR_422",
    "text": "BACK TO SURVEYS",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع إلى قائمة الاستبيانات"
      }
    ]
  },
  {
    "key": "txt_CUSTOMDRI_800",
    "text": "CUSTOM DRIVERS",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل مخصصة"
      }
    ]
  },
  {
    "key": "txt_OPTIONALD_332",
    "text": "OPTIONAL DRIVERS",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل اختيارية"
      }
    ]
  },
  {
    "key": "txt_IMPACTDRI_535",
    "text": "IMPACT DRIVERS",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل IMPACT"
      }
    ]
  },
  {
    "key": "txt_Statement_172",
    "text": "Statements of ",
    "translations": [
      {
        "language": "AR",
        "text": "عبارات"
      }
    ]
  },
  {
    "key": "txt_Optional_587",
    "text": "Optional",
    "translations": [
      {
        "language": "AR",
        "text": "اختياري"
      }
    ]
  },
  {
    "key": "txt_Descripti_145",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "txtNoPermissonToAccess",
    "text": "Permission Required To Access This Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "مطلوب ترخيص للسماح في الدخول إلى صفحة الاندماج الموظف"
      }
    ]
  },
  {
    "key": "txtNoPermissonToAccessEntity",
    "text": "Permission Required To Access This Entity",
    "translations": [
      {
        "language": "AR",
        "text": "مطلوب ترخيص للسماح في الدخول الى الوحدة"
      }
    ]
  },
  {
    "key": "Survey List",
    "text": "Survey List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الاستبيانات"
      },
      {
        "language": "FR",
        "text": "Liste de Enquętes"
      }
    ]
  },
  {
    "key": "txtinnovation2",
    "text": "Innovation",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار"
      },
      {
        "language": "FR",
        "text": "Innovation"
      }
    ]
  },
  {
    "key": "Top Performers",
    "text": "Top Performers",
    "translations": [
      {
        "language": "AR",
        "text": "أفضل أداء"
      }
    ]
  },
  {
    "key": "Total Respondents should be at least 3 Respondents",
    "text": "Total Respondents should be at least 3 Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون مجموع عدد المستجيبين 3 على الأقل"
      }
    ]
  },
  {
    "key": "txtalert",
    "text": "Alert",
    "translations": [
      {
        "language": "AR",
        "text": "تنبيه"
      },
      {
        "language": "FR",
        "text": "Avertissement"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "FR",
        "text": "Rechercher"
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": "Email (Courrier électronique)"
      },
      {
        "language": "HI",
        "text": "ईमेल"
      },
      {
        "language": "TA",
        "text": "Email"
      },
      {
        "language": "UR",
        "text": "ای میل"
      },
      {
        "language": "BN",
        "text": "ইমেইল"
      }
    ]
  },
  {
    "key": "txt_fill_fields",
    "text": "Please, fill all required fields!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة جميع الحقول المطلوبة!"
      }
    ]
  },
  {
    "key": "txtAddStatement",
    "text": "Add Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Déclaration"
      }
    ]
  },
  {
    "key": "txtStatements",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "FR",
        "text": "Déclarations"
      }
    ]
  },
  {
    "key": "txtStatement",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "FR",
        "text": "Déclaration"
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "FR",
        "text": "Nom "
      },
      {
        "language": "HI",
        "text": "नाम"
      },
      {
        "language": "TA",
        "text": "Pangalan"
      },
      {
        "language": "UR",
        "text": "نام"
      }
    ]
  },
  {
    "key": "txtSurveyRespondentList",
    "text": "Survey Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون للاستبيان"
      },
      {
        "language": "FR",
        "text": "Liste des Répondants au Enquęte "
      }
    ]
  },
  {
    "key": "txt_employee_ID",
    "text": "Employee ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID de l'Employé"
      },
      {
        "language": "HI",
        "text": "ID"
      },
      {
        "language": "TA",
        "text": "ID"
      },
      {
        "language": "UR",
        "text": "ID"
      }
    ]
  },
  {
    "key": "txtScore",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة"
      },
      {
        "language": "FR",
        "text": "Résultat"
      }
    ]
  },
  {
    "key": "txtYear",
    "text": "Year",
    "translations": [
      {
        "language": "AR",
        "text": "السنة"
      },
      {
        "language": "FR",
        "text": "An"
      }
    ]
  },
  {
    "key": "txt_companies",
    "text": "Companies",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات"
      },
      {
        "language": "FR",
        "text": "Sociétés"
      }
    ]
  },
  {
    "key": "txtCustomizeTable",
    "text": "Customize Table",
    "translations": [
      {
        "language": "AR",
        "text": "عدِِل الجدول"
      }
    ]
  },
  {
    "key": "txtCustomize",
    "text": "Customize",
    "translations": [
      {
        "language": "AR",
        "text": "عدِِل"
      }
    ]
  },
  {
    "key": "txtApplyChanges",
    "text": "Apply Changes",
    "translations": [
      {
        "language": "AR",
        "text": "طبق التغييرات"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "FR",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_message",
    "text": "Are you sure you want to delete this survey?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا الاستبيان؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer cet enquęte?"
      }
    ]
  },
  {
    "key": "txt_respondents_pool",
    "text": "Respondent Pool",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة المستجيبون"
      },
      {
        "language": "FR",
        "text": "Réserve des Répondants"
      }
    ]
  },
  {
    "key": "txt_new_respondent",
    "text": "New Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": "Nouveau Répondant"
      }
    ]
  },
  {
    "key": "txtComparison",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة"
      }
    ]
  },
  {
    "key": "txtPromoters",
    "text": "Promoters",
    "translations": [
      {
        "language": "AR",
        "text": "المروجون"
      }
    ]
  },
  {
    "key": "txtPassives",
    "text": "Passives",
    "translations": [
      {
        "language": "AR",
        "text": "المحايدون"
      }
    ]
  },
  {
    "key": "txtDetractors",
    "text": "Detractors",
    "translations": [
      {
        "language": "AR",
        "text": "المنتقدون"
      }
    ]
  },
  {
    "key": "txtBenchmarks",
    "text": "Benchmarks",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير"
      }
    ]
  },
  {
    "key": "txtGlobal",
    "text": "MENA",
    "translations": [
      {
        "language": "AR",
        "text": "الشرق الأوسط"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Selected Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة"
      }
    ]
  },
  {
    "key": "txt_resp_by_generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      }
    ]
  },
  {
    "key": "txt_resp_by_age_group",
    "text": "Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      }
    ]
  },
  {
    "key": "txt_resp_by_tenure_group",
    "text": "Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View By",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح عن طريق"
      }
    ]
  },
  {
    "key": "txtRespbygender",
    "text": " Gender",
    "translations": [
      {
        "language": "AR",
        "text": " الجنس"
      },
      {
        "language": "FR",
        "text": " Sexe"
      },
      {
        "language": "HI",
        "text": "लिंग"
      },
      {
        "language": "TA",
        "text": "Kasarian"
      },
      {
        "language": "UR",
        "text": "جنس"
      },
      {
        "language": "BN",
        "text": "লিঙ্গ"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by ",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب "
      }
    ]
  },
  {
    "key": "txtRespbynationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      },
      {
        "language": "FR",
        "text": "Répondants par Nationalité"
      }
    ]
  },
  {
    "key": "txtExtraDriver",
    "text": "Extra Driver",
    "translations": [
      {
        "language": "AR",
        "text": "عامل الاندماج الإضافي"
      }
    ]
  },
  {
    "key": "txtQ",
    "text": "Q",
    "translations": [
      {
        "language": "AR",
        "text": "س"
      },
      {
        "language": "FR",
        "text": "Q"
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      },
      {
        "language": "FR",
        "text": "Retour"
      },
      {
        "language": "BN",
        "text": "পূর্ববর্তী"
      }
    ]
  },
  {
    "key": "HIGHLY_DISENGAGED",
    "text": "Extremely&nbsp;Disengaged",
    "translations": [
      {
        "language": "AR",
        "text": "غير&nbsp;مندمج&nbsp;إطلاقًا"
      },
      {
        "language": "FR",
        "text": "Extremely Disengaged"
      }
    ]
  },
  {
    "key": "HIGHLY_DISENGAGEDchart",
    "text": "Extremely Disengaged",
    "translations": [
      {
        "language": "AR",
        "text": "غير مندمج إطلاقًا"
      },
      {
        "language": "FR",
        "text": "Extremely Disengaged"
      }
    ]
  },
  {
    "key": "DISENGAGED",
    "text": "Disengaged",
    "translations": [
      {
        "language": "AR",
        "text": "غير&nbsp;مندمج"
      },
      {
        "language": "FR",
        "text": "Disengaged"
      }
    ]
  },
  {
    "key": "DISENGAGED1",
    "text": "Disengaged",
    "translations": [
      {
        "language": "AR",
        "text": "غير مندمج"
      }
    ]
  },
  {
    "key": "MODERATELY_ENGAGED",
    "text": "Moderate",
    "translations": [
      {
        "language": "AR",
        "text": "معتدل"
      },
      {
        "language": "FR",
        "text": "Moderately Engaged"
      }
    ]
  },
  {
    "key": "ENGAGED_LOW",
    "text": "Engaged&nbsp;<sub>Low</sub>",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج&nbsp;<sub>منخفض</sub>"
      },
      {
        "language": "FR",
        "text": "Engaged Low"
      }
    ]
  },
  {
    "key": "ENGAGED_MID",
    "text": "Engaged&nbsp;<sub>Mid</sub>",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج&nbsp;<sub>معتدل</sub>"
      },
      {
        "language": "FR",
        "text": "Engaged Mid"
      }
    ]
  },
  {
    "key": "ENGAGED_LOWchart",
    "text": "Engaged(Low)",
    "translations": [
      {
        "language": "AR",
        "text": "(مندمج(منخفض"
      },
      {
        "language": "FR",
        "text": "Engaged Low"
      }
    ]
  },
  {
    "key": "ENGAGED_MIDchart",
    "text": "Engaged(Mid)",
    "translations": [
      {
        "language": "AR",
        "text": "(مندمج(معتدل"
      },
      {
        "language": "FR",
        "text": "Engaged(Mid)"
      }
    ]
  },
  {
    "key": "ENGAGED_HIGH",
    "text": "Engaged&nbsp;<sub>High</sub>",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج&nbsp;<sub>مرتفع</sub>"
      },
      {
        "language": "FR",
        "text": "Engaged High "
      }
    ]
  },
  {
    "key": "ENGAGED_HIGHchart",
    "text": "Engaged(High)",
    "translations": [
      {
        "language": "AR",
        "text": "(مندمج(مرتفع"
      },
      {
        "language": "FR",
        "text": "Engaged High "
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      },
      {
        "language": "FR",
        "text": "Mise ŕ jour avec Succčs!"
      }
    ]
  },
  {
    "key": "txt_reminder_sent",
    "text": "Email sent to relevant respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال البريد الإلكتروني إلى المستجيبين المعنيين."
      },
      {
        "language": "FR",
        "text": "Courriel envoyé aux répondants concernés."
      }
    ]
  },
  {
    "key": "txt_respondents_list",
    "text": "Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون"
      },
      {
        "language": "FR",
        "text": "Liste des Répondants  "
      }
    ]
  },
  {
    "key": "btn_add_respondent",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Répondant"
      }
    ]
  },
  {
    "key": "txt_email_address",
    "text": "Email Address",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الالكتروني"
      },
      {
        "language": "FR",
        "text": "Adresse Email (Adresse électronique)"
      },
      {
        "language": "BN",
        "text": "ইমেইল"
      }
    ]
  },
  {
    "key": "txt_respondent_name",
    "text": "Respondent's Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "FR",
        "text": "Nom du Répondant "
      }
    ]
  },
  {
    "key": "txtinnovation2",
    "text": "Innovation",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار"
      },
      {
        "language": "FR",
        "text": "Innovation"
      }
    ]
  },
  {
    "key": "txtMotivation2",
    "text": "Motivation",
    "translations": [
      {
        "language": "AR",
        "text": "التحفيز"
      },
      {
        "language": "FR",
        "text": "Motivation"
      }
    ]
  },
  {
    "key": "txtPerformance2",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      },
      {
        "language": "FR",
        "text": "Performance"
      },
      {
        "language": "BN",
        "text": "কর্মক্ষমতা"
      }
    ]
  },
  {
    "key": "txtAutonomy2",
    "text": "Autonomy",
    "translations": [
      {
        "language": "AR",
        "text": "الاستقلالية"
      },
      {
        "language": "FR",
        "text": "Autonomie"
      }
    ]
  },
  {
    "key": "txtConnection2",
    "text": "Connection",
    "translations": [
      {
        "language": "AR",
        "text": "الاتصال"
      },
      {
        "language": "FR",
        "text": "Connexion"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadership2",
    "text": "Transformational Leadership",
    "translations": [
      {
        "language": "AR",
        "text": "القيادة التحويلية"
      },
      {
        "language": "FR",
        "text": "Leadership transformationnel"
      }
    ]
  },
  {
    "key": "txt_progress",
    "text": "Progress",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "FR",
        "text": "Progrčs"
      }
    ]
  },
  {
    "key": "txtSearch",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "FR",
        "text": "Rechercher"
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "FR",
        "text": "Complet"
      }
    ]
  },
  {
    "key": "txtquestion",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "FR",
        "text": "Question"
      },
      {
        "language": "BN",
        "text": "প্রশ্ন"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      },
      {
        "language": "FR",
        "text": "De"
      },
      {
        "language": "BN",
        "text": "এর"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      },
      {
        "language": "FR",
        "text": "Aperçu "
      }
    ]
  },
  {
    "key": "txtjoinersAnalysis",
    "text": "Joiners' Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات المغادرين"
      }
    ]
  },
  {
    "key": "txt_deleted",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعّال"
      },
      {
        "language": "FR",
        "text": "Supprimé"
      }
    ]
  },
  {
    "key": "txtMinimum",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل"
      },
      {
        "language": "FR",
        "text": "Minimum"
      }
    ]
  },
  {
    "key": "txtMaximum",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر"
      },
      {
        "language": "FR",
        "text": "Maximum"
      }
    ]
  },
  {
    "key": "txtMedian",
    "text": "Median",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "FR",
        "text": "Modifié"
      }
    ]
  },
  {
    "key": "txtbydrivers",
    "text": "By Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "حسب عوامل الاندماج"
      },
      {
        "language": "FR",
        "text": "Par les facteurs d’intégration"
      }
    ]
  },
  {
    "key": "txtByCriteria",
    "text": "By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "حسب المعايير"
      },
      {
        "language": "FR",
        "text": "Par Critčres"
      }
    ]
  },
  {
    "key": "txt_workplace_engagement",
    "text": "Workplace Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "الاندماج الوظيفي في مكان العمل"
      },
      {
        "language": "FR",
        "text": "Engagement en Milieu de Travail"
      }
    ]
  },
  {
    "key": "The Workplace Engagement Score measures the overall Engagement across the workplace. It is the average score of all the drivers combined",
    "text": "The Workplace Engagement Score measures the overall Engagement across the workplace. It is the average score of all the drivers combined",
    "translations": [
      {
        "language": "AR",
        "text": "تُعبر نتيجة الاندماج الوظيفي في مكان العمل عن التصور والاندماج الكلي في مكان العمل. وهي تشكل المعدل الكلي لنتائج عوامل الاندماج المختارة."
      }
    ]
  },
  {
    "key": "The below chart represents the overall workplace Engagement across companies",
    "text": "The below chart represents the overall workplace Engagement across companies",
    "translations": [
      {
        "language": "AR",
        "text": "ويعرض الرسم البياني أدناه نتائج الاندماج الوظيفي الكلي في مكان العمل حسب الشركات المختارة على مدى السنوات"
      }
    ]
  },
  {
    "key": "The below chart represents the",
    "text": "The below chart represents the",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض الرسم البياني أدناه درجة الاندماج الوظيفي لعامل "
      }
    ]
  },
  {
    "key": "driver score across companies",
    "text": "driver score across companies",
    "translations": [
      {
        "language": "AR",
        "text": "للشركات المختارة على مدى السنوات"
      }
    ]
  },
  {
    "key": "Comparative Analysis Report",
    "text": "Comparative Analysis Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير مقارنة الاندماج الوظيفي"
      }
    ]
  },
  {
    "key": "Workplace Engagement Drivers",
    "text": "Workplace Engagement Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل الاندماج في مكان العمل"
      }
    ]
  },
  {
    "key": "txt_drivers_score",
    "text": "Drivers' Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتائج عوامل الاندماج"
      },
      {
        "language": "FR",
        "text": "Note des Facteurs d’Intégration"
      }
    ]
  },
  {
    "key": "btn_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier"
      }
    ]
  },
  {
    "key": "txt_respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "FR",
        "text": "Répondants"
      }
    ]
  },
  {
    "key": "txtResponses",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      },
      {
        "language": "FR",
        "text": "Analyse des Répondants"
      }
    ]
  },
  {
    "key": "txtHeatmap",
    "text": "Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "مخطط تمثيل البيانات بالألوان"
      },
      {
        "language": "FR",
        "text": "Carte Thermique (Schéma de représentation des données en couleur)"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaires"
      }
    ]
  },
  {
    "key": "txtComments2",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تعليقات"
      }
    ]
  },
  {
    "key": "txtComment",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaire"
      }
    ]
  },
  {
    "key": "txt_response_rate",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      },
      {
        "language": "FR",
        "text": "Taux de Participation"
      }
    ]
  },
  {
    "key": "txt_engagement_report_export",
    "text": "Engagement Survey Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير استبيان الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Rapport d'Enquęte d'Engagement"
      }
    ]
  },
  {
    "key": "txtEngagement",
    "text": "Employee Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Engagement de l'Employé"
      }
    ]
  },
  {
    "key": "txtEngagementScale",
    "text": "Employee Engagement Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Indice de l’Engagement de l'Employé"
      }
    ]
  },
  {
    "key": "txtQuestionsAnalysisbyDriver",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_not_started",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يبدأ"
      },
      {
        "language": "FR",
        "text": "Non Commencé"
      }
    ]
  },
  {
    "key": "txt_added_success",
    "text": "Added Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح!"
      },
      {
        "language": "FR",
        "text": "Ajouté avec succčs!"
      }
    ]
  },
  {
    "key": "txt_removed_success",
    "text": "Deleted Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح!"
      },
      {
        "language": "FR",
        "text": "Supprimé avec Succčs!"
      }
    ]
  },
  {
    "key": "txt_in_progress",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإتمام"
      },
      {
        "language": "FR",
        "text": "En Progression"
      }
    ]
  },
  {
    "key": "txtComparisonOverall",
    "text": "Comparison: Overall",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة بالنسبة إلى: الكل"
      },
      {
        "language": "FR",
        "text": "Comparaison: En Général"
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      },
      {
        "language": "FR",
        "text": "Discussion:"
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      },
      {
        "language": "FR",
        "text": "En Général"
      }
    ]
  },
  {
    "key": "txtMean",
    "text": "Mean",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "FR",
        "text": "Moyenne"
      }
    ]
  },
  {
    "key": "txtDistribution",
    "text": "Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الإجابات"
      },
      {
        "language": "FR",
        "text": "Distribution"
      }
    ]
  },
  {
    "key": "txtRespondentComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaires des répondants"
      }
    ]
  },
  {
    "key": "ENGAGED",
    "text": "Engaged",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج"
      }
    ]
  },
  {
    "key": "txtheatmaptooltip",
    "text": "The value displayed in the cell is delta, which represents a difference in the overall value.",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
      },
      {
        "language": "FR",
        "text": "which represents a difference in the overall value."
      }
    ]
  },
  {
    "key": "txt_respondentsCount",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "مستجيب"
      }
    ]
  },
  {
    "key": "txtNeutral",
    "text": "Moderate",
    "translations": [
      {
        "language": "AR",
        "text": "معتدل"
      },
      {
        "language": "FR",
        "text": "Modéré"
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق بشدة"
      },
      {
        "language": "FR",
        "text": "Fortement en désaccord"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق"
      },
      {
        "language": "FR",
        "text": "Désaccord"
      }
    ]
  },
  {
    "key": "txtNeutral2",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "محايد"
      },
      {
        "language": "FR",
        "text": "Neutre"
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق"
      },
      {
        "language": "FR",
        "text": "Accepter "
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق بشدة"
      },
      {
        "language": "FR",
        "text": "Tout ŕ fait d'accord"
      }
    ]
  },
  {
    "key": "txtResponsesStatus",
    "text": "Responses Status",
    "translations": [
      {
        "language": "AR",
        "text": "حالة الردود"
      },
      {
        "language": "FR",
        "text": "Statut de Réponses"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      },
      {
        "language": "FR",
        "text": "Taux de Réponse Global"
      }
    ]
  },
  {
    "key": "txtAveraged",
    "text": "Averaged",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "FR",
        "text": "Moyenne"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المختارة"
      },
      {
        "language": "FR",
        "text": "Choisi"
      }
    ]
  },
  {
    "key": "txtEngagementsComparison",
    "text": "Engagements Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Comparaison de l’Intégration"
      }
    ]
  },
  {
    "key": "txtSurvey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      },
      {
        "language": "FR",
        "text": "Date de Début "
      }
    ]
  },
  {
    "key": "txtSurveys",
    "text": "Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "استبيانات"
      },
      {
        "language": "FR",
        "text": "Enquętes"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Délai"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceEngagement",
    "text": "Overall Workplace Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "الاندماج الوظيفي الكلي في مكان العمل"
      },
      {
        "language": "FR",
        "text": "Engagement Total sur le Lieu de Travail"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceEngagementScore",
    "text": "Overall Workplace Engagement Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة الاندماج الوظيفي الكلي في مكان العمل"
      },
      {
        "language": "FR",
        "text": "Note Global d'Engagement sur le Lieu de Travail"
      }
    ]
  },
  {
    "key": "txtSurveysByCompany",
    "text": "Surveys By Company",
    "translations": [
      {
        "language": "AR",
        "text": "الاستبيانات حسب الشركة"
      },
      {
        "language": "FR",
        "text": "Enquętes par Entreprise"
      }
    ]
  },
  {
    "key": "txtCompanyList",
    "text": "Company List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الشركات"
      }
    ]
  },
  {
    "key": "txt_time_frame_start",
    "text": "Time Frame Start",
    "translations": [
      {
        "language": "AR",
        "text": "بداية المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_time_frame_end",
    "text": "Time Frame End",
    "translations": [
      {
        "language": "AR",
        "text": "نهاية المدة الزمنية"
      }
    ]
  },
  {
    "key": "txtExportReport",
    "text": "Download Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "FR",
        "text": "Rapport de Téléchargement"
      }
    ]
  },
  {
    "key": "txtEngagementComparisonReport",
    "text": "Engagement Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير مقارنة اندماج الموظفين"
      },
      {
        "language": "FR",
        "text": "Engagement Comparison Report"
      }
    ]
  },
  {
    "key": "txtWrongPattern",
    "text": "Email wrong pattern.",
    "translations": [
      {
        "language": "AR",
        "text": "صيغة بريد إلكتروني خاطئة."
      }
    ]
  },
  {
    "key": "txtID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID"
      },
      {
        "language": "HI",
        "text": "ID"
      },
      {
        "language": "TA",
        "text": "ID"
      },
      {
        "language": "UR",
        "text": "ID"
      }
    ]
  },
  {
    "key": "txtEnterInformation",
    "text": "Fill the needed information to proceed.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة المعلومات اللازمة للمتابعة."
      },
      {
        "language": "HI",
        "text": "आगे बढ़ने के लिए आवश्यक जानकारी भरें।"
      },
      {
        "language": "TA",
        "text": "Punan ang kinakailangang impormasyon upang magpatuloy."
      },
      {
        "language": "UR",
        "text": "آگے بڑھنے کے لیے ضروری معلومات پر کریں۔"
      },
      {
        "language": "BN",
        "text": "এগিয়ে যেতে প্রয়োজনীয় তথ্য পূরণ করুন৷"
      }
    ]
  },
  {
    "key": "Insufficient Credit, Please Contact Your Admin",
    "text": "Insufficient Credit, Please Contact Your Admin",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد غير كافي، يرجى الاتصال بالمسؤول"
      }
    ]
  },
  {
    "key": "txtWelcomeAboard",
    "text": "Welcome Aboard",
    "translations": [
      {
        "language": "AR",
        "text": "أهلا وسهلا بك معنا"
      },
      {
        "language": "FR",
        "text": "Bienvenue ŕ bord"
      }
    ]
  },
  {
    "key": "txtUsername",
    "text": "Username",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المستخدم"
      },
      {
        "language": "FR",
        "text": "Nom d'utilisateur"
      },
      {
        "language": "HI",
        "text": "उपयोगकर्ता नाम"
      },
      {
        "language": "TA",
        "text": "Username"
      },
      {
        "language": "UR",
        "text": "صارف کا نام"
      },
      {
        "language": "BN",
        "text": "ব্যবহারকারীর নাম"
      }
    ]
  },
  {
    "key": "txtContinue",
    "text": "Continue",
    "translations": [
      {
        "language": "AR",
        "text": "استمر"
      },
      {
        "language": "FR",
        "text": "Continuer"
      },
      {
        "language": "HI",
        "text": "जारी रखें"
      },
      {
        "language": "TA",
        "text": "Magpatuloy"
      },
      {
        "language": "UR",
        "text": "جاری رکھیں"
      },
      {
        "language": "BN",
        "text": "অব্যাহত রাখুন"
      }
    ]
  },
  {
    "key": "txt_required_field",
    "text": "This field is required",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الحقل إجباري"
      },
      {
        "language": "FR",
        "text": "Ce champ est requis"
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      },
      {
        "language": "FR",
        "text": "Mettre ŕ jour"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "FR",
        "text": "Télécharger"
      }
    ]
  },
  {
    "key": "txtTitle",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      },
      {
        "language": "FR",
        "text": "Titre de Enquęte"
      },
      {
        "language": "BN",
        "text": "সমীক্ষার শিরোনাম"
      }
    ]
  },
  {
    "key": "txtRename",
    "text": "Rename",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تسمية"
      },
      {
        "language": "FR",
        "text": "Renommer"
      }
    ]
  },
  {
    "key": "txtEditSurvey",
    "text": "Edit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الاستبيان"
      },
      {
        "language": "FR",
        "text": "Modifier l'enquęte"
      }
    ]
  },
  {
    "key": "txtSelectOption",
    "text": "Select Option",
    "translations": [
      {
        "language": "AR",
        "text": "اختر خيار"
      }
    ]
  },
  {
    "key": "txt_copy",
    "text": "Copy",
    "translations": [
      {
        "language": "AR",
        "text": "نسخ"
      }
    ]
  },
  {
    "key": "txt_survey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte"
      }
    ]
  },
  {
    "key": "txt_done",
    "text": "Done",
    "translations": [
      {
        "language": "AR",
        "text": "منجز"
      },
      {
        "language": "FR",
        "text": "Fait"
      }
    ]
  },
  {
    "key": "btn_remove",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      }
    ]
  },
  {
    "key": "btn_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      },
      {
        "language": "FR",
        "text": "Fermer"
      }
    ]
  },
  {
    "key": "txt_send_reminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      },
      {
        "language": "FR",
        "text": "Envoyer des Rappels"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      },
      {
        "language": "FR",
        "text": "Envoyer un Rappel"
      }
    ]
  },
  {
    "key": "btn_save_reminder_template",
    "text": "Save Template",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ نموذج التذكير"
      },
      {
        "language": "FR",
        "text": "Sauvegarder le Modčle"
      }
    ]
  },
  {
    "key": "txtLive",
    "text": "Live",
    "translations": [
      {
        "language": "AR",
        "text": "مباشر"
      },
      {
        "language": "FR",
        "text": "En Direct"
      }
    ]
  },
  {
    "key": "txt_survey_progress",
    "text": "Survey Progress",
    "translations": [
      {
        "language": "AR",
        "text": "حالة الاستبيان"
      },
      {
        "language": "FR",
        "text": "Progression de Enquęte "
      }
    ]
  },
  {
    "key": "btn_filter_by",
    "text": "Filter By",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب"
      },
      {
        "language": "FR",
        "text": "FILTRER PAR"
      }
    ]
  },
  {
    "key": "btnCloseNow",
    "text": "Close Now",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الآن"
      },
      {
        "language": "FR",
        "text": "FERMER MAINTENANT"
      }
    ]
  },
  {
    "key": "txtResponded",
    "text": "Responded",
    "translations": [
      {
        "language": "AR",
        "text": "استجاب منهم"
      },
      {
        "language": "FR",
        "text": "A répondu"
      }
    ]
  },
  {
    "key": "txtGenerate",
    "text": "Generate",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء"
      }
    ]
  },
  {
    "key": "txt_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق"
      },
      {
        "language": "FR",
        "text": "Fermer"
      }
    ]
  },
  {
    "key": "txtLandingPage",
    "text": "Survey Link",
    "translations": [
      {
        "language": "AR",
        "text": "رابط الاستبيان"
      }
    ]
  },
  {
    "key": "txt_questionnaire_name",
    "text": "Survey Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الاستبيان"
      },
      {
        "language": "FR",
        "text": "Nom de Enquęte "
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة الاستبيان"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা প্রশ্ন"
      }
    ]
  },
  {
    "key": "txtExportSurvey",
    "text": "Download Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل أسئلة الاستبيان"
      },
      {
        "language": "FR",
        "text": "Enquętes de Téléchargement"
      }
    ]
  },
  {
    "key": "txt_engagement_preview_survey",
    "text": "Engagement Survey Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض استبيان الاندماج الوظيفي"
      }
    ]
  },
  {
    "key": "txtGeneratedon",
    "text": "Generated on:",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاؤه في"
      },
      {
        "language": "FR",
        "text": "Généré le:"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      },
      {
        "language": "FR",
        "text": "Alimenté par:"
      },
      {
        "language": "HI",
        "text": "द्वारा शक्तियुक्त:"
      },
      {
        "language": "TA",
        "text": "Pinatatakbo ng:"
      },
      {
        "language": "UR",
        "text": "قویت یافتہ از:"
      },
      {
        "language": "BN",
        "text": "দ্বারা চালিত:"
      }
    ]
  },
  {
    "key": "txt_survey_title",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      },
      {
        "language": "FR",
        "text": "Titre de Enquęte"
      },
      {
        "language": "BN",
        "text": "সমীক্ষার শিরোনাম"
      }
    ]
  },
  {
    "key": "txt_status",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "FR",
        "text": "Statut "
      }
    ]
  },
  {
    "key": "txt_view_by_drivers",
    "text": "VIEW BY DRIVERS",
    "translations": [
      {
        "language": "AR",
        "text": "عرض حسب عوامل الاندماج"
      },
      {
        "language": "FR",
        "text": "Présentation par les fecteurs "
      }
    ]
  },
  {
    "key": "txt_date_created",
    "text": "Date Created",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء"
      },
      {
        "language": "FR",
        "text": "Date Créée"
      }
    ]
  },
  {
    "key": "btn_relaunch",
    "text": "Relaunch",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة إطلاق"
      },
      {
        "language": "FR",
        "text": "Relancer"
      }
    ]
  },
  {
    "key": "txt_new_setup",
    "text": "New Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد جديد"
      },
      {
        "language": "FR",
        "text": "Nouvelle Configuration"
      }
    ]
  },
  {
    "key": "txt_survey_info",
    "text": "Survey Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات الاستبيان"
      },
      {
        "language": "FR",
        "text": "Informations sur le Enquęte"
      }
    ]
  },
  {
    "key": "txtOveralleng",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "المعدل الكلي"
      }
    ]
  },
  {
    "key": "Engagement Level",
    "text": "Engagement Level",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس الاندماج"
      }
    ]
  },
  {
    "key": "txt_question",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "FR",
        "text": "Question"
      },
      {
        "language": "BN",
        "text": "প্রশ্ন"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "FR",
        "text": "D'accord"
      }
    ]
  },
  {
    "key": "txt_go_closed",
    "text": "This survey will now be closed and you will no longer be able to make any changes or add new respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إنهاء هذا الاستبيان الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      },
      {
        "language": "FR",
        "text": "Ce Enquête sera maintenant fermé et vous ne serez plus en mesure d’apporter des changements ou d’ajouter de nouveaux répondants."
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "FR",
        "text": "Statements"
      },
      {
        "language": "BN",
        "text": "টি প্রশ্ন"
      }
    ]
  },
  {
    "key": "txtIMPACTEngagementModelbyZENITHR",
    "text": "The IMPACT Model by Zenithr",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج IMPACT - زينثر"
      },
      {
        "language": "FR",
        "text": "Modčle d'Engagement IMPACT par ZENITHR"
      }
    ]
  },
  {
    "key": "txt_Workplace_Engagement_Score",
    "text": "Workplace Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الاندماج في مكان العمل"
      },
      {
        "language": "FR",
        "text": "Engagement en Milieu de Travail"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      },
      {
        "language": "FR",
        "text": "Tous les droits sont réservés"
      }
    ]
  },
  {
    "key": "txtEngagementReport",
    "text": "Employee Engagement Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Rapport sur l’Engagement de l'Employé"
      }
    ]
  },
  {
    "key": "txtEngagementScaleByDriver",
    "text": "Employee Engagement Index by Driver",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر الاندماج الوظيفي حسب كل عامل اندماج"
      }
    ]
  },
  {
    "key": "txtEngagementScaleByCriteria",
    "text": "Employee Engagement by Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر الاندماج الوظيفي حسب المعايير"
      }
    ]
  },
  {
    "key": "txtLowlyEngaged",
    "text": "Lowly Engaged",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج بنسبة منخفضة"
      },
      {
        "language": "FR",
        "text": "Peu Engagé"
      }
    ]
  },
  {
    "key": "txtHighlyEngaged",
    "text": "Highly Engaged",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج بنسبة مرتفعة"
      },
      {
        "language": "FR",
        "text": "Trčs Engagé"
      }
    ]
  },
  {
    "key": "txtModeratelyEngaged",
    "text": "Moderately Engaged",
    "translations": [
      {
        "language": "AR",
        "text": "مندمج بنسبة معتدلة"
      },
      {
        "language": "FR",
        "text": "Modérément Engagé"
      }
    ]
  },
  {
    "key": "txtExportCommentCheckbox",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Télécharger avec commentaires"
      }
    ]
  },
  {
    "key": "txtExportCommentsUnavailable",
    "text": "Comments Unavailable",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات غير متاحة"
      },
      {
        "language": "FR",
        "text": "Commentaires Indisponibles"
      }
    ]
  },
  {
    "key": "txtLow",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "قليل"
      },
      {
        "language": "FR",
        "text": "Bas"
      }
    ]
  },
  {
    "key": "txtHigh",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "عالي"
      },
      {
        "language": "FR",
        "text": "Haut"
      }
    ]
  },
  {
    "key": "txtResultsRating",
    "text": "Results Rating",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النتائج"
      }
    ]
  },
  {
    "key": "txtRatingScale",
    "text": "Rating Scale",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس التقييم"
      },
      {
        "language": "FR",
        "text": "Échelle d’Évaluation"
      },
      {
        "language": "BN",
        "text": "নির্ধারণের মাপকাঠি"
      }
    ]
  },
  {
    "key": "txtCalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      },
      {
        "language": "FR",
        "text": "Processus de Calcul"
      }
    ]
  },
  {
    "key": "txtCalculationProcess1",
    "text": "Each statement score is given an average rating based on the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب نتيجة كل عبارة من خلال أخذ متوسط نتائج اختيارات الموظفين."
      },
      {
        "language": "FR",
        "text": "Chaque note de déclaration reçoit une note moyenne basée sur les commentaires reçus."
      }
    ]
  },
  {
    "key": "txtCalculationProcess2",
    "text": "Each driver score is calculated as the overall rating score of the statements.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب نتيجة كل عامل من عوامل الاندماج من خلال أخذ متوسط نتائج العبارات. "
      },
      {
        "language": "FR",
        "text": "Chaque  note de compétences est calculé comme le score global de notation des énoncés sélectionnés."
      }
    ]
  },
  {
    "key": "txtCalculationProcess3",
    "text": "The Overall Workplace Engagement is calculated as the average rating of the selected drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب مستوى الاندماج الوظيفي الكلي في مكان العمل من خلال أخذ متوسط نتائج عوامل الاندماج التي تم اختيارها."
      },
      {
        "language": "FR",
        "text": "«Sans objet» est exclu du calcul de la note moyenne."
      }
    ]
  },
  {
    "key": "txtCalculationProcess4",
    "text": "The Employee Engagement Index is calculated as per the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب مؤشر اندماج الموظفين من خلال نتائج اختيارات الموظفين."
      },
      {
        "language": "FR",
        "text": "La performance globale est calculée comme la note moyenne des compétences pondérées."
      }
    ]
  },
  {
    "key": "txtEmployeesEngagementIndex",
    "text": "Employee Engagement Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر اندماج الموظفين"
      },
      {
        "language": "FR",
        "text": "Indice de l’Engagement de l'Employé"
      }
    ]
  },
  {
    "key": "txtEmployeesEngagementIndexpara",
    "text": "The Employee Engagement Index is the next level of the workplace engagement score. It represents the engagement levels of your employees. The below results exhibit the percentages of the respondents who are highly engaged, moderately engaged, and lowly engaged based on their responses to the selected drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "وتمثل مؤشرات اندماج الموظفين المستوى التالي من درجة الاندماج الوظيفي في مكان العمل. وهذه المؤشرات تمثل مستويات اندماج الموظفين. وتعرض النتائج أدناه، النسب المئوية للموظفين الذين يتمتعون باندماج عالٍ، أو معتدل، أو منخفض، بناءً على ردودهم على عوامل الاندماج المختارة."
      },
      {
        "language": "FR",
        "text": "L’indice d’engagement des employés est le prochain niveau de la note d’engagement en milieu de travail. Il représente les niveaux d'engagement de vos employés. Les résultats ci-dessous montrent les pourcentages de répondants qui sont très engagés, modérément engagés et peu engagés en fonction de leurs réponses aux fecteurs sélectionnés."
      }
    ]
  },
  {
    "key": "txtDriversofWorkplaceEngagement",
    "text": "Workplace Engagement Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل اندماج مكان العمل"
      },
      {
        "language": "FR",
        "text": "Facteurs de l'Engagement du Lieu de Travail"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceEngagementpara1",
    "text": "The Workplace Engagement Score measures the overall engagement & perception across the organization. It is the average score of the selected drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "تعبر نتيجة الاندماج الوظيفي في مكان العمل عن التصور والاندماج الكلي في مكان العمل. وهي تشكل المعدل الكلي لنتائج عوامل الاندماج المختارة."
      },
      {
        "language": "FR",
        "text": "Le score d'engagement sur le lieu de travail mesure l'engagement global et la perception au sein de l'organisation. C'est le score moyen des facteurs sélectionnés."
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceEngagementpara2",
    "text": "The more engaged your employees are, the more willing they are to put effort into achieving the business goals and contributing to its success.",
    "translations": [
      {
        "language": "AR",
        "text": "كلما زاد تفاعل موظفيك واندماجهم في العمل، زادت رغبتهم في بذل جهد إضافي لتحقيق أهداف العمل والمساهمة في نجاحه."
      },
      {
        "language": "FR",
        "text": "Plus vos employés sont engagés, plus ils sont prêts à faire des efforts pour atteindre les objectifs de l'entreprise et contribuer à son succès."
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      },
      {
        "language": "FR",
        "text": "Rapport"
      }
    ]
  },
  {
    "key": "txt_reporteng",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "التقرير"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use the Report",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من التقرير؟"
      },
      {
        "language": "FR",
        "text": "Comment Utiliser le Rapport  "
      }
    ]
  },
  {
    "key": "txtHowtousethisreportpara",
    "text": "<p class=\"mb-4\">This report is a representation of the current level of workplace engagement at [Company Name]. The overall engagement score will help understand how the workplace performs.</p>\n  <p class=\"mb-4\">The drivers and their engagement levels displayed in this report are a result of the employees’ responses. Below every score is the analysis of the current work situation and the recommended actions.</p>\n  <p class=\"mb-4\">Recommended actions in this report are only a few of the many activities that can be taken to improve the environment, and they are not limited to the displayed suggestions. It is highly encouraged that the actions deemed fit for [Company Name] are taken to improve its employee engagement level and performance.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">يوضح هذا التقرير المستوى الحالي للاندماج الوظيفي في [Company Name]. وسوف تساعد النتيجة الإجمالية للاندماج في فهم كيفية أداء مكان العمل.</p>\n  <p class=\"mb-4\">إن عوامل الاندماج المبينة في هذا التقرير ومستوى الاندماج الخاص بها هي نتيجة وخلاصة استجابة الموظفين لهذا الاستبيان. ويلي كل نتيجة، تحليل خاص بالوضع الحالي في مكان العمل، والتوصيات المقترحة للمحافظة على الوضع الحالي أو العمل على تحسينه.</p>\n  <p class=\"mb-4\">إن الإجراءات الموصى بها في هذا التقرير ما هي الإ جزء من الإجراءات التي من الممكن اتخاذها في تحسين بيئة العمل، ولا تقتصر عليها فقط. وتشجع على اتخاذ الإجراءات المناسبة لتحسين مستوى الاندماج الوظيفي الخاص بـ [Company Name] وتحسين الأداء.</p>"
      },
      {
        "language": "FR",
        "text": "<p class=\"mb-4\">Ce rapport est une représentation du niveau actuel d'engagement sur le lieu de travail chez [Company Name]. Le score global d'engagement aidera à comprendre les performances du lieu de travail.</p>\n<p class=\"mb-4\"> Les facteurs d’Intégration et leurs niveaux d’engagement affichés dans le présent rapport sont le résultat des réponses des employés.</p>\n<p class=\"mb-4\"> Sous chaque note se trouve l’analyse de la situation de travail actuelle et des mesures recommandées.</p>\n<p class=\"mb-4\"> Les mesures recommandées dans le présent rapport ne sont que quelques-unes des nombreuses activités qui peuvent être entreprises pour améliorer l’environnement, et elles ne se limitent pas aux suggestions affichées. Il est fortement recommandé que les mesures jugées appropriées pour [Company Name] soient prises pour améliorer le niveau d'engagement et la performance de ses employés.</p>"
      }
    ]
  },
  {
    "key": "txtscience",
    "text": "Science Behind the IMPACT Model",
    "translations": [
      {
        "language": "AR",
        "text": "العلم الذي يرتكز عليه نموذج IMPACT"
      },
      {
        "language": "FR",
        "text": "La science sur laquelle repose le modčle IMPACT"
      }
    ]
  },
  {
    "key": "txtobjectives",
    "text": "<h4 class=\"mb-5 text-zen text-lg font-semibold mt-12\">Objectives of this Report</h4> <div class=\"columns-content\"> <div class=\"col-left\"> <ul> <li> <i class=\"fas fa-circle\"></i> <p>Identify the workplace overall engagement score and understand how lowly, moderately, and highly engaged employees affect the workplace and its performance.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Identify strengths through drivers with high engagement and recognize how they impact the workplace.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Understand areas of improvement through drivers with low engagement and the reason behind the results.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Access recommended actions to be taken for each driver, whether they are lowly, moderately, or highly engaged, and how they can be implemented to improve the workplace and environment.</p> </li> <li> <i class=\"fas fa-circle\"></i> <p>Obtain open-ended statements or feedback submitted by employees during the survey, use it to improve ways of doing things, and understand how they feel about the workplace.</p> </li> </ul> </div> </div>",
    "translations": [
      {
        "language": "AR",
        "text": "<h4 class=\"text-zen text-xl font-medium pb-7 pt-10\">أهداف التقرير</h4> <div class=\"flex flex-col items-stretch\">   <div class=\"flex flex-col w-full\">     <ul>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>تحديد درجة الاندماج الإجمالية وفهم كيف يؤثر الموظفون المندمجون بنسبة متدنية، أو معتدلة، أو عالية على مكان           العمل وأدائه.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>تحديد نِقَاط القوة باعتماد عوامل الاندماج ذات الاندماج العالي وإدراك كيفية تأثيرها في مكان العمل.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>تحديد نِقَاط التحسين باعتماد عوامل الاندماج ذات الاندماج المتدني والأسباب وراء هذه النتائج. </p>       </li>        <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>الحصول على توصيات لأخذها بعين الاعتبار لكل عامل اندماج، بغض النظر عن درجة الاندماج الخاصة به إن كانت متدنية،           أو معتدلة، أو عالية وكيفية تطبيق هذه التوصيات لتحسين بيئة ومكان العمل.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>الحصول على تعليقات الموظفين من خلال الاستبيان، للاستفادة منها في تطوير طرق تنفيذ الأعمال، وفهم شعور الموظفين           تجاه مكان العمل. </p>       </li>     </ul>   </div> </div>"
      },
      {
        "language": "FR",
        "text": "<h4 class=\"mb-5 fw-bold\">Objectifs de ce rapport</h4>\n<div class=\"columns-content\"> <div class=\"col-left\"> <ul> <li> <i class=\"fas fa-circle\"></i> <p> Identifiez le score global d'engagement sur le lieu de travail et comprenez comment les employés modestes, modérément et fortement engagés affectent le lieu de travail et ses performances.\n</p> </li> <li> <i class=\"fas fa-circle\"></i> <p> Identifiez les points forts par des facteurs très engagés et reconnaissez leur impact sur le lieu de travail.\n</p> </li> <li> <i class=\"fas fa-circle\"></i> <p> Comprendre les domaines d'amélioration par des facteurs avec un faible engagement et la raison derrière les résultats.\n</p> </li> </ul> </div> <div class=\"col-sep\"></div> <div class=\"col-right\"> <ul> <li> <i class=\"fas fa-circle\"></i> <p> Accédez aux mesures recommandées à prendre pour chaque conducteur, qu'il soit faiblement, modérément ou fortement engagé, et comment elles peuvent être mises en œuvre pour améliorer le lieu de travail et l'environnement.\n</p> </li> <li> <i class=\"fas fa-circle\"></i> <p> Obtenez des déclarations ouvertes ou des commentaires soumis par les employés pendant le Enquête, utilisez-les pour améliorer leurs façons de faire et comprendre ce qu'ils pensent du lieu de travail.</p> </li> </ul> </div> </div>"
      }
    ]
  },
  {
    "key": "txtsciencepara",
    "text": "<p class=\"mb-4\">Proved studies have indicated that Employee Engagement depends on several psychological conditions and elements, like meaningfulness, safety, and availability, required for an individual to remain engaged.</p>  <p class=\"mb-4\">It is a dynamic principle of employee performance that leads to their retention.</p>  <p class=\"mb-4\">The latest scientific research conducted by experts from a wide spectrum of top-rated universities revealed the positive correlation between Employee Engagement and improving both employees’ and business performance.</p>  <p class=\"mb-4\">Zenithr’s team has designed the IMPACT model drivers influencing the employee's engagement based on the latest scientific practices and research, psychological conditions, and the recent business trends.  IMPACT stands for Innovation, Motivation, Performance, Autonomy, Connection, and Transformational Leadership.</p>  <p class=\"mb-4\">Zenithr’s IMPACT Model, defined as a “marked influence,” was generated using the initials of the most important drivers that best measure Employee Engagement. Each of these drivers is cascaded into two sub-drivers that explicitly measure psychological conditions, which help dive into the reasons behind what keeps employees engaged and disengaged.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">أشارت الدراسات المُثبتة إلى أن الاندماج الوظيفي يعتمد على بعض الظروف النفسية (السيكولوجية) للموظف مثل: المغزى من العمل، والسلامة، والتوافر، وهو ما يتطلبه لضمان بقاء الفرد مندمجاً في مكان العمل.</p>  <p class=\"mb-4\">الاندماج الوظيفي يعتبر معيار ديناميكي لأداء الموظف والذي بدوره يؤدي إلى الاحتفاظ بهم.</p>  <p class=\"mb-4\">كشفت أحدث الأبحاث العلمية التي أجراها خبراء مختصين من جامعات ذات تصنيف عالي عن العلاقة الإيجابية بين اندماج الموظفين في العمل وتحسين أدائهم وأداء الأعمال.</p>  <p class=\"mb-4\">صمم فريق عمل زينثر عوامل الاندماج في منهجية \"IMPACT\" و التي تؤثر على اندماج الموظفين بناءً على أحدث الممارسات العملية والبحوث والظروف النفسية (السيكولوجية) واتجاهات الأعمال الحديثة.  وتُمثل منهجية “IMPACT” عوامل الاندماج: الابتكار (Innovation)، والتشجيع (Motivation)، والأداء (Performance)، والاستقلالية (Autonomy)، والاتصال (Connection)، والقيادة التحويلية (Transformational Leadership).</p>  <p class=\"mb-4\">وقد تم تصميم اسم المنهجية “IMPACT” من خلال أخذ الأحرف الأولى لأهم عوامل الاندماج التي تقيس معدل الاندماج الوظيفي. ويشمل كل عامل اندماج من هذه العوامل على مجالين يقيسان الظروف النفسية (السيكولوجية) بشكل واضح ومحدد مما يساعد على الوصول إلى الأسباب الرئيسية التي تجعل الموظفين مندمجين وظيفياً أو تحول دون ذلك.</p>"
      },
      {
        "language": "FR",
        "text": "<p class=\"mb-4\">Des études prouvées ont indiqué que l’engagement des employés dépend de plusieurs conditions et éléments psychologiques, comme la signification, la sécurité et la disponibilité, nécessaires pour qu’une personne demeure engagée.</p>\n<p class=\"mb-4\">C’est un principe dynamique de performance des collaborateurs qui conduit à leur fidélisation.</p>\n<p class=\"mb-4\"> Les dernières recherches scientifiques menées par des experts d’un large éventail d’universités de premier ordre ont révélé la corrélation positive entre l’engagement des employés et l’amélioration des performances des employés et de l’entreprise.</p>\n<p class=\"mb-4\"> L’équipe de ZENITHR a conçu les moteurs du modèle IMPACT qui influencent l’engagement des employés en se basant sur les dernières pratiques et recherches scientifiques, les conditions psychologiques et les tendances commerciales récentes. IMPACT signifie Innovation, Motivation, Performance, Autonomie, Connexion et Leadership Transformationnel.</p>\n<p class=\"mb-4\">Le modèle IMPACT de ZENITHR, défini comme une « influence marquée », a été généré à l’aide des initiales des principaux facteurs qui mesurent le mieux l’engagement des employés. Chacun de ces facteurs est réparti en deux sous-facteurs qui mesurent explicitement les conditions psychologiques, ce qui aide à examiner les raisons qui motivent l’engagement et le désengagement des employés.</p>"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      },
      {
        "language": "FR",
        "text": "introduction"
      }
    ]
  },
  {
    "key": "txtIntroductionpara",
    "text": "<p>Employee Engagement is the employee’s emotional commitment to the workplace and their willingness to give their best and show high performance to achieve business goals.</p> <br>  <p>It has no predetermined definition; however, it is wrapped around the connection employees have towards their job and place.</p> <br> <p>Employee Engagement plays an essential role in promoting a culture of loyalty and fostering the motivation for employees who take the leap for the work they feel recognizes them.</p> <br>  <p>The Employee Engagement Survey applies the IMPACT model to measure the employees’ interaction in the workplace, displayed in this report through in-depth analysis, scores, and recommendations.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>\"الاندماج الوظيفي\" هو الالتزام العاطفي بين الموظفين ومكان العمل ورغبتهم في تقديم أفضل ما لديهم وإظهار مستوى أداء عالٍ لتحقيق أهداف العمل.</p><br> <p>وبشكل عام، ليس هناك تعريف محدد \"للاندماج الوظيفي\". إلا أنها مرتكزة على ارتباط الموظفين مع عملهم والمكان الذي يعملون فيه.</p>  <p>يُمثّل \"الاندماج الوظيفي\" دوراً أساسياً في تعزيز ثقافة الولاء وتشجيع الموظفين وتحفيزهم لتقديم أفضل ما عندهم، خصوصاً عند مقابلة مواقفهم بالدعم والتقدير.</p> <br> <p>يُطبق \"استبيان الاندماج الوظيفي\" منهجية “IMPACT” لقياس التفاعل الذي يُحققه ويُنجزه الموظفين في مكان العمل، والذي يتم عرضه في هذا التقرير من خلال التحليل المتعمق في التقييم، والردود، والتوصيات المقترحة.</p>"
      },
      {
        "language": "FR",
        "text": "<p>L’engagement des employés est l’engagement émotionnel de l’employé envers le lieu de travail et sa volonté de donner le meilleur de lui-même et de montrer des performances élevées pour atteindre les objectifs de l’entreprise.</p>  <br>  <p> Il n'a pas de définition prédéterminée; cependant, il est enveloppé autour du lien que les employés ont avec leur travail et leur place.</p> <p>L'engagement des employés joue un rôle essentiel dans la promotion d'une culture de loyauté et la motivation des employés qui franchissent le pas pour le travail qui, selon eux, les reconnaît.</p> <p> L'enquête sur l'engagement des employés applique le modèle D'IMPACT pour mesurer l'interaction des employés sur le lieu de travail, qui est affichée dans ce rapport par le biais d'une analyse approfondie, de scores et de recommandations.</p>"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      },
      {
        "language": "FR",
        "text": "Table des matičres"
      }
    ]
  },
  {
    "key": "txtResponses2",
    "text": "Responses",
    "translations": [
      {
        "language": "AR",
        "text": "الردود"
      },
      {
        "language": "FR",
        "text": "Réponses"
      }
    ]
  },
  {
    "key": "txtOutOf",
    "text": "out of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      },
      {
        "language": "FR",
        "text": "Hors de "
      }
    ]
  },
  {
    "key": "txtHighlyDisengagedDesc",
    "text": "[Percentage]% of the participated employees are extremely disengaged within the workplace. These employees feel extremely not involved in the workplace, demotivated, and do not feel like doing the work expected of them. They are not loyal and not productive at all, and they may look for opportunities in a better work environment",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين غير مندمجون في بيئة العمل، وهم محبطين ولا يبدون أي رغبة في القيام بالعمل الموكل إليهم. وهؤلاء الموظفين لا يظهرون أي درجة من الإخلاص وليس لديهم الدافع ليكونوا منتجين. وهنالك احتمالية لجوئهم للبحث عن فرص في بيئة عمل أفضل."
      },
      {
        "language": "FR",
        "text": "[Percentage]% des employés participants qui sont peu engagés sur le lieu de travail. Ces employés se sentent non impliqués dans le milieu de travail, démotivés et n'ont pas envie de faire le travail qu'on attend d'eux. Ils ne sont ni loyaux, ni productifs, et ils peuvent chercher des opportunités dans un meilleur environnement de travail."
      }
    ]
  },
  {
    "key": "txtLowlyEngagedDesc",
    "text": "[Percentage]% of the participated employees are extremely disengaged within the workplace. These employees feel extremely not involved in the workplace, demotivated, and do not feel like doing the work expected of them. They are not loyal and not productive at all, and they may look for opportunities in a better work environment",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين غير مندمجون في بيئة العمل، وهم محبطين ولا يبدون أي رغبة في القيام بالعمل الموكل إليهم. وهؤلاء الموظفين لا يظهرون أي درجة من الإخلاص وليس لديهم الدافع ليكونوا منتجين. وهنالك احتمالية لجوئهم للبحث عن فرص في بيئة عمل أفضل."
      },
      {
        "language": "FR",
        "text": "[Percentage]% des employés participants qui sont peu engagés sur le lieu de travail. Ces employés se sentent non impliqués dans le milieu de travail, démotivés et n'ont pas envie de faire le travail qu'on attend d'eux. Ils ne sont ni loyaux, ni productifs, et ils peuvent chercher des opportunités dans un meilleur environnement de travail."
      }
    ]
  },
  {
    "key": "txtModeratelyEngagedDesc",
    "text": "[Percentage]% of the participated employees are moderately engaged within the workplace. These employees are less likely to be passionate about their job and the workplace. These are the ones who only do the work expected from them, but there is a chance for better effort if they receive more appreciation and support in their work. They are less loyal and productive.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين مندمجون في عملهم بقدر معتدل، وهم أقل شغفاً بوظائفهم وبيئة العمل. هؤلاء الموظين يقومون بالعمل المتوقع منهم فقط، ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ودعمهم بشكل أكثر. ويعتبرون أقل إخلاصاً وإنتاجية."
      },
      {
        "language": "FR",
        "text": "[Percentage]% des employés participants sont moyennement engagés sur le lieu de travail. Ces employés sont moins susceptibles d'être passionnés par leur travail et leur milieu de travail. Ce sont eux qui ne font que le travail attendu d'eux, mais il y a une chance pour un meilleur effort s'ils reçoivent plus d'appréciation et de soutien dans leur travail. Ils sont moins fidèles et moins productifs."
      }
    ]
  },
  {
    "key": "txtHighlyEngagedLowDesc",
    "text": "[Percentage]% of the participated employees are lowly engaged within the workplace. These employees feel involved and passionate about their job and the workplace. They are innovative and creative in transforming knowledge and ideas into new products and services to achieve business goals. They show a high level of loyalty, and they are motivated to be productive.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين مندمجون في عملهم بقدر معتدل، وهم أقل شغفاً بوظائفهم وبيئة العمل. هؤلاء الموظين يقومون بالعمل المتوقع منهم فقط، ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ودعمهم بشكل أكثر. ويعتبرون أقل إخلاصاً وإنتاجية."
      },
      {
        "language": "FR",
        "text": "[Percentage]% des employés participants sont moyennement engagés sur le lieu de travail. Ces employés sont moins susceptibles d'être passionnés par leur travail et leur milieu de travail. Ce sont eux qui ne font que le travail attendu d'eux, mais il y a une chance pour un meilleur effort s'ils reçoivent plus d'appréciation et de soutien dans leur travail. Ils sont moins fidèles et moins productifs."
      }
    ]
  },
  {
    "key": "txtHighlyEngagedMidDesc",
    "text": "[Percentage]% of the participated employees are engaged within the workplace. These employees feel more involved and passionate about their job and the workplace. They tend to be more innovative and creative in transforming knowledge and ideas into new products and services to achieve business goals. They show a higher level of loyalty, and they are motivated to be more productive.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين مندمجون في عملهم بقدر معتدل، وهم أقل شغفاً بوظائفهم وبيئة العمل. هؤلاء الموظين يقومون بالعمل المتوقع منهم فقط، ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ودعمهم بشكل أكثر. ويعتبرون أقل إخلاصاً وإنتاجية."
      },
      {
        "language": "FR",
        "text": "[Percentage]% des employés participants sont moyennement engagés sur le lieu de travail. Ces employés sont moins susceptibles d'être passionnés par leur travail et leur milieu de travail. Ce sont eux qui ne font que le travail attendu d'eux, mais il y a une chance pour un meilleur effort s'ils reçoivent plus d'appréciation et de soutien dans leur travail. Ils sont moins fidèles et moins productifs."
      }
    ]
  },
  {
    "key": "txtHighlyEngagedDesc",
    "text": "[Percentage]% of the participated employees are highly engaged within the workplace. These employees feel extremely involved and passionate about their job and the workplace. They will continue to remain innovative and creative in transforming knowledge and ideas into new products and services to achieve business goals. They show an extremely high level of loyalty, and they are motivated to be extremely productive.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين مندمجون في عملهم بقدر كبير، نتيجة شعورهم بالشغف اتجاه وظائفهم واندماجهم في بيئة العمل. وهم مبدعين ومبتكرين في تحويل المعرفة والأفكار إلى قيم وإجراءات جديدة لتحقيق أهداف العمل. وهؤلاء الموظفين على درجة عالية من الإخلاص والإنتاجية."
      },
      {
        "language": "FR",
        "text": "[Percentage]% des employés participants sont très engagés sur le lieu de travail. Ces employés se sentent impliqués et passionnés par leur travail et leur milieu de travail. Ils sont innovants et créatifs dans la transformation des connaissances et des idées en nouveaux produits et services pour atteindre les objectifs de l’entreprise et les objectifs commerciaux. Ils font preuve d'un haut niveau de loyauté et sont motivés pour être plus productifs."
      }
    ]
  },
  {
    "key": "txtDriversofWorkplaceEngagementDesc",
    "text": "The below indicates the scores for each of the [Drivers Count] drivers of Workplace Engagement at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "وتعرض أدناه نتائج عوامل الاندماج المختارة لقياس الاندماج الوظيفي في مكان العمل ل [Company Name]:"
      },
      {
        "language": "FR",
        "text": "Les résultats des facteurs d’Intégration retenus pour mesurer l’intégration professionnelle sur le lieu de travail sont présentés ci-dessous pour < Fort > [Company Name] </Fort> :"
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "FR",
        "text": "Pour"
      }
    ]
  },
  {
    "key": "txtInnovationDriverDesc",
    "text": "Innovation and engagement are positively correlated through creativity and innovative capabilities. The employees encouraged to be creative while considering their ideas are more likely to be happy with the results they drive. They contribute more to achieve business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار والاندماج الوظيفي يرتبطان بشكل إيجابي من خلال الإبداع والقدرات الابتكارية. فالموظفين الذين يتم تشجيعهم للإبداع في العمل ويتم أخذ أفكارهم بعين الاعتبار لديهم قابلية ليكونوا سعداء مع النتائج التي يحققونها، وبالتالي يساهمون بتحقيق أهداف العمل بشكل أفضل."
      },
      {
        "language": "FR",
        "text": "L'innovation et l'engagement sont positivement corrélés par la créativité et les capacités d'innovation. Les employés encouragés à faire preuve de créativité tout en considérant leurs idées sont plus susceptibles d'être satisfaits des résultats qu'ils génèrent. Ils contribuent davantage à atteindre les objectifs commerciaux."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverReadings",
    "text": "These results indicate that the environment does not allow the employees to unleash creativity and does not give them enough space to be creative and innovative. As a result, they refrain from developing ideas about new values and procedures.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج  أن بيئة العمل لا تسمح للموظفين بإطلاق العنان للإبداع ولا تمنحهم المساحة الكافية للإبداع والابتكار، وبالتالي يمتنعون عن تطوير أفكار حول قيم وإجراءات جديدة."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l’environnement ne permet pas aux employés de libérer la créativité et ne leur donne pas assez d’espace pour être créatifs et innovateurs. Par conséquent, ils s’abstiennent d’élaborer des idées sur de nouvelles valeurs et procédures."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationBrief",
    "text": "These results may indicate a high degree of risk in the work environment in terms of not encouraging the employees enough to be more creative and innovative, which in turn affects employees’ engagement. It is recommended to take immediate and rapid actions to motivate them to contribute innovative ideas, welcoming what they propose, making their contribution feel valued, and giving them the space to improve.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير درجة عالية من الخطورة في بيئة العمل من حيث عدم تشجيع الموظفين ليكونوا أكثر إبداعاً وابتكاراً والذي يؤثر بدوره على اندماج الموظفين. ويجب اتخاذ إجراءات فورية وسريعة من خلال تحفيز الموظفين على المساهمة بأفكار مبتكرة، والترحيب بما يقترحونه، وتقدير مساهمتهم، ومنحهم مساحة للتحسين."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer un degré élevé de risque dans le milieu de travail en termes de non-encouragement des employés suffisamment pour être plus créatifs et innovateurs, ce qui à son tour affecte l’engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour les motiver à apporter des idées novatrices, à accueillir ce qu’ils proposent, à valoriser leur contribution et à leur donner l’espace nécessaire pour s’améliorer."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationPointHeader",
    "text": "You can take the following actions. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Vous pouvez prendre les mesures suivantes. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationTitle_1",
    "text": "Invest in more resources that drive innovation.",
    "translations": [
      {
        "language": "AR",
        "text": "الاستثمار في المزيد من الموارد التي تدفع الابتكار."
      },
      {
        "language": "FR",
        "text": "Investissez dans plus de ressources qui stimulent l'innovation."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationDesc_1",
    "text": "The workplace might lack the resources that it needs to drive Innovation and creativity from the employees. The investment in these unavailable resources is a must to obtain maximum efficiency and help the development of innovation. Give the employees access to those resources and encourage them to drive the change in the business.",
    "translations": [
      {
        "language": "AR",
        "text": "قد يفتقر مكان العمل للموارد التي يحتاجها لدفع الموظفين للابتكار والإبداع. ويجب الاستثمار في هذه الموارد الغير متاحة، للحصول على أقصى قدر من الكفاءة والمساعدة في تنمية هذا الابتكار. ومنح الموظفين إمكانية الوصول إلى هذه الموارد وتشجيعهم على قيادة التغيير في العمل."
      },
      {
        "language": "FR",
        "text": "Le lieu de travail peut manquer des ressources dont il a besoin pour stimuler l'innovation et la créativité des employés. L'investissement dans ces ressources indisponibles est indispensable pour obtenir une efficacité maximale et contribuer au développement de l'innovation. Donner aux employés l’accès à ces ressources et les encourager à conduire le changement dans l’entreprise."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationTitle_2",
    "text": "Team Diversity.",
    "translations": [
      {
        "language": "AR",
        "text": "تنوع الفريق."
      },
      {
        "language": "FR",
        "text": "Diversité de l'Équipe."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationDesc_2",
    "text": "Building a diverse team with different experiences, skills, and thinking styles contributes to bringing new ideas that help educate individuals and develop their creative skills. This is reflected in providing a positive contribution to achieve business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "بناء فريق متنوع بخبرات ومهارات وأنماط تفكير مختلفة، يسهم في جلب أفكار جديدة تساعد في تعليم الأفراد وتطوير مهاراتهم الإبداعية، وينعكس ذلك بتقديم مساهمة إيجابية ومشتركة لتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "Construire une équipe diversifiée avec des expériences, des compétences et des styles de réflexion différents contribue à apporter de nouvelles idées qui aident à éduquer les individus et à développer leurs compétences créatives. Cela se traduit par une contribution positive à la réalisation des objectifs commerciaux."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationTitle_3",
    "text": "Inspire the employees to transform knowledge into products and services.",
    "translations": [
      {
        "language": "AR",
        "text": "إلهام الموظفين لتحويل المعرفة إلى قيم وإجراءات جديدة."
      },
      {
        "language": "FR",
        "text": "Inspirer les employés ŕ transformer les connaissances en produits et en services."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationDesc_3",
    "text": "This can be done through casual meetings, allowing each employee to brainstorm and present their ideas in an informal matter. It is important to give them a comfortable space where they can speak up. Note their ideas down and discuss the same with them. They will feel valued, and the discussions will help provoke their thought process into creating something new.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن القيام بذلك من خلال اجتماعات غير رسمية، مما يسمح لكل موظف بالعصف الذهني وتقديم أفكارهم بطريقة غير رسمية. ومن المهم منحهم مساحة مريحة حيث يمكنهم التحدث. ويمكن تدوين أفكارهم ومناقشتها معهم، وبذلك سيشعرون بالتقدير وستساعد المناقشات في تعزيز عملية التفكير لديهم لخلق شيء جديد. "
      },
      {
        "language": "FR",
        "text": "Cela peut se faire par le biais de réunions informelles, ce qui permet à chaque employé de réfléchir et de présenter ses idées de manière informelle. Il est important de leur donner un espace confortable où ils peuvent s'exprimer. Leurs idées peuvent être écrites et discutées avec eux, Ils se sentiront valorisés, et les discussions aideront à provoquer leur processus de pensée en créant quelque chose de nouveau."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationTitle_4",
    "text": "Continuous innovation in the work environment.",
    "translations": [
      {
        "language": "AR",
        "text": "التجديد المستمر في بيئة العمل."
      },
      {
        "language": "FR",
        "text": "Innovation continue dans l'environnement de travail."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverRecommendationDesc_4",
    "text": "The work environment has a huge impact on creativity. Creating a flexible and comfortable workspace that does not resemble the design of the workplace but rather is closer to life outside the office can enhance creativity and inspires employees to create new innovative ideas and products.",
    "translations": [
      {
        "language": "AR",
        "text": "بيئة العمل لها تأثير كبير على الإبداع. حيث أن إنشاء مساحة للعمل، مرنة ومريحة ولا تشبه تصميم مكان العمل، بل تكون أقرب للحياة خارج المكتب، يمكن أن تعزز روح الإبداع ,تلهم الموظفين لابتكار أفكار ومنتجات جديدة."
      },
      {
        "language": "FR",
        "text": "L'environnement de travail a un impact énorme sur la créativité. L'environnement de travail a un impact énorme sur la créativité. Comme la création d'un espace de travail flexible et confortable ne ressemble pas à la conception du lieu de travail, mais est plutôt plus proche de la vie en dehors du bureau, elle peut renforcer l'esprit de créativité, incitant les employés à créer de nouvelles idées et de nouveaux produits."
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الابتكار:"
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverOtherRecommendation_1",
    "text": "Set annual budget for the required resources and enablers",
    "translations": [
      {
        "language": "AR",
        "text": "وضع موازنة سنوية للموارد والممكنات المطلوبة"
      },
      {
        "language": "FR",
        "text": "Établir un budget annuel pour les ressources et les catalyseurs nécessaires"
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverOtherRecommendation_2",
    "text": "Resources management training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب إدارة الموارد"
      },
      {
        "language": "FR",
        "text": "Programmes de formation en gestion des ressources"
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverOtherRecommendation_3",
    "text": "Strategic Innovation Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج الابتكار الاستراتيجي"
      },
      {
        "language": "FR",
        "text": "Programmes d'Innovation Stratégique"
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverOtherRecommendation_4",
    "text": "Building a Culture of Innovation",
    "translations": [
      {
        "language": "AR",
        "text": "بناء ثقافة الابتكار"
      },
      {
        "language": "FR",
        "text": "Construire une Culture de l'Innovation"
      }
    ]
  },
  {
    "key": "txtInnovationExtremeLowDriverOtherRecommendation_5",
    "text": "Workplace Diversity management Program",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج إدارة التنوع في مكان العمل"
      },
      {
        "language": "FR",
        "text": "Programme de gestion de la diversité en milieu de travail"
      }
    ]
  },
  {
    "key": "txtInnovationLowDriverReadings",
    "text": "These results indicate that the environment does not allow the employees to unleash creativity. When the Innovation driver is low, employees tend to refrain from transforming knowledge and ideas into new values and procedures.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج أن بيئة العمل لا تسمح للموظفين بإطلاق العنان للإبداع. عندما يكون دافع الابتكار منخفضاً، يميل الموظفون إلى الامتناع عن تحويل المعرفة والأفكار إلى قيم وإجراءات جديدة."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l’environnement ne permet pas aux employés de libérer la créativité et ne leur donne pas assez d’espace pour être créatifs et innovateurs. Par conséquent, ils s’abstiennent d’élaborer des idées sur de nouvelles valeurs et procédures."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverReadings",
    "text": "These results indicate that the environment gives the employees limited space to be creative and innovative in their work. Some of the employees feel like they can contribute to transforming ideas into new products and services, while some might need a little guidance and attention.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن بيئة العمل توفر مساحة محدودة للموظفين للإبداع والبتكار في العمل الذي يؤدونه، وبالتالي يشعر بعض الموظفين أنهم قادرون على المساهمة في تحويل الأفكار إلى قيم وإجراءات جديدة، بينما قد يحتاج البعض إلى القليل من التوجيه والاهتمام."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l'environnement donne aux employés un espace limité pour être créatifs et innovants dans leur travail. Ainsi, certains employés sentent qu'ils peuvent contribuer à transformer des idées en nouvelles valeurs et services, tandis que certains peuvent avoir besoin d'un peu de conseils et d'attention."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationBrief",
    "text": "These results may indicate potential vulnerabilities in the work environment in terms of not encouraging the employees enough to be more creative and innovative, which in turn affects employees' engagement. It is recommended to take immediate actions to motivate the employees to boost creativity. This can be done by accepting the ideas they propose and giving them space for improvement.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود ضعف محتمل في بيئة العمل من حيث عدم تشجيع الموظفين بالشكل الكافي ليكونوا أكثر إبداعاً وابتكاراً والذي يؤثر بدوره على اندماج الموظفين. ويجب اتخاذ إجراءات فورية من خلال تحفيز الموظفين لتعزيز الإبداع. ويمكن القيام بذلك عن طريق قبول الأفكار التي يقترحونها ومنحهم مساحة كافية للتحسين."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer des vulnérabilités potentielles dans l'environnement de travail en termes de ne pas encourager suffisamment les employés à être plus créatifs et innovants, ce qui affecte à son tour l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour motiver les employés à stimuler la créativité. Cela peut se faire en acceptant les idées qu’ils proposent et en leur donnant un espace d’amélioration."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationPointHeader",
    "text": "You can take the following actions. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Vous pouvez prendre les mesures suivantes. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationTitle_1",
    "text": "Reallocate resources required for Innovation.",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تخصيص الموارد المطلوبة للابتكار"
      },
      {
        "language": "FR",
        "text": "Réaffecter les ressources nécessaires ŕ l'innovation."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationDesc_1",
    "text": "The workplace may hold a lot more resources than you know. It is important to allocate these resources to their utmost efficiency to help drive Innovation from your employees and give them the access to those resources and encourage them to drive the change in the business.",
    "translations": [
      {
        "language": "AR",
        "text": "قد يتوفر في مكان العمل موارد أكثر بكثير مما تعرف. ويجب تخصيص هذه الموارد بأقصى قدر من الكفاءة للمساعدة في دفع الابتكار، ومنح الموظفين إمكانية الوصول إلى هذه الموارد وتشجيعهم على قيادة التغيير في العمل."
      },
      {
        "language": "FR",
        "text": "Votre lieu de travail peut avoir beaucoup plus de ressources que vous ne savez pas. Il est important d’allouer ces ressources à leur plus grande efficacité pour aider à stimuler l’innovation de vos employés et leur donner accès à ces ressources et les encourager à conduire le changement dans l’entreprise."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationTitle_2",
    "text": "Team Diversity.",
    "translations": [
      {
        "language": "AR",
        "text": "تنوع الفريق."
      },
      {
        "language": "FR",
        "text": "Diversité de l'Équipe."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationDesc_2",
    "text": "Building a diverse team with different experiences, skills, and thinking styles contributes to bringing new ideas that help educate individuals and develop their creative skills. This is reflected in providing a positive contribution to achieve business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "بناء فريق متنوع بخبرات ومهارات وأنماط تفكير مختلفة، يسهم في جلب أفكار جديدة تساعد في تعليم الأفراد وتطوير مهاراتهم الإبداعية، وينعكس ذلك بتقديم مساهمة إيجابية ومشتركة لتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "Construire une équipe diversifiée avec des expériences, des compétences et des styles de réflexion différents contribue à apporter de nouvelles idées qui aident à éduquer les individus et à développer leurs compétences créatives. Cela se traduit par une contribution positive à la réalisation des objectifs commerciaux."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationTitle_3",
    "text": "Motivate your employees to experiment with new ideas.",
    "translations": [
      {
        "language": "AR",
        "text": "تحفيز الموظفين لتجربة أفكار جديدة."
      },
      {
        "language": "FR",
        "text": "Motivez vos employés ŕ expérimenter de nouvelles idées."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationDesc_3",
    "text": "One of the best ways to do this is to eliminate the fear of failure that your employees may have. Make it clear to the employees that some progress is better than no progress at all and ensure that they will have the support regardless of the result.",
    "translations": [
      {
        "language": "AR",
        "text": "واحدة من أفضل الطرق للقيام بذلك هي القضاء على الخوف من الفشل الذي قد يكون لدى الموظفين. ربما يخشون أن يتركوا انطباعاً سيئاً عند مسؤولهم المباشر إذا فعلوا شيئاً خاطئاً، لذلك قرروا عدم القيام به. يجب التوضيح للموظفين بأن بعض التقدم أفضل من عدم إحراز أي تقدم على الإطلاق، وضمان حصولهم على الدعم بغض النظر عن النتيجة. "
      },
      {
        "language": "FR",
        "text": "L'un des meilleurs moyens d'y parvenir est d'éliminer la peur de l'échec que vos employés peuvent avoir. Expliquer clairement aux employés que certains progrès valent mieux que pas de progrès du tout. Et pour s'assurer qu'ils reçoivent un soutien quel que soit le résultat."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationTitle_4",
    "text": "Avoid penalizing employees.",
    "translations": [
      {
        "language": "AR",
        "text": "تجنب معاقبة الموظفين."
      },
      {
        "language": "FR",
        "text": "Éviter de punir les employés."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverRecommendationDesc_4",
    "text": "Many superiors tend to punish or discipline their employees for making mistakes when experimenting with new ideas. This is not the way to go. The recommended course of action is to show them how they can learn from those mistakes and understand why the mistake was made by going over the steps taken and directing them on how to fix it and avoid it next time.",
    "translations": [
      {
        "language": "AR",
        "text": "يميل العديد من المسؤولين المباشرين إلى معاقبة موظفيهم لارتكابهم أخطاء عند تجربة أفكار جديدة. هذه ليست الطريقة المناسبة للتعامل مع الأمر. الطريقة الموصى بها هي التوضيح لهم كيف يمكنهم التعلم من تلك الأخطاء، ومساعدتهم على فهم سبب حدوث الخطأ من خلال مراجعة الخطوات التي تم اتخاذها، وتوجيههم لإصلاحه وتجنبه في المرة القادمة. "
      },
      {
        "language": "FR",
        "text": "De nombreux supérieurs ont tendance à punir ou à discipliner leurs employés pour avoir commis des erreurs lorsqu'ils expérimentent de nouvelles idées. Ce n’est pas la voie à suivre. La marche à suivre recommandée est de leur montrer comment ils peuvent apprendre de ces erreurs et comprendre pourquoi l'erreur a été commise en passant en revue les mesures prises et en leur indiquant comment la corriger et l'éviter la prochaine fois."
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الابتكار:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverOtherRecommendation_1",
    "text": "Resources management skills programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب إدارة الموارد"
      },
      {
        "language": "FR",
        "text": "Programmes de formation en gestion des ressources"
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverOtherRecommendation_2",
    "text": "Strategic Innovation Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج الابتكار الاستراتيجي"
      },
      {
        "language": "FR",
        "text": "Programmes d'Innovation Stratégique"
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverOtherRecommendation_3",
    "text": "Building a Culture of Innovation",
    "translations": [
      {
        "language": "AR",
        "text": "بناء ثقافة الابتكار"
      },
      {
        "language": "FR",
        "text": "Construire une Culture de l'Innovation"
      }
    ]
  },
  {
    "key": "txtInnovationModerateDriverOtherRecommendation_4",
    "text": "Workplace Diversity management Program",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج إدارة التنوع في مكان العمل"
      },
      {
        "language": "FR",
        "text": "Programme de gestion de la diversité en milieu de travail"
      }
    ]
  },
  {
    "key": "txtInnovationEngagedLowDriverReadings",
    "text": "These results indicate that the work environment is somehow limiting the employees to be creative and innovative in the work they perform, leading to better performance. Thus, it enables the employees to transform ideas into new products and services.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن بيئة العمل تسمح للموظفين حد معين للإبداع في العمل الذي يؤدونه مما يؤدي إلى أداء أفضل، وبالتالي تمكين الموظفين من تحويل الأفكار إلى قيم وإجراءات جديدة. "
      }
    ]
  },
  {
    "key": "txtInnovationHighDriverReadings",
    "text": "These results indicate that the work environment gives space for its employees to unleash creativity into the work they perform, leading to better performance. Thus, it enables the employees to transform ideas into new products and services.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن بيئة العمل توفر مساحة للموظفين للإبداع في العمل الذي يؤدونه مما يؤدي إلى أداء أفضل، وبالتالي تمكين الموظفين من تحويل الأفكار إلى قيم وإجراءات جديدة."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l’environnement de travail donne à ses employés l’espace pour libérer la créativité dans le travail qu’ils exécutent, menant à une meilleure exécution. Ainsi, il permet aux employés de transformer les idées en nouveaux produits et services."
      }
    ]
  },
  {
    "key": "txtInnovationHighDriverRecommendationBrief",
    "text": "Innovation is considered one of the main strengths of the work environment. It plays a role in enhancing employees’ creativity and increasing productivity. It is recommended to continue providing a work environment that supports innovation and creativity by encouraging the employees to adopt new creative methods at work and nurturing the current innovative spirit that drives the employees to think out of the box to contribute to the development of the work and achieve the goals.",
    "translations": [
      {
        "language": "AR",
        "text": "يُعدّ الابتكار أحد نقاط القوة الأساسية في بيئة العمل، لما له من دور في تعزيز إبداع الموظفين وزيادة إنتاجيتهم. ويوصى بالاستمرار في توفير بيئة عمل داعمة للابتكار والإبداع من خلال تشجيع الموظفين على تبني أساليب إبداعية جديدة في العمل، وتغذية روح الابتكار الحالية التي تدفع الموظفين إلى التفكير خارج الصندوق للمساهمة في تطوير العمل وتحقيق أهدافه."
      },
      {
        "language": "FR",
        "text": "L’innovation est considérée comme l’une des principales forces de l’environnement de travail. Il joue un rôle dans l’amélioration de la créativité et de la productivité des employés. Il est recommandé de continuer à offrir un milieu de travail qui favorise l’innovation et la créativité en encourageant les employés à adopter de nouvelles méthodes créatives au travail et en favorisant l’esprit d’innovation actuel qui pousse les employés à sortir des sentiers battus pour contribuer à la développement du travail et atteindre les objectifs."
      }
    ]
  },
  {
    "key": "txtInnovationHighDriverRecommendationPointHeader",
    "text": "",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtInnovationExtremeHighDriverReadings",
    "text": "These results indicate that the work environment is truly driven by innovation, where employees are consistently being supported to be creative in transforming knowledge and ideas into new products and services.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن بيئة العمل مهتمة بشكل كبير بالابتكار حيث يتم دعم الموظفين وإلهامهم باستمرار ليكونوا مبدعين في تحويل المعرفة والأفكار إلى قيم وإجراءات جديدة."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l'environnement de travail est vraiment axé sur l’innovation, où les employés sont constamment encouragés à faire preuve de créativité dans la transformation des connaissances et des idées en nouveaux produits et services."
      }
    ]
  },
  {
    "key": "txtMotivationDriverDesc",
    "text": "The positive relationship between Motivation and Engagement is measured by the reward and recognition programs offered to the employees. The employees who are rewarded and recognized for the excellent work they do; show an increase in their productivity and contribution to achieve business goals. Therefore, this type of employee must be retained for their effective role in improving the workplace environment and performance.",
    "translations": [
      {
        "language": "AR",
        "text": "تقاس العلاقة الإيجابية بين التحفيز واندماج الموظفين بالمكافآت وبرامج التقدير المقدمة للموظفين. فالموظفون الذين يتم مكافأتهم وتقديرهم على العمل الجيد الذي يقومون به، لديهم زيادة في الإنتاجية ويبذلون جهداً إضافياً لتحقيق أهداف العمل. وبالتالي يجب المحافظة على هذه الفئة من الموظفين لما لهم من دور فعال في تحسين بيئة وأداء العمل."
      },
      {
        "language": "FR",
        "text": "La relation positive entre la motivation et l'engagement est mesurée par les programmes de récompense et de reconnaissance offerts aux employés. Les employés récompensés et reconnus pour l'excellent travail qu'ils accomplissent; montrent une augmentation de leur productivité et de leur contribution à l'atteinte des objectifs commerciaux. Par conséquent, ce type d'employé doit être retenu pour son rôle efficace dans l'amélioration de l'environnement de travail et de la performance."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverReadings",
    "text": "This analysis demonstrates that your employees are demotivated and do not feel like doing the work expected of them. They are lowly engaged with their job, and they do not feel sufficiently appreciated and rewarded for their work, and they may look for opportunities in a better work environment.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج بأن الموظفين محبطون ولا يبدون أي رغبة في القيام بالعمل الموكل إليهم. وقد يكون السبب عدم شعورهم بالتقدير الكافي لأعمالهم ومكافأتهم عليها. وبالتالي هنالك احتمالية لجوئهم للبحث عن فرص في بيئة عمل أفضل."
      },
      {
        "language": "FR",
        "text": "Cette analyse démontre que vos employés sont démotivés et n'ont pas envie de faire le travail qu'on attend d'eux. Ils sont peu engagés dans leur travail et ne se sentent pas suffisamment appréciés et récompensés pour leur travail. Par conséquent, il est possible qu'ils recherchent des opportunités dans un meilleur environnement de travail."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationBrief",
    "text": "These results may indicate a high degree of risk in the motivation and recognition programs, which in turn affects employees' engagement. It is recommended to take immediate and rapid actions to motivate your employees, reward them for their effort, and thus contribute to increase their productivity and achieve business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج لوجود درجة عالية من الخطورة في برامج التحفيز والتقدير والتي تؤثر بدورها على اندماج الموظفين. ويجب اتخاذ إجراءات فورية وسريعة بتطبيق وتنفيذ برامج التقدير والمكافأة للموظفين لزيادة تحفيزهم والمساهمة في رفع إنتاجيتهم لتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer un degré élevé de risque dans les programmes de motivation et de reconnaissance, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour motiver vos employés, les récompenser pour leurs efforts et ainsi contribuer à accroître leur productivité et à atteindre les objectifs de l’entreprise. Vous pouvez prendre les mesures suivantes pour améliorer la motivation. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationPointHeader",
    "text": "You can take the following actions to improve motivation. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل التحفيز:"
      },
      {
        "language": "FR",
        "text": "Vous pouvez prendre les mesures suivantes. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationTitle_1",
    "text": "Recognize your employees' contribution and success.",
    "translations": [
      {
        "language": "AR",
        "text": "تقدير عمل الموظفين ومكافأتهم على جهدهم الإضافي."
      },
      {
        "language": "FR",
        "text": "Reconnaissez la contribution et le succčs de vos employés."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationDesc_1",
    "text": "Employees tend to be more motivated and achieve better results when they know that they will be recognized for it. When they contribute something unexpected, thank them and let them know that they are always welcomed to do so. Congratulate them on their successes, even when it is not directly related to your company. Their success should be your success.",
    "translations": [
      {
        "language": "AR",
        "text": "يميل الموظفون إلى العمل الجاد وتحقيق نتائج أفضل في حال تم تقدير عملهم ومكافأتهم لبذل مجهود إضافي. عندما يساهمون بشيء غير متوقع، يجب تقديرهم وثناءهم على قيامهم بذلك ويجب تهنئتهم على نجاحاتهم ولو لم تكن مرتبطة بشكل مباشر بالعمل. فنجاح الموظفين هو نجاح العمل."
      },
      {
        "language": "FR",
        "text": "Les employés ont tendance à être plus motivés et accomplir de meilleurs résultats quand ils savent qu'ils seront reconnus pour cela. Lorsqu'ils apportent quelque chose d'inattendu, remerciez-les et faites-leur savoir qu'ils sont toujours les bienvenus. Félicitez-les pour leurs succès, même lorsqu'ils ne sont pas directement liés à votre entreprise. Leur succès doit être votre succès."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationTitle_2",
    "text": "Implement non-monetary recognition programs.",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير برامج التقدير غير النقدية."
      },
      {
        "language": "FR",
        "text": "Mettre en śuvre des programmes de reconnaissance non monétaire."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationDesc_2",
    "text": "It is important to implement non-monetary recognition programs to praise employees’ efforts and motivate them to achieve the best. Examples of non-monetary recognition programs: Employee of the month, awards and appreciation certificates, work anniversaries celebration, and more.",
    "translations": [
      {
        "language": "AR",
        "text": "أهمية تطبيق برامج التقدير غير النقدية كثناء على جهد الموظفين المبذولة وتحفيزهم على إنجاز الأفضل. ومن هذه البرامج: برامج تقدير الموظفين (الموظف المبدع والموظف المثالي)، جوائز وشهادات تقديرية، احتفالات الذكرى السنوية للعمل، وغيرها."
      },
      {
        "language": "FR",
        "text": "Il est important de mettre en œuvre des programmes de reconnaissance non monétaire pour saluer les efforts des employés et les motiver à réaliser le meilleur. Exemples de programmes de reconnaissance non monétaire: L'employé du mois, prix et les certificats d'appréciation, la célébration d'anniversaires de travail et plus."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationTitle_3",
    "text": "Reward your employees for that extra mile.",
    "translations": [
      {
        "language": "AR",
        "text": "تقديم مكافآت نقدية للموظفين."
      },
      {
        "language": "FR",
        "text": "Récompensez vos employés pour cet effort supplémentaire."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationDesc_3",
    "text": "Rewards are considered one of the most important ways to motivate employees. Providing rewards to the employees is essential and highly recommended when introducing new ideas to improve work and achieve goals. You can reward them through salary increases, bonuses, commissions, paid training, and so much more.",
    "translations": [
      {
        "language": "AR",
        "text": "تعد المكافآت من أهم الطرق التحفيزية للموظفين، ففي حال نجاح الموظفين في طرح أفكار جديدة هادفة إلى تحسين العمل ونجاحه، يصبح تقديم المكافأة أمر ضروري ليشعر الموظفين بأهمية ما قدموه وسيدفعهم لتقديم المزيد. ويمكن مكافأتهم من خلال زيادة الرواتب وحوافز سنوية وعمولات وغيرها."
      },
      {
        "language": "FR",
        "text": "Les récompenses sont considérées comme l'un des moyens les plus importants de motiver les employés. Offrir des récompenses aux employés est essentiel et fortement recommandé lors de l'introduction de nouvelles idées pour améliorer le travail et atteindre les objectifs. Vous pouvez les récompenser par des augmentations de salaire, des primes, des commissions, des formations rémunérées et bien plus encore."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationTitle_4",
    "text": "Introduce team-building activities.",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق أنشطة بناء الفريق."
      },
      {
        "language": "FR",
        "text": "Introduisez des activités de consolidation d'équipe."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverRecommendationDesc_4",
    "text": "Build a collaborative workplace, enhance team spirit by implementing team-building activities, and conduct workshops to improve employee engagement and collaboration and achieve work goals.",
    "translations": [
      {
        "language": "AR",
        "text": " نشر ثقافة التعاون وروح الفريق في بيئة العمل من خلال تطبيق بعض أنشطة بناء الفريق وورش عمل مختلفة لما لها من أهمية في تعزيز الاندماج وتقديم التعاون لتحقيق الأهداف المشتركة. "
      },
      {
        "language": "FR",
        "text": "Créez un lieu de travail collaboratif, améliorez l'esprit d'équipe en mettant en œuvre des activités de consolidation d'équipe et organisez des ateliers pour améliorer l'engagement et la collaboration des employés et atteindre les objectifs de travail."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverOtherRecommendation_1",
    "text": "Teamwork and team leadership training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب العمل الجماعي وقيادة الفريق"
      },
      {
        "language": "FR",
        "text": "Des programmes de formation sur le travail d'équipe et le leadership d'équipe."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverOtherRecommendation_2",
    "text": "Compensation & Benefits Programs Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير برامج التعويضات والمزايا"
      },
      {
        "language": "FR",
        "text": "Développement de programmes de rémunération et d'avantages sociaux."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverOtherRecommendation_3",
    "text": "Motivation and Recognition Programs Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير برامج التقدير والتحفيز"
      },
      {
        "language": "FR",
        "text": "Développement de programmes de motivation et de reconnaissance."
      }
    ]
  },
  {
    "key": "txtMotivationExtremeLowDriverOtherRecommendation_4",
    "text": "Set plans for team-building activities",
    "translations": [
      {
        "language": "AR",
        "text": "وضع خطط لأنشطة بناء وتعزيز روح الفريق"
      },
      {
        "language": "FR",
        "text": "Établir des plans pour les activités de consolidation d'équipe."
      }
    ]
  },
  {
    "key": "txtMotivationLowDriverReadings",
    "text": "This analysis demonstrates the fact that your employees are demotivated and only do the work expected from them. They seem to be lowly engaged with their job, and they do not feel sufficiently appreciated and rewarded for their work.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج بأن الموظفين محبطين وينجزون فقط ما يوكل إليهم من المهام بالحد الأدنى، ولا يظهرون أية دوافع للقيام بأكثر من ذلك. وقد يكون السبب عدم شعورهم بالتقدير الكافي لأعمالهم ومكافأتهم عليها."
      },
      {
        "language": "FR",
        "text": "Cette analyse démontre le fait que vos employés sont démotivés et ne font que le travail attendu d'eux. Et ils ne montrent aucune motivation pour faire plus que cela. La raison peut être qu'ils ne se sentent pas suffisamment appréciés et récompensés pour leur travail."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverReadings",
    "text": "This analysis demonstrates that your employees are motivated enough to do what is expected of them. But there is a chance for better effort if they receive more appreciation and recognition for their work.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج بأن الموظفين لديهم الحد الأدنى من الحافز للقيام بما هو متوقع منهم، ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ومكافأتهم بشكل أكثر."
      },
      {
        "language": "FR",
        "text": "Cette analyse démontre que vos employés sont suffisamment motivés pour faire ce que l'on attend d'eux. Mais il y a une chance pour un meilleur effort s’ils reçoivent plus d’appréciation et de reconnaissance pour leur travail."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationBrief",
    "text": "These results may indicate potential vulnerabilities in the motivation and recognition programs, which in turn affects employees' engagement. It is recommended to take immediate actions to motivate your employees by recognizing their contribution and success.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود ضعف محتمل في برامج التحفيز والتقدير والتي تؤثر بدورها على اندماج الموظفين. ويوصى هنا بإتخاذ إجراءات تهدف لتحفيز الموظفين بشكل أكبر من خلال تقدير جهودهم المبذولة ومكافأتهم على ذلك."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer des vulnérabilités potentielles dans les programmes de motivation et de reconnaissance, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour motiver vos employés en reconnaissant leur contribution et leur réussite."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationPointHeader",
    "text": "You can take the following actions to improve motivation. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Vous pouvez prendre les mesures suivantes pour améliorer la motivation. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationTitle_1",
    "text": "Implement attractive compensation programs.",
    "translations": [
      {
        "language": "AR",
        "text": "تنفيذ برامج تعويضات جاذبة."
      },
      {
        "language": "FR",
        "text": "Mettre en śuvre des programmes de rémunération attrayants."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationDesc_1",
    "text": "One of many ways to motivate and retain your key talent is compensation programs. In addition to the wage your employees are receiving on a monthly basis, the allowances, benefits, annual incentives, and more are recommended to motivate them to achieve the desired success.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "تعد برامج التعويضات إحدى أهم الطرق المتعددة لتحفيز المواهب والكفاءات والاحتفاظ بها. فبالإضافة للأجر الذي يتقاضاه الموظفون بشكل ثابت وشهري، ينصح بصرف بدلات، ومزايا، وحوافز سنوية لدفعهم لتقديم جهد أفضل لتحقيق النجاح المرجو."
      },
      {
        "language": "FR",
        "text": "Les programmes de rémunération sont l'une des nombreuses façons de motiver et de fidéliser vos talents clés. Outre le salaire que vos employés reçoivent chaque mois, les indemnités, avantages sociaux, primes annuelles, etc. sont recommandés pour les motiver à atteindre le succès souhaité."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationTitle_2",
    "text": "Convert your employees' tasks into small, measurable goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تحويل مهام الموظفين إلى أهداف صغيرة قابلة للقياس."
      },
      {
        "language": "FR",
        "text": "Transformez les tâches de vos employés en petits objectifs mesurables."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationDesc_2",
    "text": "Although employees may not always feel demotivated, they may think that their tasks exceed their capabilities and are challenging to accomplish. It is important to assist them and show them how to break tasks into smaller and easier tasks to achieve goals.",
    "translations": [
      {
        "language": "AR",
        "text": "قد يشعر بعض الموظفين بأن ما يوكل إليهم من مهام تفوق قدراتهم ويصعب تنفيذها، ويجب في هذه الحالة توجيه الموظفين لطرق إتمامها والتعامل من خلال تجزئتها إلى مهام أصغر وبالتالي سهولة تنفيذها."
      },
      {
        "language": "FR",
        "text": "Bien que les employés ne se sentent pas toujours démotivés, ils peuvent penser que leurs tâches dépassent leurs capacités et sont difficiles à accomplir. Il est important de les aider et de leur montrer comment décomposer les tâches en tâches plus petites et plus faciles pour atteindre leurs objectifs."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationTitle_3",
    "text": "Celebrate the results your employees bring to you.",
    "translations": [
      {
        "language": "AR",
        "text": "تقدير النتائج التي يحققها الموظفين."
      },
      {
        "language": "FR",
        "text": "Célébrer les résultats que vos employés vous apportent."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationDesc_3",
    "text": "Pay attention to the work that they do and appreciate the effort that has been put into it. You can motivate them to \"keep up the good work.”\n  Motivation & recognition help in enhancing the overall team spirit and building a collaborative workplace where employees feel more committed to the work.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب تقدير العمل الذي يقوم به الموظفين والجهد الذي تم بذله لإتمامه وتحفيزهم لمواصلة العمل الجيد بكفاءة. فالتقدير يُعزز روح الفريق ويبني بيئة عمل متعاونة حيث يشعر الموظفون بمزيد من الالتزام تجاه العمل. "
      },
      {
        "language": "FR",
        "text": "Faites attention au travail qu'ils font et appréciez les efforts qui y ont été consacrés. Vous pouvez les motiver à continuer le bon travail. La motivation et la reconnaissance contribuent à renforcer l'esprit d'équipe général et à créer un lieu de travail collaboratif où les employés se sentent plus engagés dans le travail."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationTitle_4",
    "text": "Change of scenery.",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير مكان العمل."
      },
      {
        "language": "FR",
        "text": "Changement de lieu."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverRecommendationDesc_4",
    "text": "Sometimes the office may feel a little pressuring to your employees, and a constricting and unchanging environment places a block on their performance. A change in place or working outside once in a while can help with mindfulness.",
    "translations": [
      {
        "language": "AR",
        "text": "في بعض الأحيان قد يشعر الموظفين ببعض الضغط بالعمل داخل المكتب، وتضع البيئة المقيدة وغير المتغيرة عائقاً أمام أدائهم. تغيير مكان العمل أو العمل بالخارج من حين لآخر يساعد في زيادة التركيز في العمل."
      },
      {
        "language": "FR",
        "text": "Parfois, le bureau peut ressentir un peu de pression sur vos employés, et un environnement contraignant et immuable bloque leur performance. Un changement de place ou un travail à l'extérieur de temps en temps peut aider à la pleine conscience."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverOtherRecommendation_1",
    "text": "Teamwork and Team Leadership Training Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب العمل الجماعي وقيادة الفريق"
      },
      {
        "language": "FR",
        "text": "Des programmes de formation sur le travail d'équipe et le leadership d'équipe."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverOtherRecommendation_2",
    "text": "Compensation & Benefits Programs Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير برامج التعويضات والمزايا"
      },
      {
        "language": "FR",
        "text": "Développement de programmes de rémunération et d'avantages sociaux."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverOtherRecommendation_3",
    "text": "Motivation and Recognition Programs Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير برامج التقدير والتحفيز"
      },
      {
        "language": "FR",
        "text": "Développement de programmes de motivation et de reconnaissance."
      }
    ]
  },
  {
    "key": "txtMotivationModerateDriverOtherRecommendation_4",
    "text": "Set plans for team-building activities",
    "translations": [
      {
        "language": "AR",
        "text": "وضع خطط لأنشطة بناء وتعزيز روح الفريق"
      },
      {
        "language": "FR",
        "text": "Établir des plans pour les activités de consolidation d'équipe."
      }
    ]
  },
  {
    "key": "txtMotivationEngagedLowDriverReadings",
    "text": "The analysis demonstrates that your employees are motivated enough to do more than what is expected of them as you reward and recognize their work. But there is a chance for better effort if they receive more appreciation and recognition for their work.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج بأن الموظفين لديهم الحافز الكافي للقيام بأكثر مما هو متوقع منهم نتيجة لمكافئتهم على عملهم وتقديرهم. ولكن هنالك مجال لبذل مجهود أفضل في حال تم تقدير عملهم ومكافأتهم بشكل أكبر."
      }
    ]
  },
  {
    "key": "txtMotivationHighDriverReadings",
    "text": "The analysis demonstrates that your employees are motivated to do more than what is expected of them as you reward and recognize their work. And continuing to appreciate them will contribute to accomplishing more achievements and successes.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج بأن الموظفين لديهم الحافز للقيام بأكثر مما هو متوقع منهم نتيجة لمكافئتهم على عملهم وتقديرهم، واستمرارية تقديرهم ستسهم في تحقيق إنجازات ونجاحات أكثر."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que vos employés sont motivés à faire plus que ce que l'on attend d'eux lorsque vous récompensez et reconnaissez leur travail. Et continuer à les apprécier contribuera à accomplir plus de réalisations et de succès."
      }
    ]
  },
  {
    "key": "txtMotivationHighDriverRecommendationBrief",
    "text": "Your company is highly engaged in terms of Motivation. It is highly recommended to continue implementing the recognition and reward programs for the employees' efforts in accomplishing their work.\n  The attractive reward programs attract and retain top talents and increase their productivity to achieve business goals.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "يتضح من النتائج بأن الاندماج الوظيفي المرتفع هنا نتيجة لتحفيز الموظفين وتقديرهم. ويوصى بالاستمرار بتطبيق وتنفيذ برامج التقدير والمكافأة للموظفين لجهودهم المبذولة وتحفيزهم. ويجدر بالذكر أن برامج المكافآت الجاذبة تسهم في استقطاب والمحافظة على المواهب والكفاءات ورفع إنتاجيتها وبالتالي المساهمة بتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "Votre société est très engagée en termes de motivation. Il est fortement recommandé de continuer à mettre en œuvre les programmes de reconnaissance et de récompense pour les efforts déployés par les employés dans l’accomplissement de leur travail. Les programmes de récompense attrayants attirent et retiennent les meilleurs talents et augmentent leur productivité pour atteindre leurs objectifs d’affaires."
      }
    ]
  },
  {
    "key": "txtMotivationHighDriverRecommendationPointHeader",
    "text": "",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtMotivationExtremeHighDriverReadings",
    "text": "The analysis demonstrates that your employees are driven to do more than what is expected of them as you reward and recognize their work. And thus, they will continue to outperform in the tasks given to them and to accomplish more achievements and successes.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج بأن الموظفين لديهم الدافع الكافي للقيام بأكثر مما هو متوقع منهم نتيجة لمكافئتهم على عملهم وتقديرهم المستمر، وبالتالي سيواصلون التفوق في المهام الموكلة إليهم وتحقيق إنجازات ونجاحات أكثر."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que vos employés sont motivés à faire plus que ce que l'on attend d'eux alors que vous récompensez et reconnaissez leur travail. Et ainsi, ils continueront de surpasser les tâches qui leur sont confiées et d'accomplir plus de réalisations et de succès."
      }
    ]
  },
  {
    "key": "txtPerformanceDriverDesc",
    "text": "The positive relationship between Performance and Engagement is measured in terms of growth and learning. When employees feel like they can grow professionally and personally as well as develop in their workplace, they are more likely to engage and drive the level of performance to achieve business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تقاس العلاقة الإيجابية بين الأداء واندماج الموظفين بمستوى النمو والتعلم المقدمين للموظفين. فعندما يشعر الموظفون أنهم قادرون على النمو مهنياً وشخصياً بالإضافة إلى إمكانية تطورهم في مكان عملهم، فمن المرجح أن يقدموا مستويات أعلى من الأداء للمشاركة في إنجاز الأعمال والمهام لتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "La relation positive entre la performance et l'engagement se mesure en termes de croissance et d'apprentissage. Lorsque les employés sentent qu'ils peuvent évoluer professionnellement et personnellement ainsi que se développer sur leur lieu de travail, ils sont plus susceptibles de s'engager et de stimuler le niveau de performance pour atteindre les objectifs de l'entreprise."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverReadings",
    "text": "These results indicate that the workplace is unable to generate enough productivity from the employees, and they may need more space and encouragement to grow. There may be some constraints to develop any skills to perform their tasks, which affects their performance and the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين لا يقدمون الحد الأدنى من مستوى الأداء المطلوب لإنجاز المهام والأعمال الموكلة، وبالتالي يشكلون عائقاً أمام تحقيق إنتاجية العمل المطلوبة، وقد تكون هناك بعض القيود التي لا تمكنهم من تطوير مهاراتهم مما يؤثر على أدائهم وإنتاجية العمل. وهذا دليل واضح على حاجة الموظفين الماسة للتوجيه والتدريب لتطورهم ونموهم مهنياً وشخصياً."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que le milieu de travail n’est pas en mesure de générer une productivité suffisante de la part des employés qu'ils peuvent avoir besoin de plus d'espace et d'encouragements pour se développer.  Il peut y avoir certaines contraintes pour développer des compétences pour accomplir leurs tâches, ce qui affecte et le lieu de travail. "
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationBrief",
    "text": "These results may indicate a high degree of risk in the level of performance, which in turn affects employees' engagement. It is recommended to take immediate and rapid actions to encourage employees to learn new skills and gain knowledge to grow professionally and personally. Also provides the necessary training programs to fill the gap between the current level of performance and the desired level.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة في مستوى الأداء الذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة تطبيق إجراءات فورية لتشجيع الموظفين على التعلم وكسب المهارات التي ستساعدهم على نموهم مهنياً وشخصياً. وضرورة تقديم برامج التدريب اللازمة لسد الفجوة بين مستوى الأداء الحالي والمستوى المنشود."
      },
      {
        "language": "FR",
        "text": "Parfois, le bureau peut ressentir un peu de pression sur vos employés, et un environnement contraignant et immuable bloque leur performance. Un changement de place ou un travail à l'extérieur de temps en temps peut aider à la pleine conscience."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationPointHeader",
    "text": "The following actions need to be taken to improve. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer un degré élevé de risque dans le niveau de performance, qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour encourager les employés à acquérir de nouvelles compétences et à acquérir des connaissances pour se développer professionnellement et personnellement. Fournit également les programmes de formation nécessaires pour combler l’écart entre le niveau actuel de rendement et le niveau souhaité."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationTitle_1",
    "text": "Support the growth of employees professionally and personally.",
    "translations": [
      {
        "language": "AR",
        "text": "دعم نمو الموظفين مهنياً وشخصياً."
      },
      {
        "language": "FR",
        "text": "Soutenir la croissance des employés professionnellement et personnellement."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationDesc_1",
    "text": "Employees' personal growth is just as important as their professional growth and plays a vital role in their performance. Therefore, employees must be encouraged to learn skills that can be used at work and off-work, which would give them a great sense of accomplishment. Those skills may include persuasion, negotiation, budgeting, and more.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يقل النمو الشخصي للموظفين أهمية عن نموهم المهني ويلعب دوراً حيوياً في أدائهم. و يجب تشجيع الموظفين على تعلم المهارات التي يمكنهم استخدامها في العمل وخارجه، مما يمنحهم إحساساً كبيراً بالإنجاز. قد تشمل هذه المهارات: مهارات التعامل مع الآخرين، مهارات المفاوضة والإقناع، مهارات الابتكار، وغيرها."
      },
      {
        "language": "FR",
        "text": "La croissance personnelle des employés est tout aussi importante que leur croissance professionnelle et joue un rôle essentiel dans leur performance. Les employés doivent être encouragés à acquérir des compétences qui peuvent être utilisées au travail et en dehors du travail, ce qui leur donnerait un grand sentiment d’accomplissement. Ces compétences peuvent inclure la persuasion, la négociation, la budgétisation, etc."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationTitle_2",
    "text": "Provide necessary training needed in specific roles.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير التدريب اللازم في أدوار محددة."
      },
      {
        "language": "FR",
        "text": "Fournir la formation nécessaire dans des rôles spécifiques."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationDesc_2",
    "text": "It is important to recognize the fact that different training programs are created for different purposes, and they should not apply to all employees in general. Instead, have employees in specific roles get the training they need to perform well in their field rather than wasting resources on training them for something they may not find useful, motivating, or have the ability to use in their field.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إدراك حقيقة أن برامج التدريب المختلفة يتم إنشاؤها لأغراض مختلفة، ولا ينبغي أن تنطبق على جميع الموظفين بشكل عام. وعليه، يجب توفير برامج التدريب بحسب حاجة الموظفين لتقديم أداء جيد في مجالهم بدلاً من إهدار الموارد في تدريبهم على مهارات غير مفيدة ولا يمكن استخدامها وتطبيقها في مجال عملهم."
      },
      {
        "language": "FR",
        "text": "Il est important de reconnaître le fait que différents programmes de formation sont créés à des fins différentes et qu’ils ne devraient pas s’appliquer à tous les employés en général. Demandez plutôt aux employés occupant des rôles spécifiques d'obtenir la formation dont ils ont besoin pour bien performer dans leur domaine plutôt que de gaspiller des ressources sur leur formation pour quelque chose qu’ils peuvent ne pas trouver utile, motivant, ou qu'ils n'ont pas la capacité d'utiliser dans leur domaine."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationTitle_3",
    "text": "Make learning and development a part of the mission.",
    "translations": [
      {
        "language": "AR",
        "text": "دعم التعليم والتطوير ليصبح جزءاً من مهمة العمل."
      },
      {
        "language": "FR",
        "text": "Faire de l’apprentissage et du développement une partie de la mission."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationDesc_3",
    "text": "It is very important to make learning and development part of the business mission and goals and one of the top priorities by developing policies and procedures that ensure training and development opportunities for employees' career progression. The investment in the development of Human capital will lead to productive results that will help in achieving the business mission.",
    "translations": [
      {
        "language": "AR",
        "text": "من المهم جداً، جعل التعلم والتطور جزء من أهداف ومهمة العمل و إحدى أولوياته، وذلك من خلال تطوير السياسات والإجراءات التي تضمن توفير فرص تدريب وتطوير للموظفين وبالتالي تقدمهم مهنياً. فرأس المال البشري والاستثمار في تنميته سيؤديان إلى نتائج مثمرة تساعد في تحقيق الأهداف المرجوة."
      },
      {
        "language": "FR",
        "text": "Il est très important de faire de l’apprentissage et du perfectionnement une partie de la mission et des objectifs de l’entreprise et l’une des principales priorités en élaborant des politiques et des procédures qui garantissent des opportunités de formation et de développement pour la progression de carrière des employés. L’investissement dans le développement du capital humain conduira à des résultats productifs qui aideront à atteindre la mission d’affaires."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationTitle_4",
    "text": "Provide good opportunities for career progression.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير فرص جيدة للتقدم الوظيفي."
      },
      {
        "language": "FR",
        "text": "Fournir de bonnes opportunités ŕ la progression de carričre."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverRecommendationDesc_4",
    "text": "Career progression plans must be implemented for the employees and communicated with them. The employee should be directed and mentored by conducting different evaluations to improve their performance and enhance work productivity.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "يجب تطبيق خطط للتقدم الوظيفي ومشاركتها مع الموظفين. ويجب توجيه وإرشاد الموظفين من خلال التقييمات والتي بدورها تعتبر وسيلة متميزة لتحسين أدائهم وتعزيز إنتاجيتتهم في العمل. "
      },
      {
        "language": "FR",
        "text": "Les plans de progression de carrière doivent être mis en œuvre pour les employés et communiqués avec eux. L'employé doit être dirigé et encadré en effectuant différentes évaluations pour améliorer ses performances et accroître sa productivité au travail."
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الأداء:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendation_1",
    "text": "Prepare career development plans",
    "translations": [
      {
        "language": "AR",
        "text": "وضع خطط واضحة للتطور الوظيفي"
      },
      {
        "language": "FR",
        "text": "Préparer des plans de développement de carričre"
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendation_2",
    "text": "Prepare training plans and the personal development plans",
    "translations": [
      {
        "language": "AR",
        "text": "وضع خطة التدريب السنوية بالإضافة إلى خطط التطوير الفردي للموظفين"
      },
      {
        "language": "FR",
        "text": "Préparer les plans de formation et les plans de développement personnel"
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendation_3",
    "text": "Set annual budget for training and development",
    "translations": [
      {
        "language": "AR",
        "text": "وضع موازنة سنوية للتدريب والتطوير"
      },
      {
        "language": "FR",
        "text": "Établir un budget annuel pour la formation et le développement"
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendation_4",
    "text": "Performance Framework Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير برامج تقييم الأداء"
      },
      {
        "language": "FR",
        "text": "Développement du cadre de performance"
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendation_5",
    "text": "Conduct 360-degree Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق تقييم 360°"
      },
      {
        "language": "FR",
        "text": "Effectuer une évaluation ŕ 360 degrés"
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendation_6",
    "text": "Building and Managing Teams Training Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريبية لبناء وإدارة فريق العمل"
      },
      {
        "language": "FR",
        "text": "Création et gestion des programmes de formation des équipes"
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeLowDriverOtherRecommendation_7",
    "text": "Review and upgrade the automation systems",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة وتحديث أنظمة الأتمتة"
      },
      {
        "language": "FR",
        "text": "Examiner et mettre ŕ niveau les systčmes d’automatisation"
      }
    ]
  },
  {
    "key": "txtPerformanceLowDriverReadings",
    "text": "The results indicate that employees are not providing a sufficient level of performance in completing the assigned activities and tasks, and thus they do not contribute to achieving work productivity at the minimum required level. This indicates that the employees may need continuous assistance and more encouragement to grow and develop professionally and personally.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين لا يقدمون المستوى الكافي من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي لا يسهمون في تحقيق إنتاجية العمل بالدرجة المطلوبة. وهذا دليل على حاجة الموظفين للدعم المستمر والمساعدة في عملهم من خلال التوجيه والتدريب اللازمين لتطورهم ونموهم مهنياً وشخصياً."
      },
      {
        "language": "FR",
        "text": "Les résultats indiquent que les employés n’offrent pas un niveau de rendement suffisant pour accomplir les activités et les tâches assignées et qu’ils ne contribuent donc pas à atteindre la productivité au travail au niveau minimum requis. Cela indique que les employés peuvent avoir besoin d'une assistance continue et de plus d'encouragements pour grandir et se développer professionnellement et personnellement."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverReadings",
    "text": "The results indicate that employees are providing an average level of performance in completing the assigned activities and tasks, and thus they contribute to achieving work productivity at the minimum required level. This indicates that the employees may need more guidance and training to complete their work.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين يقدمون مستوى معتدل من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بالدرجة المطلوبة بالحد الأدنى. وقد يشير ذلك إلى حاجة الموظفين إلى مزيد من المساعدة في عملهم من خلال التوجيه والتدريب اللازمين لإتمام أعمالهم."
      },
      {
        "language": "FR",
        "text": "Les résultats indiquent que les employés fournissent un niveau de performance moyen dans l'accomplissement des activités et des tâches assignées et contribuent ainsi à atteindre la productivité du travail au niveau minimum requis. Cela indique que les employés peuvent avoir besoin de plus de conseils et de formation pour accomplir leur travail."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationBrief",
    "text": "These results may indicate potential vulnerabilities in the level of performance, which in turn affects employees' engagement. It is recommended to take immediate actions to encourage employees to learn new skills and gain knowledge that will help them grown professionally and personally. As well as providing the necessary training programs to fill the gap between the current level of performance and the desired level.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود ضعف محتمل في مستوى الأداء الذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بأهمية تطبيق إجراءات لتشجيع الموظفين على التعلم وكسب المهارات التي ستساعدهم على نموهم مهنياً وشخصياً، وتقديم برامج التدريب اللازمة لسد الفجوة بين مستوى الأداء الحالي والمستوى المنشود."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer des vulnérabilités potentielles dans le niveau de performance, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour encourager les employés à acquérir de nouvelles compétences et à acquérir des connaissances qui les aideront à acquérir des compétences professionnelles et personnelles. En plus de fournir les programmes de formation nécessaires pour combler l’écart entre le niveau actuel de rendement et le niveau souhaité."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationPointHeader",
    "text": "The following actions can be taken to improve this driver. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer un degré élevé de risque dans le niveau de performance, qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour encourager les employés à acquérir de nouvelles compétences et à acquérir des connaissances pour se développer professionnellement et personnellement. Fournit également les programmes de formation nécessaires pour combler l’écart entre le niveau actuel de rendement et le niveau souhaité."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationTitle_1",
    "text": "Knowledge transfer.",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة العلم والخبرات."
      },
      {
        "language": "FR",
        "text": "Le Transfert de Connaissances."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationDesc_1",
    "text": "It is the superior’s responsibility to instill the inspiration to learn and grow within the employees. Through experience and expertise, employees can be guided and helped through similar situations to improve their performance. Leaders that possess leadership skills provide a positive, supportive environment that contributes to raising employee productivity and loyalty.",
    "translations": [
      {
        "language": "AR",
        "text": "تقع على عاتق المدراء مسؤولية غرس الإلهام للتعلم والتطور في الموظفين. فمن خلال الخبرات والتجارب يمكن توجيه الموظفين ومساعدتهم لتحسين أدائهم وزيادة إنتاجيتهم. فالقادة الفاعلون الذين يمتلكون مهارات القيادة، يوفرون بيئة عمل إيجابية داعمة يسهمون في رفع إنتاجية الموظفين وولائهم."
      },
      {
        "language": "FR",
        "text": "C'est la responsabilité d’inspirer les employés à apprendre et à s’épanouir. Grâce à l’expérience et à l’expertise, les employés peuvent être guidés et aidés dans des situations semblables pour améliorer leur performance. Les leaders qui possèdent des compétences en leadership offrent un environnement positif et favorable qui contribue à accroître la productivité et la loyauté des employés."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationTitle_2",
    "text": "Have consistent performance appraisals.",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم أداء الموظفين بشكل مستمر."
      },
      {
        "language": "FR",
        "text": "Avoir des évaluations de performance cohérentes."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationDesc_2",
    "text": "It is very important to conduct the performance evaluation programs on a regular basis to identify employees' hidden strengths and weaknesses and accordingly decide the required training programs to improve their skills and competencies that affect work productivity—examples on evaluation programs: 360-degree feedback, performance appraisal, and management by objectives.",
    "translations": [
      {
        "language": "AR",
        "text": "من المهم جداً العمل على تقييم أداء الموظفين بشكل دوري لتحديد نقاط قوتهم الغير مستغلة ونقاط ضعفهم، وبالتالي تحضير برامج التدريب اللازمة لتحسين مهاراتهم وكفاءتهم التي تؤثر على إنتاجية العمل. ومن الأمثلة على برامج التقييم: التقييم 360°، وتقييم أداء الموظفين، والإدارة بالأهداف."
      },
      {
        "language": "FR",
        "text": "Il est très important de mener régulièrement des programmes d'évaluation des performances pour identifier les forces et faiblesses cachées des employés et décider en conséquence des programmes de formation nécessaires pour améliorer leurs aptitudes et compétences qui affectent la productivité du travail - exemples sur les programmes d'évaluation: rétroaction à 360 degrés, évaluation des performances et gestion par objectifs."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationTitle_3",
    "text": "Utilize the right technology.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدام التكنولوجيا المناسبة."
      },
      {
        "language": "FR",
        "text": "Utiliser la Technologie appropriée."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationDesc_3",
    "text": "Learning at work does not only come through doing things manually and from others' experiences. In addition to that, employees should learn how to utilize technology, systems, and applications that help them to do their work. It is important to provide employees with those resources.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يأتي التعلم في العمل فقط من خلال القيام بالأشياء يدوياً ومن تجارب الآخرين. بالإضافة إلى ذلك، يجب أن يتعلم الموظفون كيفية الاستفادة من التكنولوجيا والأنظمة والتطبيقات التي تساعدهم على القيام بعملهم. ومن المهم تزويد الموظفين بالمصادر اللازمة لذلك."
      },
      {
        "language": "FR",
        "text": "L'apprentissage au travail ne passe pas seulement par le fait de faire les choses manuellement et de l'expérience des autres. En outre, les employés devraient apprendre à utiliser la technologie, les systèmes et les applications qui les aident à faire leur travail. Il est important de fournir ces ressources aux employés."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationTitle_4",
    "text": "Invest in learning and development.",
    "translations": [
      {
        "language": "AR",
        "text": "الاستثمار في التعلم والتطوير."
      },
      {
        "language": "FR",
        "text": "Investissez dans l'apprentissage et le développement."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverRecommendationDesc_4",
    "text": "It is imperative to provide employees with the opportunity to upgrade their current knowledge and skills to improve their performance. One of the best ways to do that is by providing on-site classes for the employees, workshops, or even online training courses.",
    "translations": [
      {
        "language": "AR",
        "text": "من الضروري منح الموظفين الفرص الكافية لتطوير مهاراتهم الحالية واكتساب مهارات ومعارف جديدة لتحسين أدائهم. ومن أفضل الطرق للقيام بذلك هي توفير جلسة تبادل المعرفة، وورش عمل، وحضور دورات تدريبية عبر الإنترنت."
      },
      {
        "language": "FR",
        "text": "Il est impératif d'offrir aux employés la possibilité de mettre à niveau leurs connaissances et compétences actuelles pour améliorer leurs performances. L’une des meilleures façons de le faire est d’offrir des cours sur place aux employés, des ateliers ou même des cours de formation en ligne."
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الأداء:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendation_1",
    "text": "Managerial and Supervisory Skills",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تطوير المهارات الإدارية والإشرافية"
      },
      {
        "language": "FR",
        "text": "Les Compétences de Gestion et de Supervision"
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendation_2",
    "text": "How to Train your Employee Program",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج \"كيف تدرب الموظف الخاص بك؟\""
      },
      {
        "language": "FR",
        "text": "Comment former votre programme d'employés"
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendation_3",
    "text": "Performance Framework Development",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير برامج تقييم الأداء"
      },
      {
        "language": "FR",
        "text": "Développement du cadre de performance"
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendation_4",
    "text": "Conduct 360-degree Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق تقييم 360°"
      },
      {
        "language": "FR",
        "text": "Effectuer une évaluation ŕ 360 degrés"
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendation_5",
    "text": "Building and Managing Teams Training Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريبية لبناء وإدارة فريق العمل"
      },
      {
        "language": "FR",
        "text": "Création et gestion des programmes de formation des équipes"
      }
    ]
  },
  {
    "key": "txtReminderMissingURL",
    "text": "The reminder is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا التذكير!"
      },
      {
        "language": "FR",
        "text": "Votre lien a été supprimé dans ce rappel!"
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendation_6",
    "text": "Review and upgrade the automation systems",
    "translations": [
      {
        "language": "AR",
        "text": "مراجعة أنظمة الأتمتة وسبل تطويرها"
      },
      {
        "language": "FR",
        "text": "Examiner et mettre ŕ niveau les systčmes d’automatisation"
      }
    ]
  },
  {
    "key": "txtPerformanceModerateDriverOtherRecommendation_7",
    "text": "Set annual budget for training and development",
    "translations": [
      {
        "language": "AR",
        "text": "وضع موازنة سنوية للتدريب والتطوير"
      },
      {
        "language": "FR",
        "text": "Établir un budget annuel pour la formation et le développement"
      }
    ]
  },
  {
    "key": "txtPerformanceEngagedLowDriverReadings",
    "text": "The results indicate that employees are providing above average level of performance in completing the assigned activities and tasks. Thus they contribute to achieving work productivity at a somewhat satisfactory level by allowing them to develop and grow in their job through specific training and clear directions. This indicates that the employees are always learning new skills and gaining knowledge.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين يقدمون مستوى فوق المتوسط من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بدرجة مرضية، وذلك نتيجة لتوافر فرص التعلم والتطور للموظفين من خلال برامج التدريب المميزة والمرتبطة بتوجيهات واضحة نحو النمو والتطور. وهذا دليل على تطور مهارات الموظفين واكتسابهم المعرفة المطلوبة"
      }
    ]
  },
  {
    "key": "txtPerformanceHighDriverReadings",
    "text": "The results indicate that employees are providing a high level of performance in completing the assigned activities and tasks to achieve work productivity at a satisfactory high level by allowing them to develop and grow in their job through specific training and clear directions. This indicates that the employees are always learning new skills and gaining knowledge.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين يقدمون مستوى جيد من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بدرجة مرضية، وذلك نتيجة لتوافر فرص التعلم والتطور للموظفين من خلال برامج التدريب المميزة والمرتبطة بتوجيهات واضحة نحو النمو والتطور. وهذا دليل على تطور مهارات الموظفين واكتسابهم المعرفة المطلوبة."
      },
      {
        "language": "FR",
        "text": "Les résultats indiquent que les employés fournissent un bon niveau de performance dans l'accomplissement des activités et tâches assignées, et contribuent ainsi à atteindre une productivité du travail à un niveau satisfaisant en leur permettant de se développer et d'évoluer dans leur travail grâce à une formation spécifique et des orientations claires. Cela indique que les employés apprennent toujours de nouvelles compétences et acquièrent des connaissances."
      }
    ]
  },
  {
    "key": "txtPerformanceHighDriverRecommendationBrief",
    "text": "It is evident that the workplace has great opportunities to engage its employees by maintaining performance levels. It is recommended to continue to inspire the employees to consistently learn new skills and gain knowledge that will help them grow professionally and personally and provide them with good opportunities for career progression and provide the necessary training they require in their role. Keep investing in employees' learning and development to build a supportive environment that contributes to employee engagement and business success.",
    "translations": [
      {
        "language": "AR",
        "text": "هنالك فرصة كبيرة لبيئة العمل لتحسين اندماج الموظفين من خلال المحافظة على مستوى الأداء. ويوصى بالاستمرار في تشجيع الموظفين لتعلم وكسب مهارات جديدة التي ستساعدهم على نموهم مهنياً وشخصياً، وتوفير فرصاً جيدة للتقدم الوظيفي وتقديم برامج التدريب اللازمة. ومن المهم مراعاة أن الاستثمار في تعليم الموظفين وتطويرهم، لها دور كبير في بناء بيئة داعمة تسهم في زيادة اندماج الموظفين، وبالتالي نجاح الأعمال."
      },
      {
        "language": "FR",
        "text": "Les résultats indiquent que les employés fournissent un bon niveau de performance dans l'accomplissement des activités et tâches assignées, et contribuent ainsi à atteindre une productivité du travail à un niveau satisfaisant en leur permettant de se développer et d'évoluer dans leur travail grâce à une formation spécifique et des orientations claires. Cela indique que les employés apprennent toujours de nouvelles compétences et acquièrent des connaissances."
      }
    ]
  },
  {
    "key": "txtPerformanceHighDriverRecommendationPointHeader",
    "text": "",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtPerformanceExtremeHighDriverReadings",
    "text": "The results indicate that employees are providing a high level of performance in completing the assigned activities and tasks, and thus they contribute to achieving work productivity at a satisfactory high level by allowing them to develop and grow in their job through specific training and clear directions. This indicates that the employees are always learning new skills and gaining knowledge.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين يقدمون مستوى عال من الأداء في إنجاز المهام والأعمال الموكلة، وبالتالي يسهمون في تحقيق إنتاجية العمل بدرجة مرضية جداً، وذلك نتيجة لتوافر فرص التعلم والتطور للموظفين من خلال برامج التدريب المميزة والمرتبطة بتوجيهات واضحة نحو النمو والتطور. وهذا دليل على تطور مهارات الموظفين واكتسابهم المعرفة بشكل مستمر."
      },
      {
        "language": "FR",
        "text": "Les résultats indiquent que les employés fournissent un bon niveau de performance dans l'accomplissement des activités et tâches assignées, et contribuent ainsi à atteindre une productivité du travail à un niveau satisfaisant en leur permettant de se développer et d'évoluer dans leur travail grâce à une formation spécifique et des orientations claires. Cela indique que les employés apprennent toujours de nouvelles compétences et acquièrent des connaissances."
      }
    ]
  },
  {
    "key": "txtAutonomyDriverDesc",
    "text": "Autonomy holds a constructive relation with engagement in terms of empowerment and enablement. Employees who tend to feel empowered to participate in work activities and contribute ideas tend to yield a higher engagement level in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "هنالك علاقة بناءة بين الاستقلالية والاندماج الوظيفي من حيث التمكين والتفويض. حيث يميل الموظفون الذين يشعرون بالتمكين وحرية التصرف في العمل للمشاركة في الأنشطة المتاحة، بالإضافة للمساهمة في تقديم أفكار لتحقيق مستوى أعلى من الاندماج الوظيفي."
      },
      {
        "language": "FR",
        "text": "L'autonomie entretient une relation constructive avec l'engagement en termes d'autonomisation et d'habilitation. Les employés qui ont tendance à se sentir habilités à participer aux activités de travail et à apporter des idées ont tendance à générer un niveau d'engagement plus élevé sur le lieu de travail."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverReadings",
    "text": "The analysis demonstrates that the work environment does not provide its employees with any level of autonomy and flexibility in their work, and that may happen because they do not have access to the enablers [tools, materials, and equipment] that they need to get their job done. It may require providing more activities for the employees and encouraging them to participate in.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل لا تمنح الموظفين استقلالية ومرونة في عملهم. وقد يكون السبب هو عدم توفير الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم. ويجب توفير أنشطة مختلفة وتشجيع الموظفين للمشاركة فيها."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que l'environnement de travail n'offre à ses employés aucun niveau d'autonomie et de flexibilité dans leur travail, et cela peut se produire parce qu'ils n'ont pas accès aux facilitateurs [outils, matériaux et équipements] dont ils ont besoin pour obtenir leur travail accompli. Cela peut nécessiter d'offrir plus d'activités aux employés et de les encourager à y participer."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationBrief",
    "text": "These results may indicate a high degree of risk in the autonomy level granted in the workplace, which in turn affects employees’ engagement. It is recommended to take immediate and rapid actions to provide the employees with the minimum level of flexibility required to complete their work. Additionally, start trusting them and allowing them to be involved in decisions that affect their job.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة في مستوى الاستقلالية الممنوحة في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة تطبيق إجراءات فورية لمنح الموظفين الحد الأدنى من الاستقلالية المطلوبة لقيامهم بأعمالهم. ويجب إظهار الثقة في الموظفين والسماح لهم بالمشاركة في اتخاذ القرارات التي تؤثر على أعمالهم."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer un degré élevé de risque dans le niveau d’autonomie accordé sur le lieu de travail, ce qui à son tour affecte l’engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour offrir aux employés le niveau minimum de flexibilité requis pour terminer leur travail. De plus, commencez à leur faire confiance et à leur permettre de participer à des décisions qui affectent leur travail."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationPointHeader",
    "text": "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationTitle_1",
    "text": "Enhance workplace autonomy.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير الاستقلالية."
      },
      {
        "language": "FR",
        "text": "Améliorer l'autonomie au travail."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationDesc_1",
    "text": "Provide the employees with the required flexibility in their job has a great impact on the work environment. It makes them feel the confidence given and motivates them to take responsibility and show their potential powers and creativity to accomplish their tasks efficiently and effectively.",
    "translations": [
      {
        "language": "AR",
        "text": "منح الموظفين جزء من الاستقلالية لديه أثر كبير في بيئة العمل، حيث يشعرهم بالثقة الممنوحة ويحفزهم لتحمل المسؤولية وإظهار طاقاتهم الكامنة وإبداعاتهم نحو العمل وإنجازهم لمهامهم بكفاءة وفعالية عالية."
      },
      {
        "language": "FR",
        "text": "Offrir aux employés la flexibilité requise dans leur travail a un grand impact sur l'environnement de travail. Cela leur fait ressentir la confiance qui leur est donnée et les motive à assumer leurs responsabilités et à montrer leurs pouvoirs potentiels et leur créativité pour accomplir leurs tâches de manière efficace et efficiente."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationTitle_2",
    "text": "Allow employees to be involved in the decision-making process.",
    "translations": [
      {
        "language": "AR",
        "text": "منح الموظفين فرصة المشاركة في صنع القرار."
      },
      {
        "language": "FR",
        "text": "Permettre aux employés d'ętre impliqués dans le processus de prise de décision."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationDesc_2",
    "text": "It is important to involve the employees in the decision-making process as it directly impacts their jobs. This strategy has various benefits, the most important of which are motivation, raising their spirits, sense of responsibility, and increasing productivity. Additionally, it is possible to get benefit from their previous experiences in solving some problems.",
    "translations": [
      {
        "language": "AR",
        "text": "إشراك الموظفين بعملية صنع القرار أمر هام للغاية، لما له من أثر مباشر على وظائفهم. ولهذه الاستراتيجية منافع أهمها تحفيزهم ورفع معنوياتهم، وتنمية شعورهم بالمسؤولية، وزيادة الإنتاجية. كما يمكن الاستفادة من خبرات الموظفين وتجاربهم في حل بعض المشاكل."
      },
      {
        "language": "FR",
        "text": "Il est important d'impliquer les employés dans le processus de prise de décision car cela a un impact direct sur leur travail. Cette stratégie a divers avantages, dont les plus importants sont la motivation, l’élévation du moral, le sens des responsabilités et l’augmentation de la productivité. En outre, il est possible de tirer profit de leurs expériences antérieures dans la résolution de certains problèmes."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationTitle_3",
    "text": "Invest in enablers.",
    "translations": [
      {
        "language": "AR",
        "text": "الاستثمار في الممكنات."
      },
      {
        "language": "FR",
        "text": "Investissez dans des catalyseurs."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationDesc_3",
    "text": "Employees feel that they do not have the tools, materials, and equipment needed to get their job done and be more productive. It is important to identify what is required for specific job roles and departments to invest in the right resources to drive change.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استشارة الموظفين في ما يخص الممكنات [الأدوات والمواد والمعدات] الغير متوافرة والتي يحتاجونها لإنجاز مهامهم ويكونوا أكثر إنتاجية. كما يجب تحدد ما هو مطلوب للأدوار الوظيفية والأقسام المختلفة حتى تتمكن من الاستثمار في الموارد المناسبة لدعم عملية التغيير."
      },
      {
        "language": "FR",
        "text": "Les employés estiment qu’ils n’ont pas les outils, le matériel et l’équipement nécessaires pour faire leur travail et être plus productifs. Il est important d'identifier ce qui est nécessaire pour que des rôles et des services spécifiques investissent dans les bonnes ressources pour conduire le changement."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationTitle_4",
    "text": "Delegate work to employees.",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع العمل والمهام."
      },
      {
        "language": "FR",
        "text": "Déléguer le travail aux employés."
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverRecommendationDesc_4",
    "text": "It is important to instill a sense of responsibility and accountability. Accordingly, distribute and delegate work equally among employees and the set time they need to complete the work and contribute to achieving business goals efficiently.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب العمل على غرس الشعور بالمسؤولية والمساءلة. وعليه يحبّذ توزيع المهام والواجبات على الموظفين بشكل عادل ويجب تحديد الوقت الذي يحتاجونه لتنفيذ العمل. وبالتالي سيتمكنون من المشاركة في أهداف العمل وإنجازها بكفاءة عالية."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاستقلالية:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverOtherRecommendation_1",
    "text": "Planning and organizing skills training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب مهارات التخطيط والتنظيم"
      },
      {
        "language": "FR",
        "text": "Planifier et organiser des programmes de formation professionnelle"
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverOtherRecommendation_2",
    "text": "Time management training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب إدارة الوقت"
      },
      {
        "language": "FR",
        "text": "Programmes de formation ŕ la gestion du temps"
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverOtherRecommendation_3",
    "text": "Delegation skills training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب مهارات التفويض"
      },
      {
        "language": "FR",
        "text": "Programmes de formation aux compétences de délégation"
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverOtherRecommendation_4",
    "text": "Set annual budget for the required enablers",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد موازنة سنوية للممكنات"
      },
      {
        "language": "FR",
        "text": "Définir un budget annuel pour les catalyseurs et les facilitateurs requis"
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeLowDriverOtherRecommendation_5",
    "text": "Set plans for practical & entertainment activities and events",
    "translations": [
      {
        "language": "AR",
        "text": "وضع خطط للأنشطة والفعاليات الترفيهية والعملية"
      },
      {
        "language": "FR",
        "text": "Établir des plans pour des activités et des événements pratiques et de divertissement"
      }
    ]
  },
  {
    "key": "txtAutonomyLowDriverReadings",
    "text": "The analysis demonstrates that the work environment does not provide its employees with enough autonomy and flexibility in their work, and that may happen because employees need access to enablers [tools, materials, and equipment] to get their job done. It may require providing more activities for the employees and encouraging them to participate in.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل لا تمنح الموظفين استقلالية ومرونة كافية في عملهم. وقد يكون السبب صعوبة توفير الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين وصعوبة الوصول إليها لإنجاز مهامهم. ويجب توفير أنشطة مختلفة وتشجيع الموظفين للمشاركة فيها."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que l'environnement de travail n'offre à ses employés aucun niveau d'autonomie et de flexibilité dans leur travail, et cela peut se produire parce que les employés doivent avoir accès à des facilitateurs [outils, matériaux et équipement] pour faire leur travail. Cela peut nécessiter d'offrir plus d'activités aux employés et de les encourager à y participer."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverReadings",
    "text": "The analysis demonstrates that the workplace has moderate autonomy and sometimes provides enablers [tools, materials, and equipment] that employees may need to get the job done. It may require providing more activities for the employees to participate in.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة معتدلة في عملهم. كما وتوفير الحد الأدنى من الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتسعى لتوفير المزيد من الأنشطة للموظفين للمشاركة فيها."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que le milieu de travail a une autonomie modérée et fournit parfois des facilitateurs [outils, matériaux et équipement] dont les employés peuvent avoir besoin pour faire le travail. Cela peut nécessiter d'offrir plus d'activités aux employés et de les encourager à y participer."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationBrief",
    "text": "These results may indicate potential vulnerabilities in the autonomy level granted in the workplace, which in turn affects employees' engagement. It is recommended to take immediate actions to provide the employees with the flexibility required to complete their work. Additionally, trusting them and allowing them to be involved in decisions that affect their job.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود ضعف محتمل بالنسبة لمستوى الاستقلالية الممنوحة في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بأهمية تطبيق إجراءات لمنح الموظفين الاستقلالية المطلوبة لقيامهم بأعمالهم. ويجب الثقة في الموظفين والسماح لهم بالمشاركة في اتخاذ القرارات التي تؤثر على أعمالهم."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer des vulnérabilités potentielles dans le niveau d'autonomie accordé sur le lieu de travail, ce qui à son tour affecte l'engagement des employés. Ces résultats peuvent indiquer des vulnérabilités potentielles dans le niveau d'autonomie octroyé sur le lieu de travail, il est recommandé de prendre des mesures immédiates pour donner aux employés la flexibilité nécessaire pour terminer leur travail, ce qui affecte à son tour l'engagement des employés. En outre, leur faire confiance et leur permettre de participer à des décisions qui affectent leur travail."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationPointHeader",
    "text": "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationTitle_1",
    "text": "Provide a flexible work schedule.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير جدول عمل مرن."
      },
      {
        "language": "FR",
        "text": "Fournir un horaire de travail flexible."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationDesc_1",
    "text": "In addition to sick leave and vacation permissions, employees sometimes have situations where they are unable to make it to the office, so it is important to allow them to work remotely and provide the enablers they need to get their job done. This contributes to increasing job satisfaction and productivity.",
    "translations": [
      {
        "language": "AR",
        "text": "بالإضافة إلى الإجازات المرضية والإجازات السنوية، قد يواجه الموظفون أحياناً مواقف يتعذر عليهم فيها الوصول إلى المكتب لظروف معينة، فمن المهم السماح لهم بالعمل عن بعد وتوفير الممكنات اللازمة، وذلك يسهم في زيادة الرضا الوظيفي والإنتاجية."
      },
      {
        "language": "FR",
        "text": "En plus des congés de maladie et des autorisations de vacances, les employés ont parfois des situations où ils sont incapables de se rendre au bureau, il est donc important de leur permettre de travailler à distance et de fournir les outils dont ils ont besoin pour faire leur travail. Cela contribue à accroître la satisfaction au travail et la productivité."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationTitle_2",
    "text": "Allow the freedom to set deadlines.",
    "translations": [
      {
        "language": "AR",
        "text": "السماح للموظفين بتحديد المواعيد النهائية."
      },
      {
        "language": "FR",
        "text": "Laissez la liberté de fixer des délais."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationDesc_2",
    "text": "Try trusting employees to set the deadline that they deem necessary for the tasks they need to complete. Employees may have more knowledge of the amount of time they need to complete the scope of work provided.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إعطاء الموظفين فرصة لتحديد الموعد النهائي الذي يرونه منطقياً لإنهاء المهام المطلوبة. فقد يكون لديهم معرفة أكبر بمقدار الوقت الذي يحتاجون إليه لإتمام المهام الموكلة إليهم بفاعلية عالية."
      },
      {
        "language": "FR",
        "text": "Essayer de faire confiance aux employés pour fixer la date limite qu'ils jugent nécessaire pour les tâches qu'ils doivent accomplir. Les employés peuvent avoir une meilleure connaissance du temps dont ils ont besoin pour terminer la portée des travaux fournis."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationTitle_3",
    "text": "Provide access to enablers.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير الممكنات."
      },
      {
        "language": "FR",
        "text": "Fournir un accčs aux facilitateurs."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationDesc_3",
    "text": "Sit down with the employees and find out what enablers [tools, materials, and equipment] they are missing or ones they need to update to get their job done.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استشارة الموظفين في ما يخص الممكنات من الأدوات والمواد والمعدات الغير متوفرة والتي يحتاجونها لإنجاز مهامهم ويكونوا أكثر إنتاجية."
      },
      {
        "language": "FR",
        "text": "Asseyez-vous avec les employés et découvrez quels facilitateurs [outils, matériaux et équipements] ils manquent ou ceux dont ils ont besoin pour mettre à jour pour faire leur travail."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationTitle_4",
    "text": "Encourage employees to design their own process of doing things.",
    "translations": [
      {
        "language": "AR",
        "text": "تشجيع الموظفين على تصميم طرقهم الخاصة لإنجاز الأعمال."
      },
      {
        "language": "FR",
        "text": "Encourager les employés ŕ concevoir leur propre processus de travail."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverRecommendationDesc_4",
    "text": "Sometimes employees may find it difficult to follow a specific pattern dictated to them by their superiors, and they do not complete the task as efficiently as possible. Allow them to come up with their own way and method to do things that make it easier for them to do the job.",
    "translations": [
      {
        "language": "AR",
        "text": "في بعض الأحيان، قد يجد الموظفين صعوبة في اتباع نمط معين تم فرضه عليهم من قبل رؤسائهم المباشرين، وعليه يواجهون صعوبة في إكماله بالكفاءة المطلوبة. لذلك يجب السماح لهم بالتوصل إلى طرق ومنهجيات خاصة بهم تسهل عليهم إتمام أعمالهم."
      },
      {
        "language": "FR",
        "text": "Parfois, les employés peuvent avoir du mal à suivre un modèle spécifique qui leur est dicté par leurs supérieurs et ils n'accomplissent pas la tâche aussi efficacement que possible. Permettez-leur de trouver leur propre façon et méthode de faire les choses qui leur facilitent la tâche."
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاستقلالية:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverOtherRecommendation_1",
    "text": "Implement the work remotely policy",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق سياسة العمل عن بعد"
      },
      {
        "language": "FR",
        "text": "Mettre en śuvre la politique de travail ŕ distance"
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverOtherRecommendation_2",
    "text": "Planning and Organizing skills training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب مهارات التخطيط والتنظيم"
      },
      {
        "language": "FR",
        "text": "Planifier et organiser des programmes de formation professionnelle"
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverOtherRecommendation_3",
    "text": "Time management training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب مهارة إدارة الوقت"
      },
      {
        "language": "FR",
        "text": "Programmes de formation ŕ la gestion du temps"
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverOtherRecommendation_4",
    "text": "Set annual budget for the required enablers",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد موازنة سنوية للممكنات"
      },
      {
        "language": "FR",
        "text": "Définir un budget annuel pour les catalyseurs et les facilitateurs requis"
      }
    ]
  },
  {
    "key": "txtAutonomyModerateDriverOtherRecommendation_5",
    "text": "Set plans for practical & entertainment activities and events",
    "translations": [
      {
        "language": "AR",
        "text": "وضع خطط للأنشطة والفعاليات الترفيهية والعملية"
      },
      {
        "language": "FR",
        "text": "Établir des plans pour des activités et des événements pratiques et de divertissement"
      }
    ]
  },
  {
    "key": "txtAutonomyEngagedLowDriverReadings",
    "text": "The analysis demonstrates that the work environment provides its employees with enough autonomy and flexibility in their work, and it provides enablers [tools, materials, and equipment] that the employees may need to get the job done. It may require providing additional activities for the employees to participate in.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة  كافية في عملهم. كما توفر جميع الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتسعى لمشاركتهم في أنشطتها الملائمة لوظائفهم."
      }
    ]
  },
  {
    "key": "txtAutonomyHighDriverReadings",
    "text": "The analysis demonstrates that the work environment provides its employees with high autonomy and flexibility in their work, and it provides enablers [tools, materials, and equipment] that the employees may need to get the job done. It ensures that employees participate in workplace activities.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة عالية في عملهم. كما توفر جميع الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتسعى لمشاركتهم في أنشطتها الملائمة لوظائفهم."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que l'environnement de travail offre à ses employés une grande autonomie et une grande flexibilité dans leur travail, et il fournit des outils [outils, matériaux et équipements] dont les employés peuvent avoir besoin pour faire le travail. Il veille à ce que les employés participent aux activités sur le lieu de travail."
      }
    ]
  },
  {
    "key": "txtAutonomyHighDriverRecommendationBrief",
    "text": "The workplace presents the strength in terms of autonomy, and it is recommended to continue providing the employees with their current level of flexibility. Additionally, continue trusting them and encouraging them to be involved in decisions that affect their job, and ensuring that they participate in the workplace activities hosted.",
    "translations": [
      {
        "language": "AR",
        "text": "يوصى هنا بالاستمرار في النهج الحالي المتبع فيما يخص تطبيق مبدأ الاستقلالية في العمل. ويجب المحافظة على إظهار الثقة في الموظفين وتشجيتعهم لاتخاذ القرارات التي تؤثر على أعمالهم. بالإضافة إلى استمرارية تحفيزهم للمشاركة في الأنشطة المختلفة."
      },
      {
        "language": "FR",
        "text": "Le lieu de travail présente la force en termes d'autonomie et il est recommandé de continuer à offrir aux employés leur niveau actuel de flexibilité. En outre, continuez de leur faire confiance et encouragez-les à participer aux décisions qui ont une incidence sur leur travail et à s’assurer qu’ils participent aux activités en milieu de travail organisées."
      }
    ]
  },
  {
    "key": "txtAutonomyHighDriverRecommendationPointHeader",
    "text": "",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAutonomyExtremeHighDriverReadings",
    "text": "The analysis demonstrates that the work environment provides its employees with very high autonomy and flexibility in their work. And it continuously provides all the enablers [tools, materials, and equipment] that the employees may need to get the job done. It ensures that employees participate in workplace activities.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تمنح الموظفين استقلالية ومرونة عالية جداً في عملهم. كما توفر باستمرار جميع الممكنات من الأدوات والمواد والمعدات التي قد يحتاجها الموظفين لإنجاز مهامهم، وتضمن مشاركتهم في أنشطتها المختلفة."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que l'environnement de travail offre à ses employés une très grande autonomie et flexibilité dans leur travail. Et il fournit continuellement tous les facilitateurs [outils, matériaux et équipement] dont les employés peuvent avoir besoin pour faire le travail.  Il veille à ce que les employés participent aux activités sur le lieu de travail."
      }
    ]
  },
  {
    "key": "txtConnectionDriverDesc",
    "text": "Employees' connection in the workplace is important in terms of communication, social connection, and culture in general. The reason for a positive relationship between connection and engagement is that employees are more likely to engage when they feel like the culture fits with their morals and two-way communication is flowing smoothly throughout the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "الاتصال بين الموظفين مهم لرفع مستوى التواصل الاجتماعي ودعم ثقافة بيئة العمل بشكل عام. والسبب وراء وجود علاقة إيجابية بين التواصل والاندماج الوظيفي هو أن الموظفين يكونون أكثر عرضة للاندماج عندما يشعرون أن الثقافة متناسبة مع أخلاقهم وأن الاتصال المتبادل  (two-way communication) يكون سلساً في مكان العمل."
      },
      {
        "language": "FR",
        "text": "Le lien des employés sur le lieu de travail est important en termes de communication, de lien social et de culture en général. La raison d’une relation positive entre le lien et l’engagement est que les employés sont plus susceptibles de s’engager lorsqu’ils estiment que la culture correspond à leur moralité et que la communication bidirectionnelle se fait sans heurts dans l’ensemble du milieu de travail."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverReadings",
    "text": "These results indicate that the work environment doesn’t show any efficiency as a result of the lack of social connection between the teams and other functions. The work environment needs immediate attention to improve the social connection level and enhance employees’ team spirit and motivate them to communicate.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل لا تتمتع بكفاءة نتيجة إنعدام الاتصال والتعاون بين الفرق والأقسام الأخرى. إن بيئة العمل بحاجة ماسة لتحسين مستوى التواصل الاجتماعي بين الموظفين وتعزيز روح الفريق لديهم، وتشجيعهم على التواصل والتعاون ."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l’environnement de travail ne démontre aucune efficacité en raison du manque de lien social entre les équipes et les autres fonctions. L’environnement de travail nécessite une attention immédiate pour améliorer le niveau de connexion sociale et améliorer l’esprit d’équipe des employés et les motiver à communiquer."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationBrief",
    "text": "These results may indicate a high degree of risk in the connection and communication levels in the workplace, which in turn affects employees’ engagement. It is recommended to take immediate and rapid actions to enhance the social connection and encourage collaboration between the teams and other functions.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة في مستوى التواصل والاتصال في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات فورية لتعزيز التواصل الاجتماعي وتشجيع التعاون بين الفرق والأقسام الأخرى."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer un degré élevé de risque dans les niveaux de connexion et de communication en milieu de travail, ce qui influe sur l’engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour améliorer les liens sociaux et encourager la collaboration entre les équipes et les autres fonctions."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationPointHeader",
    "text": "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationTitle_1",
    "text": "Communicate work mission & values.",
    "translations": [
      {
        "language": "AR",
        "text": "ترسيخ رسالة العمل وقيم."
      },
      {
        "language": "FR",
        "text": "Communiquer la mission et les valeurs du travail."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationDesc_1",
    "text": "It is important to communicate business mission and values to ensure a safe and secure work environment. For employees to feel engaged with the workplace, their values must be consistent with business values. Motivate the employees to contribute to the achievement of this mission and values. The best way to succeed in achieving this is by collaborating and working to achieve the common goal.",
    "translations": [
      {
        "language": "AR",
        "text": "من المهم جداً ترسيخ مهمة العمل وقيمه لضمان تحقيق بيئة عمل آمنة. وكي يشعر الموظفون بأنهم مرتبطون بمكان العمل يجب أن تتسق قيمهم الشخصية مع قيم العمل. ويجب تحفيز الموظفين لدعم وتحقيق هذه القيم. وتتمثل أفضل السبل نحو النجاح في تحقيق ذلك هو بالتعاون والعمل يداً واحدة لتحقيق الهدف المشترك."
      },
      {
        "language": "FR",
        "text": "Il est important de communiquer la mission et les valeurs de la société pour garantir un environnement de travail sûr et sécurisé. Pour que les employés se sentent impliqués dans le milieu de travail, leurs valeurs doivent être cohérentes avec les valeurs de la société. Motiver les employés à contribuer à la réalisation de cette mission et de ces valeurs. La meilleure façon d’y parvenir est de collaborer et de travailler pour atteindre l’objectif commun."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationTitle_2",
    "text": "Encourage information sharing.",
    "translations": [
      {
        "language": "AR",
        "text": "تشجيع تبادل المعلومات."
      },
      {
        "language": "FR",
        "text": "Encourager le partage d'informations."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationDesc_2",
    "text": "Some employees refrain from doing so because they fear rejection, not being listened to, or even ignored. It is important to show that there is no idea or information shared that is not useful. And always welcome their suggestions.",
    "translations": [
      {
        "language": "AR",
        "text": "يمتنع بعض الموظفين عن مشاركة أفكارهم ذلك لأنهم يخشون الرفض، أو عدم الاستماع إليهم، أو حتى التجاهل. يجب التوضيح لهم أنه لا توجد أفكار أو معلومات غير مفيدة تتم مشاركتها. والترحيب باقتراحاتهم دائماً."
      },
      {
        "language": "FR",
        "text": "Certains employés s'abstiennent de le faire parce qu'ils craignent d'être rejetés, de ne pas être écoutés, voire ignorés. Il est important de montrer qu'il n'y a aucune idée ou information partagée qui ne soit pas utile. Et toujours accueillir leurs suggestions."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationTitle_3",
    "text": "Collaborate with other functions and teams.",
    "translations": [
      {
        "language": "AR",
        "text": "التعاون مع الموظفين والأقسام الأخرى."
      },
      {
        "language": "FR",
        "text": "Collaborer avec d'autres fonctions et équipes."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationDesc_3",
    "text": "There are times where employees find it difficult to collaborate with members outside of their teams and department. This is where it is necessary to show them support by communicating the common goals they are to achieve. Ensure rewarding the employees for project milestones and help them connect and collaborate and enhance team spirit.",
    "translations": [
      {
        "language": "AR",
        "text": "هناك أوقات يجد فيها الموظفين صعوبة في التعاون مع الموظفين من الأقسام الأخرى. وفي هذه المواقف يجب الدعم من خلال مشاركة الأهداف العامة التي يتعين عليهم تحقيقها. والتأكد من مكافأتهم على المراحل الرئيسية في المشروع ومساعدتهم على التواصل والتعاون وتعزيز روح الفريق. "
      },
      {
        "language": "FR",
        "text": "Il y a des moments où les employés ont du mal à collaborer avec des membres en dehors de leurs équipes et de leur service. C'est là qu'il est nécessaire de leur montrer leur soutien en communiquant les objectifs communs qu'ils doivent atteindre. Assurez-vous de récompenser les employés pour les étapes importantes du projet et aidez-les à se connecter, à collaborer et à améliorer l’esprit d’équipe."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationTitle_4",
    "text": "Celebrate culture and diversity.",
    "translations": [
      {
        "language": "AR",
        "text": "دعم تنوع الثقافات."
      },
      {
        "language": "FR",
        "text": "Célébrer la culture et la diversité."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverRecommendationDesc_4",
    "text": "This is a vital part of the work environment, given the fact that employees come from different ethnical backgrounds and cultures. There are many ways to celebrate them and make them feel welcome. Incorporate gatherings occasionally that include their local delicacies, cultural museum visits, and even game discussions.",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الجانب مهم جداً لبيئة العمل مع الأخذ بعين الاعتبار أن أغلب الموظفين يأتون من ثقافات مختلفة. وهناك العديد من الطرق التي يمكن من خلالها دعم الموظفين وجعلهم يشعرون بالترحيب. فمن الممكن تنظيم التجمعات من حين لآخر والتي قد تتضمن الأطباق المحلية الخاصة بهم، وزيارات للمتحف الثقافي، وحتى النقاش حول الألعاب."
      },
      {
        "language": "FR",
        "text": "Il s'agit d'un élément essentiel de l'environnement de travail, étant donné que les employés sont issus de cultures et d'ethnies différentes. Il existe de nombreuses façons de les célébrer et de les accueillir. Incorporez occasionnellement des rassemblements qui incluent leurs spécialités locales, des visites de musées culturels et même des discussions sur les jeux."
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاتصال:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverOtherRecommendation_1",
    "text": "Communication skills training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب مهارات الاتصال"
      },
      {
        "language": "FR",
        "text": "Programmes de formation en communication"
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverOtherRecommendation_2",
    "text": "Adopt effective communication strategies",
    "translations": [
      {
        "language": "AR",
        "text": "تبني استراتيجيات الاتصال الفعالة"
      },
      {
        "language": "FR",
        "text": "Adopter des stratégies de communication efficaces"
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverOtherRecommendation_3",
    "text": "Set up weekly or monthly meetings to share business achievement",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإعداد اجتماعات أسبوعية أو شهرية لمشاركة إنجازات الأعمال"
      },
      {
        "language": "FR",
        "text": "Organiser des réunions hebdomadaires ou mensuelles pour partager les réalisations de la société"
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverOtherRecommendation_4",
    "text": "Corporate culture orientation",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تهيئة الموظفين لثقافة العمل"
      },
      {
        "language": "FR",
        "text": "Orientation de la culture de la société"
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverOtherRecommendation_5",
    "text": "Building and managing teams training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج بناء وإدارة فريق العمل"
      },
      {
        "language": "FR",
        "text": "Création et gestion des programmes de formation des équipes"
      }
    ]
  },
  {
    "key": "txtConnectionExtremeLowDriverOtherRecommendation_6",
    "text": "Workplace Diversity management Program",
    "translations": [
      {
        "language": "AR",
        "text": "برامج إدارة التنوع في مكان العمل"
      },
      {
        "language": "FR",
        "text": "Programme de gestion de la diversité en milieu de travail"
      }
    ]
  },
  {
    "key": "txtConnectionLowDriverReadings",
    "text": "These results indicate that the work environment doesn’t show any efficiency as a result of the weak social connections between the employees, and it is affecting the collaboration within the department and between other departments. The work environment needs to improve the social connection level and enhance employees’ team spirit.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل لا تتمتع بكفاءة نتيجة ضعف الاتصال والتعاون بين الموظفين والذي بدوره يؤثر على التعاون بين الفرق والأقسام الأخرى. إن بيئة العمل بحاجة لتحسين مستوى التواصل الاجتماعي بين الموظفين وتعزيز روح الفريق لديهم."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l’environnement de travail ne montre aucune efficacité en raison de la faiblesse des liens sociaux entre les employés et affecte la collaboration au sein du département et entre les autres départements. L’environnement de travail doit améliorer le niveau de connexion sociale et renforcer l’esprit d’équipe des employés."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverReadings",
    "text": "These results indicate that the work environment shows average efficiency as a result of the collaboration and connection between the teams and other functions. The work environment requires improvement in the social connection between your employees, which may affect the collaboration between them, enhance the work culture, and increase employees’ productivity and efficiency.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تتمتع بكفاءة معتدلة نتيجة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن بيئة العمل تحتاج لتحسين مستوى التواصل الاجتماعي بين الموظفين والذي بدوره قد يؤثر على التعاون بينهم ويعزز ثقافة العمل ويزيد من كفاءة الموظفين وإنتاجيتهم. "
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l'environnement de travail montre une efficacité moyenne du fait de la collaboration et de la connexion entre les équipes et les autres fonctions. L’environnement de travail nécessite une amélioration du lien social entre vos employés, ce qui peut affecter la collaboration entre eux, améliorer la culture de travail et augmenter la productivité et l’efficacité des employés."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationBrief",
    "text": "These results may indicate potential vulnerabilities in the connection and communication levels in the workplace, which in turn affects employees' engagement. It is recommended to take immediate actions to enhance the social connection and encourage collaboration between the teams and other functions.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود ضعف محتمل بالنسبة لمستوى التواصل والاتصال في بيئة العمل والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات لتعزيز التواصل الاجتماعي وتشجيع التعاون بين الفرق والأقسام الأخرى."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer des vulnérabilités potentielles dans les niveaux de connexion et de communication sur le lieu de travail, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour renforcer le lien social et encourager la collaboration entre les équipes et les autres fonctions."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationPointHeader",
    "text": "The following actions can be taken to improve autonomy. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين هذا البُعد:"
      },
      {
        "language": "FR",
        "text": "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationTitle_1",
    "text": "Adopt an open-door policy.",
    "translations": [
      {
        "language": "AR",
        "text": "تبنى سياسة الباب المفتوح (open-door policy)."
      },
      {
        "language": "FR",
        "text": "Adoptez une politique de porte ouverte."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationDesc_1",
    "text": "This policy is vital since it looks to create a connection and engage its employees. It is essential that you impose transparent communication and allow your employees to express their opinions freely without the fear of repercussions. Tell your employees that your office door is open to them any time they have feedback to give you or something they need to talk to you about.",
    "translations": [
      {
        "language": "AR",
        "text": "تعتبر هذه السياسة مهمة جداً لأنها تتطلع إلى تعزيز التواصل بين الموظفين. من المهم أن تدعم مبدأ الشفافية، وتسمح للموظفين بالتعبير عن آرائهم بحرية دون خوف. أخبر الموظفين أن باب مكتبك مفتوح لهم في أي وقت حين يكون لديهم أية ملاحظات لمناقشتها معك."
      },
      {
        "language": "FR",
        "text": "Cette politique est essentielle puisqu’elle cherche à créer un lien et à mobiliser ses employés. Il est essentiel que vous imposiez une communication transparente et que vous permettiez à vos employés d’exprimer librement leurs opinions sans craindre de répercussions. Dites à vos employés que la porte de votre bureau leur est ouverte chaque fois qu’ils ont des commentaires à vous donner ou quelque chose dont ils ont besoin de vous parler."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationTitle_2",
    "text": "Communicate work mission & values.",
    "translations": [
      {
        "language": "AR",
        "text": "ترسيخ رسالة العمل وقيم. "
      },
      {
        "language": "FR",
        "text": "Communiquer la mission et les valeurs du travail."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationDesc_2",
    "text": "It is important to communicate business mission and values to ensure a safe and secure work environment. For employees to feel engaged with the workplace, their values must be consistent with business values. Motivate the employees to contribute to the achievement of this mission and values. The best way to succeed in achieving this is by collaborating and working to achieve the common goal.",
    "translations": [
      {
        "language": "AR",
        "text": "من المهم جداً ترسيخ مهمة العمل وقيمه لضمان تحقيق بيئة عمل آمنة. وكي يشعر الموظفون بأنهم مرتبطون بمكان العمل يجب أن تتسق قيمهم الشخصية مع قيم العمل. ويجب تحفيز الموظفين لدعم وتحقيق هذه القيم. وتتمثل أفضل السبل نحو النجاح في تحقيق ذلك هو بالتعاون والعمل يداً واحدة لتحقيق الهدف المشترك."
      },
      {
        "language": "FR",
        "text": "Il est important de communiquer la mission et les valeurs de la société pour garantir un environnement de travail sûr et sécurisé. Pour que les employés se sentent impliqués dans le milieu de travail, leurs valeurs doivent être cohérentes avec les valeurs de la société. Motiver les employés à contribuer à la réalisation de cette mission et de ces valeurs. La meilleure façon d’y parvenir est de collaborer et de travailler pour atteindre l’objectif commun."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationTitle_3",
    "text": "Openly share experiences.",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة الخبرات."
      },
      {
        "language": "FR",
        "text": "Partagez ouvertement vos expériences."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationDesc_3",
    "text": "Communicating with the employees and sharing the previous experiences has an important role in increasing their engagement. Sharing these experiences helps in performing their work effectively. As well as solving any problem or challenges they may face smoothly.",
    "translations": [
      {
        "language": "AR",
        "text": "التواصل مع الموظفين ومشاركة الخبرات والتجارب السابقة معهم له دور مهم في زيادة ارتباطهم بالعمل. فمشاركة هذه الخبرات تساعدهم في أداء وظائفهم بشكل فعال، ومواجهة الصعوبات والتحديات التي قد تواجههم بسلاسة."
      },
      {
        "language": "FR",
        "text": "Communiquer avec les employés et partager les expériences précédentes a un rôle important dans l'augmentation de leur engagement. Le partage de ces expériences aide à effectuer leur travail efficacement. Ainsi que la résolution de tout problème ou des défis auxquels ils peuvent faire face en douceur."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationTitle_4",
    "text": "Implement management by walking around.",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق الإدارة من خلال التجول في مكان العمل."
      },
      {
        "language": "FR",
        "text": "Mettre en śuvre la gestion en se promenant."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverRecommendationDesc_4",
    "text": "One of the most common ways to instill communication between the top management and other employees is using this method. It is recommended to walk around the offices and to check on how the employees are doing.",
    "translations": [
      {
        "language": "AR",
        "text": "تعد هذه الطريقة من أكثر الطرق شيوعاً لغرس التواصل بين الإدارة العليا والموظفين. ومن المستحسن أن التجول بين مكاتب الموظفين لإجراء محادثة قصيرة مع الموظفين بين حين وآخر وسؤالهم عن أحوالهم. "
      },
      {
        "language": "FR",
        "text": "L'un des moyens les plus courants d'instaurer la communication entre la direction et les autres employés consiste à utiliser cette méthode. Il est recommandé de se promener dans les bureaux et de vérifier comment les employés se portent."
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل الاتصال:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverOtherRecommendation_1",
    "text": "Communication skills training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب مهارات الاتصال"
      },
      {
        "language": "FR",
        "text": "Programmes de formation en communication"
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverOtherRecommendation_2",
    "text": "Adopt effective communication strategies",
    "translations": [
      {
        "language": "AR",
        "text": "تبني استراتيجيات الاتصال الفعالة"
      },
      {
        "language": "FR",
        "text": "Adopter des stratégies de communication efficaces"
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverOtherRecommendation_3",
    "text": "Set up weekly or monthly meetings to share business achievements",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإعداد اجتماعات أسبوعية أو شهرية لمشاركة إنجازات الأعمال"
      },
      {
        "language": "FR",
        "text": "Organiser des réunions hebdomadaires ou mensuelles pour partager les réalisations de la société"
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverOtherRecommendation_4",
    "text": "Corporate culture orientation",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تهيئة الموظفين لثقافة العمل"
      },
      {
        "language": "FR",
        "text": "Orientation de la culture de la société"
      }
    ]
  },
  {
    "key": "txtConnectionModerateDriverOtherRecommendation_5",
    "text": "Building and managing teams training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج بناء وإدارة فريق العمل"
      },
      {
        "language": "FR",
        "text": "Création et gestion des programmes de formation des équipes"
      }
    ]
  },
  {
    "key": "txtConnectionEngagedLowDriverReadings",
    "text": "These results indicate that the work environment shows above average efficiency as a result of the collaboration and connection between the teams and other functions. The work environment requires improvement in the social connection between your employees, which may affect the collaboration between them, enhance the work culture, and increase employees’ productivity and efficiency.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تتمتع بمستوى كفاءة فوق المتوسط نتيجة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن بيئة العمل تحتاج لتحسين مستوى التواصل الاجتماعي بين الموظفين والذي بدوره قد يؤثر على التعاون بينهم ويعزز ثقافة العمل ويزيد من كفاءة الموظفين وإنتاجيتهم."
      }
    ]
  },
  {
    "key": "txtConnectionHighDriverReadings",
    "text": "These results indicate that the work environment shows good efficiency as a result of the smooth collaboration and connection between the teams and other functions. The collaborative environment enhances the work culture and increases employees’ productivity and efficiency.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تتمتع بكفاءة جيدة نتيجة سلاسة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن توافر بيئة متعاونة تسهم في تعزيز ثقافة العمل وتزيد من كفاءة الموظفين وإنتاجيتهم."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l'environnement de travail montre une bonne efficacité grâce à la bonne collaboration et à la connexion entre les équipes et les autres fonctions. L’environnement collaboratif améliore la culture de travail et augmente la productivité et l’efficacité des employés."
      }
    ]
  },
  {
    "key": "txtConnectionHighDriverRecommendationBrief",
    "text": "It is recommended to continue the followed strategies to enhance the employees social connection and encourage a continuous collaboration between the teams and other functions. It is important to communicate workplace values that provide a safe and secure environment at work and impose transparency of communication by adopting an open-door policy.",
    "translations": [
      {
        "language": "AR",
        "text": "يوصى هنا بالاستمرار في النهج الحالي المتبع لتعزيز التواصل الاجتماعي بين الموظفين وتشجيع التعاون المستمر بين الفرق والأقسام الأخرى. ويجب المحافظة على ترسيخ قيم مكان العمل التي تضمن بيئة عمل آمنة وفرض مبدأ الشفافية من خلال تبني سياسة الباب المفتوح (open-door policy)."
      },
      {
        "language": "FR",
        "text": "Il est recommandé de poursuivre les stratégies suivies pour renforcer le lien social des employés et encourager une collaboration continue entre les équipes et les autres fonctions. Il est important de communiquer les valeurs du lieu de travail qui offrent un environnement de travail sûr et sécurisé et imposent la transparence de la communication en adoptant une politique de porte ouverte."
      }
    ]
  },
  {
    "key": "txtConnectionHighDriverRecommendationPointHeader",
    "text": "",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtConnectionExtremeHighDriverReadings",
    "text": "These results indicate that the work environment shows extraordinary efficiency as a result of the smooth collaboration and connection between the teams and other functions. The collaborative environment enhances the work culture and increases employees’ productivity and efficiency.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بيئة العمل تتمتع بكفاءة مرتفعة نتيجة سلاسة الاتصال والتعاون بين الفرق والأقسام الأخرى. إن توافر بيئة متعاونة تسهم في تعزيز ثقافة العمل وتزيد من كفاءة الموظفين وإنتاجيتهم."
      },
      {
        "language": "FR",
        "text": "Ces résultats indiquent que l'environnement de travail fait preuve d'une efficacité extraordinaire grâce à une collaboration et une connexion harmonieuse entre les équipes et les autres fonctions. L’environnement collaboratif améliore la culture de travail et augmente la productivité et l’efficacité des employés."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipDriverDesc",
    "text": "Transformational leadership has a positive connection with engagement since it stimulates a relationship between the leader and the employee. When the employees feel like their leader sets a clear vision and inspires and motivates them to achieve a higher level of productivity, they are more likely to be highly engaged with the organization and trust their leaders.",
    "translations": [
      {
        "language": "AR",
        "text": "ترتبط القيادة التحويلية بعلاقة إيجابية مع اندماج الموظفين لأنها تحفز العلاقة بين القائد والموظف. عندما يشعر الموظفون أن قائدهم يضع رؤية واضحة ويلهمهم ويحفزهم لتحقيق مستوى أعلى من الإنتاجية، فمن المرجح أن يثق الموظفون بقادتهم ويكونون أكثر ارتباطاً واندماجاً في العمل."
      },
      {
        "language": "FR",
        "text": "Le leadership transformationnel a un lien positif avec l’engagement puisqu’il stimule une relation entre le leader et l’employé. Lorsque les employés ont l’impression que leur chef établit une vision claire et les inspire et les motive à atteindre un niveau de productivité plus élevé, ils sont plus susceptibles d’être très engagés avec l’organisation et de faire confiance à leurs dirigeants."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverReadings",
    "text": "The analysis demonstrates that the employees do not trust the transformational leadership approach and practices. This shows the importance of the leader's role in helping the employees to understand the approach and building trust, and motivating them at the minimum required level to improve productivity and contribute to achieving business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين ليس لديهم ثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في مساعدتهم على فهم النهج المتبع ومحاولة بناء الثقة وتحفيزهم بالحد الأدنى المطلوب لتحسين مستوى الإنتاجية والمساهمة في تحقيق أهداف العمل. "
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que les employés ne font pas confiance à l'approche et aux pratiques du leadership transformationnel. Cela montre l'importance du rôle du leader en aidant les employés à comprendre l'approche et à bâtir la confiance, et en les motivant au niveau minimum requis pour améliorer la productivité et contribuer à la réalisation des objectifs de la société."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationBrief",
    "text": "These results may indicate a high risk in the transformational leadership approach and practices, which in turn affects employees' engagement. It is recommended to take immediate and rapid actions to enhance employee’s confidence and trust in transformational leadership and its approach.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود درجة عالية من الخطورة بالنسبة لمنهج وسلوك القيادة للمرؤوسين والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات فورية لتعزيز ثقة الموظفين بنهج وسلوك القيادة المتبع."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer un risque élevé dans l'approche et les pratiques de leadership transformationnel, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates et rapides pour renforcer la confiance des employés dans le leadership transformationnel et son approche."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationPointHeader",
    "text": "You can take the following actions to improve this driver. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل القيادة التحويلية:"
      },
      {
        "language": "FR",
        "text": "Les actions suivantes peuvent être prises pour améliorer l'autonomie. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_1",
    "text": "Work in harmony towards achieving the business mission.",
    "translations": [
      {
        "language": "AR",
        "text": "العمل بانسجام لتحقيق رسالة العمل. "
      },
      {
        "language": "FR",
        "text": "Travailler en harmonie pour réaliser la mission d’affaires."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_1",
    "text": "This can be done by conducting weekly meetings with team members and seeking updates from each of them. Listen to their opinions and feedback on the tasks that have been accomplished. Ask if they have been facing any obstacles that they may require help with.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن القيام بذلك من خلال عقد اجتماعات أسبوعية مع أعضاء الفريق، والحصول على المستجدات من كل منهم، والاستماع إلى آرائهم وتعليقاتهم على المهام التي تم إنجازها. والاستفسار عما إذا كانوا يواجهون أي عقبات قد يحتاجون إلى المساعدة بشأنها."
      },
      {
        "language": "FR",
        "text": "Cela peut être fait en menant des réunions hebdomadaires avec les membres de l’équipe et en demandant des mises à jour de chacun d’eux. Écoutez leurs opinions et leurs commentaires sur les tâches qui ont été accomplies. Demandez-leur s'ils ont été confrontés à des obstacles pour lesquels ils pourraient avoir besoin d'aide."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_2",
    "text": "Engage employees in transformational projects.",
    "translations": [
      {
        "language": "AR",
        "text": "إشراك الموظفين في المشاريع التحويلية"
      },
      {
        "language": "FR",
        "text": "Impliquer les employés dans des projets de transformation."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_2",
    "text": "These projects are extremely important because they drive change in the workplace, and sometimes employees try to resist that change. Here, the leader’s role is to encourage them to be a part of those projects; they have a clearer understanding of the direction of the change and have an optimistic outlook on the situation. This way, they are more likely to adapt to change and think out of the box.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه المشاريع مهمة للغاية لأنها تقود التغيير في مكان العمل، وأحياناً يحاول الموظفون مقاومة هذا التغيير. وهنا يأتي دور القائد لتشجيعهم بأن يكونوا جزءاً من تلك المشاريع، وبالتالي سيكون لديهم فهم أوضح للهدف من التغيير ولديهم نظرة متفائلة تجاهه. بهذه الطريقة، هم أكثر احتمالاً وتقبُّلاً للتكيف مع التغيير والتفكير خارج الصندوق."
      },
      {
        "language": "FR",
        "text": "Ces projets sont extrêmement importants car ils conduisent au changement sur le lieu de travail, et parfois les employés essaient de résister à ce changement. Ici, le rôle du leader est de les encourager à faire partie de ces projets; ils ont une meilleure compréhension de la direction du changement et ont une vision optimiste de la situation. De cette façon, ils sont plus susceptibles de s’adapter au changement et de penser hors de la boîte."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_3",
    "text": "Clarify the importance of employees’ roles in the business strategy.",
    "translations": [
      {
        "language": "AR",
        "text": "توضيح أهمية دور الموظفين في استراتيجية العمل."
      },
      {
        "language": "FR",
        "text": "Clarifier l’importance du rôle des employés dans la stratégie d’entreprise."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_3",
    "text": "Ensure that the employees understand the business vision and the importance of their role in achieving its objectives. The employees who feel the direct impact of their contributions on business performance are more likely to be engaged, and they seek to make better decisions and implement new methods to increase productivity and growth.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب التأكد من فهم الموظفين لرؤية العمل وأهمية دورهم في تحقيق أهدافه. إن الموظفين الذين يرون التأثير المباشر لمساهماتهم وانعكاسه على أداء العمل يكونون أكثر تفاعلاً واندماجاً في العمل، ويتخذون قرارات أفضل وتطبيق سبل جديدة لزيادة الإنتاجية والنمو. "
      },
      {
        "language": "FR",
        "text": "S'assurer que les employés comprennent la vision de l'entreprise et l'importance de leur rôle dans l'atteinte de ses objectifs. Les employés qui ressentent l'impact direct de leurs contributions sur la performance de l'entreprise sont plus susceptibles d'être impliqués, et ils cherchent à prendre de meilleures décisions et à mettre en œuvre de nouvelles méthodes pour augmenter la productivité et la croissance."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_4",
    "text": "Enhance creative thinking.",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز التفكير الإبداعي."
      },
      {
        "language": "FR",
        "text": "Améliorer la pensée créative."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_4",
    "text": "The transformational leader can enhance the employees' creative thinking and motivate them to unleash their creativity by solving traditional problems by introducing new ideas methods, thus contributing to building and developing a supportive work environment that positively affects employee engagement.",
    "translations": [
      {
        "language": "AR",
        "text": "لدى القائد التحويلي قدرة على تعزيز التفكير الإبداعي للموظفين وتحفيزهم لإطلاق طاقاتهم للتفكير في حل المشكلات التقليدية من خلال طرح أفكار وطرق جديدة مبدعة، وبذلك يُسهم في بناء وتطوير بيئة عمل داعمة والتي تؤثر بشكل إيجابي على اندماج الموظفين في العمل."
      },
      {
        "language": "FR",
        "text": "Le leader transformationnel peut améliorer la pensée créative des employés et les motiver à libérer leur créativité en résolvant les problèmes traditionnels en introduisant de nouvelles méthodes d'idées, contribuant ainsi à la construction et au développement d'un environnement de travail favorable qui affecte positivement l'engagement des employés."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationTitle_5",
    "text": "Manage your employees and follow up.",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة الموظفين ومتابعتهم."
      },
      {
        "language": "FR",
        "text": "Gérez vos employés et suivez-les."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverRecommendationDesc_5",
    "text": "There are many situations where superiors tell their employees what is required of them, hand them a deadline, and wait for the work to get done. That is not the way to go about things. A leader must explain clearly and directly to employees what is expected of them, get their opinion on a reasonable deadline that can be set, and follow up with them on the periodic progress reports. Additionally, motivate them throughout the process from beginning to end.",
    "translations": [
      {
        "language": "AR",
        "text": "هناك العديد من المواقف التي يخبر فيها الرؤساء المباشرون موظفيهم بما هو مطلوب منهم، ويعطونهم موعداً نهائياً، وينتظرون إنجاز العمل. ليس هذا هو السبيل للتعامل مع الأشياء. يجب أن يشرح القائد للموظفين/المرؤوسين ما هو متوقع منهم بشكل واضح ومباشر، وأن يحصل على رأيهم في موعد نهائي معقول ومقبول يمكن تحديده، وأن يتابع معهم تقارير الإنجاز الدورية. بالإضافة إلى ذلك، قم بتحفيزهم طوال العملية من البداية إلى النهاية."
      },
      {
        "language": "FR",
        "text": "Il existe de nombreuses situations où les supérieurs disent à leurs employés ce qu'on attend d'eux, leur donnent une date limite et attendent que le travail soit terminé. Ce n’est pas la façon de procéder. Un leader doit expliquer clairement et directement aux employés ce que l'on attend d'eux, obtenir leur avis sur un délai raisonnable qui peut être fixé et faire le suivi avec eux des rapports d'étape périodiques. En outre, motivez-les tout au long du processus du début jusqu'à la fin."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_1",
    "text": "Transformational Leadership Development Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تطوير القيادة التحويلية"
      },
      {
        "language": "FR",
        "text": "Programmes de développement du leadership transformationnel"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_2",
    "text": "Change Management training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج التدريب على إدارة التغيير"
      },
      {
        "language": "FR",
        "text": "Programmes de formation en gestion du changement"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_3",
    "text": "Workplace Conflict Management and Resolution programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج التدريب على إدارة النزاعات في مكان العمل وحلها"
      },
      {
        "language": "FR",
        "text": "Programmes de gestion et de résolution des conflits en milieu de travail"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_4",
    "text": "Strategic Change Management programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج إدارة التغيير الاستراتيجي"
      },
      {
        "language": "FR",
        "text": "Programmes de gestion du changement stratégique"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_5",
    "text": "Team Building Skills training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج مهارات بناء الفريق"
      },
      {
        "language": "FR",
        "text": "Programmes de formation sur les compétences de consolidation d'équipe"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeLowDriverOtherRecommendation_6",
    "text": "Leadership Skills workshops",
    "translations": [
      {
        "language": "AR",
        "text": "ورش عمل عن مهارات القيادة"
      },
      {
        "language": "FR",
        "text": "Ateliers sur les compétences en leadership"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipLowDriverReadings",
    "text": "The analysis demonstrates that the employees do not trust the transformational leadership approach and practices. This shows the importance of the leader's role in helping the employees understand the approach, building trust, and motivating them to improve productivity and contribute to achieving business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين ليس لديهم ثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في مساعدتهم على فهم النهج المتبع ومحاولة بناء الثقة وتحفيزهم لتحسين مستوى الإنتاجية والمساهمة في تحقيق أهداف العمل. "
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que les employés ne font pas confiance à l'approche et aux pratiques du leadership transformationnel. Cela montre l'importance du rôle du leader en aidant les employés à comprendre l'approche, en instaurant la confiance et en les motivant à améliorer la productivité et à contribuer à la réalisation des objectifs de la société."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverReadings",
    "text": "The analysis demonstrates that some employees have limited trust in the transformational leadership approach and practices. This shows the importance of the leader's role in clarifying the business vision and motivating employees to achieve a higher level of productivity and execute the business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بعض الموظفين لديهم الحد الأدنى من الثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que certains employés ont une confiance limitée dans l'approche et les pratiques du leadership transformationnel. Cela montre l'importance du rôle du leader dans la clarification de la vision de la société et la motivation des employés à atteindre un niveau de productivité plus élevé et à exécuter les objectifs de la société."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationBrief",
    "text": "These results may indicate potential vulnerabilities in the transformational leadership approach and practices, which in turn affects employees' engagement. It is recommended to take immediate actions to enhance employee’s confidence and trust in transformational leadership and its approach.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه النتائج قد تشير إلى وجود ضعف محتمل بالنسبة لمنهج وسلوك القيادة للمرؤوسين والذي يؤثر بدوره على اندماج الموظفين. ويوصى هنا بضرورة اتخاذ إجراءات لتعزيز ثقة الموظفين بنهج وسلوك القيادة المتبع."
      },
      {
        "language": "FR",
        "text": "Ces résultats peuvent indiquer des vulnérabilités potentielles dans l'approche et les pratiques de leadership transformationnel, ce qui à son tour affecte l'engagement des employés. Il est recommandé de prendre des mesures immédiates pour renforcer la confiance des employés dans le leadership transformationnel et son approche."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationPointHeader",
    "text": "The following actions can be taken to improve this driver autonomy. However, they are not limited to these options:",
    "translations": [
      {
        "language": "AR",
        "text": "ومن الممكن اتخاذ الإجراءات التالية على سبيل المثال لا الحصر لتحسين عامل القيادة التحويلية:"
      },
      {
        "language": "FR",
        "text": "Les actions suivantes peuvent être entreprises pour améliorer cette autonomie du conducteur. Cependant, ils ne sont pas limités à ces options:"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationTitle_1",
    "text": "Coach the employees.",
    "translations": [
      {
        "language": "AR",
        "text": "تدريب الموظفين."
      },
      {
        "language": "FR",
        "text": "Formation et entraînement des employés."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationDesc_1",
    "text": "Coaching and developing others is one of the most important ways to improve employees' performance and broaden their skillset and knowledge to achieve a higher level of professionalism and foster a positive learning environment.",
    "translations": [
      {
        "language": "AR",
        "text": "يُعد تعليم وتوجيه الآخرين من أهم الطرق التي تسهم في تحسين أدائهم وتوسيع مداركهم وتطوير مهاراتهم لدعم تطورهم على الصعيد المهني والوصول لمستوى عالٍ من المهنية والإحترافية ومن الممكن العمل على عقد حلقات تدريبية بشكل مستمر وبالتالي تعزيز وجود بيئة تعليمية إيجابية."
      },
      {
        "language": "FR",
        "text": "L'entraînement et le développement de d'autres sont une des voies les plus importantes qui contribuent à l'amélioration de la performance d'employé et à élargir leurs compétences et leurs connaissances pour atteindre un niveau plus élevé de professionnalisme et ainsi favoriser un environnement d’apprentissage positif."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationTitle_2",
    "text": "Work in harmony towards achieving the business mission.",
    "translations": [
      {
        "language": "AR",
        "text": "العمل بانسجام لتحقيق رسالة العمل"
      },
      {
        "language": "FR",
        "text": "Travailler en harmonie pour réaliser la mission d’affaires."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationDesc_2",
    "text": "This can be done by conducting weekly meetings with team members and seeking updates from each of them. Listen to their opinions and feedback on the tasks that have been accomplished. Ask if they have been facing any obstacles that they may require help with.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن القيام بذلك من خلال عقد اجتماعات أسبوعية مع أعضاء الفريق، والحصول على المستجدات من كل منهم، والاستماع إلى آرائهم وتعليقاتهم على المهام التي تم إنجازها. والاستفسار عما إذا كانوا يواجهون أي عقبات قد يحتاجون إلى المساعدة بشأنها."
      },
      {
        "language": "FR",
        "text": "Cela peut être fait en menant des réunions hebdomadaires avec les membres de l’équipe et en demandant des mises à jour de chacun d’eux. Écoutez leurs opinions et leurs commentaires sur les tâches qui ont été accomplies. Demandez-leur s'ils ont été confrontés à des obstacles pour lesquels ils pourraient avoir besoin d'aide."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationTitle_3",
    "text": "Involve the employees in the change management process.",
    "translations": [
      {
        "language": "AR",
        "text": "إشراك الموظفين في عملية إدارة التغيير."
      },
      {
        "language": "FR",
        "text": "Impliquez les employés dans le processus de gestion du changement."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationDesc_3",
    "text": "Most of the time, employees tend to resist change, which in turn causes slow or even failure to implement change. Here, the leader’s role is to prepare and support the employees to accept and adopt the change and successfully enhance business success and achieve the desired results.",
    "translations": [
      {
        "language": "AR",
        "text": "في أغلب الأحيان يميل الموظفون إلى مقاومة التغيير والتي بدورها تسبب في بطء تنفيذ التغيير أو حتى فشله. وهنا يأتي دور القائد لإعداد وتجهيز ودعم الموظفين في نفس الوقت ليقوموا بتبني التغيير والمساهمة في نجاحه من أجل تعزيز روح العمل وتحقيق النتائج المرجوة. "
      },
      {
        "language": "FR",
        "text": "La plupart du temps, les employés ont tendance à résister au changement, ce qui ralentit, voire échoue, à mettre en œuvre le changement. Ici, le rôle du leader est de préparer et d’aider les employés à accepter et à adopter le changement et à le faire réussir à améliorer le succès de l’entreprise et à atteindre les résultats souhaités."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationTitle_4",
    "text": "Instill trust in the employees to trust in the implemented actions and approach.",
    "translations": [
      {
        "language": "AR",
        "text": "غرس الثقة في الموظفين حتى يتمكنوا من الثقة في الإجراءات والنهج المتبعة. "
      },
      {
        "language": "FR",
        "text": "Instaurer la confiance des employés pour qu'ils fassent confiance aux actions et à l'approche mises en œuvre."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverRecommendationDesc_4",
    "text": "This factor is important because if your employees do not trust the leadership approach, they may not go with what is assigned to them and may deviate/ swerve from the goals that to be achieved. Instill that trust by communicating what to be achieved and the results of those achievements as well as involving the employees in the decision-making process.",
    "translations": [
      {
        "language": "AR",
        "text": "هذا العامل مهم للغاية لأنه إذا كان الموظفون لا يثقون بنهج القيادة؛ ولا يتماشون مع ما يوكل إليهم، وينحرفون عن الأهداف المطلوب تحقيقها. فإنه يجب غرس هذه الثقة من خلال إيصال ما يتطلع القائد إلى تحقيقه، وإبراز نتائج تلك الإنجازات، وجعل الموظفين جزءاً من عملية صنع القرار في كل خطوة يتم اتخاذها."
      },
      {
        "language": "FR",
        "text": "Ce facteur est important car si vos employés ne font pas confiance à l'approche du leadership, ils risquent de ne pas suivre ce qui leur est assigné et de s'écarter / dévier des objectifs à atteindre. Instaurer cette confiance en communiquant ce qui doit être réalisé et les résultats de ces réalisations ainsi qu'en impliquant les employés dans le processus de prise de décision."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverOtherRecommendationHeader",
    "text": "We also encourage the following initiatives and training programs to implement the aforementioned:",
    "translations": [
      {
        "language": "AR",
        "text": "ونشجع على البرامج التدريبية والمبادرات التالية لتنفيذ ما سبق ذكره:"
      },
      {
        "language": "FR",
        "text": "Nous encourageons également les initiatives et les programmes de formation suivants à mettre en œuvre les mesures susmentionnées:"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverOtherRecommendation_1",
    "text": "Transformational Leadership Development Programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تطوير القيادة التحويلية"
      },
      {
        "language": "FR",
        "text": "Programmes de développement du leadership transformationnel"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverOtherRecommendation_2",
    "text": "Coaching and developing other programs",
    "translations": [
      {
        "language": "AR",
        "text": "برنامج التدريب والتوجيه"
      },
      {
        "language": "FR",
        "text": "L'entraînement et le développement d'autres programmes"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverOtherRecommendation_3",
    "text": "Change management programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب إدارة التغيير"
      },
      {
        "language": "FR",
        "text": "Programmes de gestion du changement"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverOtherRecommendation_4",
    "text": "Leadership Skills Workshops",
    "translations": [
      {
        "language": "AR",
        "text": "ورش عمل عن مهارات القيادة"
      },
      {
        "language": "FR",
        "text": "Ateliers sur les compétences en leadership"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipModerateDriverOtherRecommendation_5",
    "text": "Team Building Skills training programs",
    "translations": [
      {
        "language": "AR",
        "text": "برامج تدريب مهارات بناء الفريق"
      },
      {
        "language": "FR",
        "text": "Programmes de formation sur les compétences de consolidation d'équipe"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipEngagedLowDriverReadings",
    "text": "The analysis demonstrates that some employees have an adequate level of trust in the transformational leadership approach and practices. This shows the importance of the leader's role in clarifying the business vision and motivating employees to achieve a higher level of productivity and execute the business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن بعض الموظفين لديهم مستوى كافٍ من الثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يُشير إلى أهمية دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipHighDriverReadings",
    "text": "The analysis demonstrates that the employees trust the transformational leadership approach and practices. This reflects the leader's role in clarifying the business vision and motivating the employees to work hard to achieve a higher level of productivity and execute the business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين لديهم ثقة في نهج وسلوك القيادة للمرؤوسين. وهذا يعكس دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل الجاد من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "L'analyse démontre que les employés font confiance à l'approche et aux pratiques du leadership transformationnel. Cela reflète le rôle du leader dans la clarification de la vision d'entreprise et la motivation des employés à travailler dur pour atteindre un niveau de productivité plus élevé et exécuter les objectifs commerciaux."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipHighDriverRecommendationBrief",
    "text": "The recommended action is to follow up and continue managing your employees with the current style. It helps them understand how their role contributes to the business strategy. It also motivates them to work in harmony to accomplish the business mission. Persevere in engaging the employees in transformational projects and promote their trust in the approach to achieve business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "مسار العمل الموصى به هو متابعة ومواصلة إدارة الموظفين بالأسلوب الحالي لأنه يساعدهم على فهم كيفية مساهمة دورهم في استراتيجية العمل. كما أنه يحفزهم على العمل بانسجام نحو مهمة العمل. ويجب المثابرة على إشراك الموظفين في المشاريع التحويلية وتعزيز ثقتهم في النهج المتبع لتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "L’action recommandée est de faire un suivi et de continuer à gérer vos employés avec le style actuel. Il les aide à comprendre comment leur rôle contribue à la stratégie d'affaires. Il les motive également à travailler en harmonie pour accomplir la mission d’affaires. Persévérer dans l’engagement des employés dans des projets transformationnels et de promouvoir leur confiance dans l’approche pour atteindre les objectifs de l’entreprise."
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipHighDriverRecommendationPointHeader",
    "text": "",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtTransformationalLeadershipExtremeHighDriverReadings",
    "text": "The analysis demonstrates that the employees have immense trust in the transformational leadership approach and practices. This reflects the leader's role in clarifying the business vision and motivating the employees to work in harmony to achieve a higher level of productivity and execute the business goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير النتائج إلى أن الموظفين لديهم ثقة كبيرة في نهج وسلوك القيادة للمرؤوسين. وهذا يعكس دور القائد في توضيح رؤية العمل وتحفيز الموظفين للعمل بانسجام من أجل تحقيق مستوى أعلى من الإنتاجية وتحقيق أهداف العمل."
      },
      {
        "language": "FR",
        "text": "L’analyse démontre que les employés ont une immense confiance dans l’approche et les pratiques de leadership transformationnel. Cela reflète le rôle du leader dans la clarification de la vision de la société et la motivation des employés à travailler en harmonie pour atteindre un niveau de productivité plus élevé et exécuter les objectifs de la société."
      }
    ]
  },
  {
    "key": "txtPreparedFor",
    "text": "Prepared For",
    "translations": [
      {
        "language": "AR",
        "text": "أُعدَّ لـ"
      },
      {
        "language": "FR",
        "text": "Préparé pour"
      }
    ]
  },
  {
    "key": "txtDefinition",
    "text": "Definition",
    "translations": [
      {
        "language": "AR",
        "text": "التعريف"
      },
      {
        "language": "FR",
        "text": "Définition"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      },
      {
        "language": "FR",
        "text": "Confidentiel"
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      },
      {
        "language": "FR",
        "text": "Créé  "
      }
    ]
  },
  {
    "key": "txt_reminder_date",
    "text": "Reminder Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التذكير"
      }
    ]
  },
  {
    "key": "txtExtraQuestionPreview",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      }
    ]
  },
  {
    "key": "txtExtraQuestion",
    "text": "I feel supported by my coworkers when facing challenges at work",
    "translations": [
      {
        "language": "AR",
        "text": "أشعر بدعم زملائي في العمل عند مواجهة التحديات"
      }
    ]
  },
  {
    "key": "txt4Questions",
    "text": "Type a maximum of 4 questions on the right to bound to the custom driver",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب 4 أسئلة كحد أقصى للعامل المخصص"
      }
    ]
  },
  {
    "key": "txtDriverName",
    "text": "Driver Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم العامل"
      }
    ]
  },
  {
    "key": "txtCustomDriver",
    "text": "Add Custom Driver?",
    "translations": [
      {
        "language": "AR",
        "text": " أضف عامل اندماج مخصص"
      }
    ]
  },
  {
    "key": "btn_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "FR",
        "text": "SUIVANT"
      }
    ]
  },
  {
    "key": "btn_add",
    "text": "Add",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة"
      },
      {
        "language": "FR",
        "text": "Ajouter"
      }
    ]
  },
  {
    "key": "btn_add_question",
    "text": "Add Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Question"
      }
    ]
  },
  {
    "key": "txt_txt_no_respondents",
    "text": "At least one respondent needs to added to proceed!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة مستجيب واحد على الأقل!"
      },
      {
        "language": "FR",
        "text": "Au moins un répondant doit ętre ajouté pour continuer!"
      }
    ]
  },
  {
    "key": "txtTypeComment",
    "text": "Type your comment here ...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب اقتراحك هنا …"
      },
      {
        "language": "FR",
        "text": "Ecrivez ici…"
      },
      {
        "language": "HI",
        "text": "अपनी टिप्पणी यहां टाइप करें…"
      },
      {
        "language": "TA",
        "text": "I-type ang iyong komento dito…"
      },
      {
        "language": "UR",
        "text": "اپنا تبصرہ یہاں ٹائپ کریں..."
      },
      {
        "language": "BN",
        "text": "আপনার মন্তব্য এখানে লিখুন..."
      }
    ]
  },
  {
    "key": "txtHavemorecomments",
    "text": "Have more comments?",
    "translations": [
      {
        "language": "AR",
        "text": "هل لديك أي تعليق ؟"
      }
    ]
  },
  {
    "key": "txtAPPROACH",
    "text": "APPROACH",
    "translations": [
      {
        "language": "AR",
        "text": "منهجية"
      },
      {
        "language": "FR",
        "text": "APPROCHE"
      }
    ]
  },
  {
    "key": "txt_survey_setup",
    "text": "Survey Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد الاستبيان"
      },
      {
        "language": "FR",
        "text": "Configuration du Enquęte"
      }
    ]
  },
  {
    "key": "txt_analytical_criteria",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      },
      {
        "language": "FR",
        "text": "Critčres Analytiques"
      },
      {
        "language": "HI",
        "text": "विश्लेषणात्मक मानदंड"
      },
      {
        "language": "TA",
        "text": "Mga Pamantayan sa Analitikal"
      },
      {
        "language": "UR",
        "text": "تجزیاتی معیار"
      },
      {
        "language": "BN",
        "text": "বিশ্লেষণাত্মক মানদণ্ড"
      }
    ]
  },
  {
    "key": "txt_invitation_email",
    "text": "Invitation Email",
    "translations": [
      {
        "language": "AR",
        "text": "دعوة لاستكمال الاستبيان"
      },
      {
        "language": "FR",
        "text": "Courriel d'invitation"
      }
    ]
  },
  {
    "key": "txt_title",
    "text": "title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "FR",
        "text": "Titre"
      }
    ]
  },
  {
    "key": "txt_description",
    "text": "Description (Optional)",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "FR",
        "text": "Description"
      }
    ]
  },
  {
    "key": "txt_select_drivers",
    "text": "Select Survey",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الاستبيان"
      },
      {
        "language": "FR",
        "text": "Sélectionner un Enquęte"
      }
    ]
  },
  {
    "key": "txt_impact_survey",
    "text": "Predefined Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان معد مسبقاً"
      },
      {
        "language": "FR",
        "text": "Enquęte prédéfinie"
      }
    ]
  },
  {
    "key": "txt_impact_survey_description",
    "text": "Use the IMPACT approach with 6 drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاء هذا الاستبيان على منهجية (IMPACT)"
      },
      {
        "language": "FR",
        "text": "Utilisez l'approche IMPACT dans ce Enquęte."
      }
    ]
  },
  {
    "key": "txt_custom_survey",
    "text": "Custom Survey",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء استبيان خاص"
      },
      {
        "language": "FR",
        "text": "Enquęte Personnalisé"
      }
    ]
  },
  {
    "key": "txt_minimum_drivers",
    "text": "Customize a survey by selecting a minimum of 4 drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء استبيانك الخاص من خلال اختيار 4 إلى 5 عوامل اندماج"
      },
      {
        "language": "FR",
        "text": "Personnalisez une enquęte en sélectionnant un minimum de 4 conducteurs."
      }
    ]
  },
  {
    "key": "btn_preview_survey",
    "text": "Preview Survey",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الاستبيان"
      },
      {
        "language": "FR",
        "text": "Aperçu du Enquęte"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      },
      {
        "language": "FR",
        "text": "Précédent"
      }
    ]
  },
  {
    "key": "txt_set_timeframe",
    "text": "Set Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Établir le calendrier"
      }
    ]
  },
  {
    "key": "txt_completion_date",
    "text": "Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال"
      },
      {
        "language": "FR",
        "text": "Date d’Achčvement"
      }
    ]
  },
  {
    "key": "txt_set_reminders",
    "text": "Set Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      },
      {
        "language": "FR",
        "text": "Établir des Rappels"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Rappel"
      }
    ]
  },
  {
    "key": "txt_no_reminders",
    "text": "No reminders have been created.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد أية تذكيرات تم ضبطها حتى الآن!"
      },
      {
        "language": "FR",
        "text": "Aucun rappel n'a été créé."
      }
    ]
  },
  {
    "key": "txt_multiple_reminders",
    "text": "Multiple Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تذكيرات متعددة"
      },
      {
        "language": "FR",
        "text": "Rappels multiples"
      }
    ]
  },
  {
    "key": "txt_multiple_reminders_description",
    "text": "Remind your respondents at preset times to fill the survey before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template.",
    "translations": [
      {
        "language": "AR",
        "text": "ذكّر المستجيبين بتعبئة الاستبيان قبل موعد الانتهاء من خلال تذكيرات محددة مسبقًا. اضبط 3 تذكيرات كحد أقصى باستخدام الواجهة اليمنى. اضغط على الزر أدناه لتعديل البريد الالكتروني الخاص بالتذكير."
      },
      {
        "language": "FR",
        "text": "Rappelez à vos répondants à des heures prédéfinies de répondre à l'enquête avant la date de fin. <br> Définissez un maximum de 3 rappels pour ne pas utiliser la bonne interface. <br> Cliquez sur le bouton ci-dessous pour modifier le modèle d'e-mail."
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المستجيب؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer ce répondant?"
      }
    ]
  },
  {
    "key": "txt_one_respondent_needed",
    "text": "At least one respondent needs to complete the survey to close",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يتم إكمال الاستبيان من مستجيب واحد على الأقل لإغلاق الاستبيان"
      },
      {
        "language": "FR",
        "text": "Le Enquęte doit ętre rempli par au moins un répondant pour clôturer l'enquęte"
      }
    ]
  },
  {
    "key": "txt_yes",
    "text": "Yes",
    "translations": [
      {
        "language": "AR",
        "text": "نعم"
      },
      {
        "language": "FR",
        "text": "Oui"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_subject",
    "text": "Delete Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد الحذف"
      },
      {
        "language": "FR",
        "text": "Confirmation de suppression"
      }
    ]
  },
  {
    "key": "txt_remove_respondents_confirmation_message",
    "text": "Are you sure you want to delete these respondents?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer ces répondants?"
      }
    ]
  },
  {
    "key": "txt_allocation_confirmation",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "FR",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "txtInvitationMissingURL",
    "text": "The email is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا البريد الإلكتروني!"
      },
      {
        "language": "FR",
        "text": "Il manque un lien au courriel!"
      }
    ]
  },
  {
    "key": "txt_start_and_endDate",
    "text": "Please, add start date and end date.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إضافة تاريخ البدء وتاريخ الانتهاء."
      },
      {
        "language": "FR",
        "text": "add at least one unit to proceed."
      }
    ]
  },
  {
    "key": "txt_reminder_template",
    "text": "Reminder Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير"
      },
      {
        "language": "FR",
        "text": "Modčle de Rappel"
      }
    ]
  },
  {
    "key": "txt_send_invitations",
    "text": "Send Invitations",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      },
      {
        "language": "FR",
        "text": "Envoyer des Invitations"
      }
    ]
  },
  {
    "key": "txt_selected_drivers",
    "text": "Selected Drivers",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل الاندماج"
      },
      {
        "language": "FR",
        "text": "r les Facteurs Sélectionnés"
      }
    ]
  },
  {
    "key": "txtEmailTemplate",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الالكتروني"
      },
      {
        "language": "FR",
        "text": "Modčle d’email"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      },
      {
        "language": "FR",
        "text": "N/A"
      }
    ]
  },
  {
    "key": "txt_recommended",
    "text": "(Recommended)",
    "translations": [
      {
        "language": "AR",
        "text": "(موصى به)"
      },
      {
        "language": "FR",
        "text": "(Recommandé)"
      }
    ]
  },
  {
    "key": "txtinnovation",
    "text": "Innovation",
    "translations": [
      {
        "language": "AR",
        "text": "الابتكار"
      },
      {
        "language": "FR",
        "text": "Innovation"
      }
    ]
  },
  {
    "key": "txtex",
    "text": "Ex. Mia",
    "translations": [
      {
        "language": "AR",
        "text": "مثال: محمد"
      },
      {
        "language": "FR",
        "text": "Ex. Louise"
      }
    ]
  },
  {
    "key": "txtMotivation",
    "text": "Motivation",
    "translations": [
      {
        "language": "AR",
        "text": "التحفيز"
      },
      {
        "language": "FR",
        "text": "Motivation"
      }
    ]
  },
  {
    "key": "txtPerformance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      },
      {
        "language": "FR",
        "text": "Performance"
      },
      {
        "language": "HI",
        "text": "कार्य-निष्पादन"
      },
      {
        "language": "TA",
        "text": "Pagganap"
      },
      {
        "language": "UR",
        "text": "کارکردگی"
      },
      {
        "language": "BN",
        "text": "কর্মক্ষমতা"
      }
    ]
  },
  {
    "key": "txtAutonomy",
    "text": "Autonomy",
    "translations": [
      {
        "language": "AR",
        "text": "الاستقلالية"
      },
      {
        "language": "FR",
        "text": "Autonomie"
      }
    ]
  },
  {
    "key": "txtConnection",
    "text": "Connection",
    "translations": [
      {
        "language": "AR",
        "text": "الاتصال"
      },
      {
        "language": "FR",
        "text": "Connexion"
      }
    ]
  },
  {
    "key": "txtTransformationalLeadership",
    "text": "Transformational Leadership",
    "translations": [
      {
        "language": "AR",
        "text": "القيادة التحويلية"
      },
      {
        "language": "FR",
        "text": "Leadership transformationnel"
      }
    ]
  },
  {
    "key": "txtType",
    "text": "Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع"
      },
      {
        "language": "FR",
        "text": "Type"
      }
    ]
  },
  {
    "key": "TransformationalLeadership",
    "text": "Transformational Leadership",
    "translations": [
      {
        "language": "AR",
        "text": "القيادة التحويلية"
      },
      {
        "language": "FR",
        "text": "Leadership transformationnel"
      }
    ]
  },
  {
    "key": "preparingReport",
    "text": "Preparing Report",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير التقرير"
      }
    ]
  },
  {
    "key": "txt_no-timeframe",
    "text": "No timeframe has been chosen.",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم تحديد مدة زمنية"
      },
      {
        "language": "FR",
        "text": "Aucun calendrier n'a été choisi."
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
      },
      {
        "language": "FR",
        "text": "#UNITS# les unités seront déduites pour cette action"
      }
    ]
  },
  {
    "key": "Employee Engagement is the employee's emotional commitment to the workplace and their willingness to give their best and show high performance to achieve business goals",
    "text": "Employee Engagement is the employee's emotional commitment to the workplace and their willingness to give their best and show high performance to achieve business goals",
    "translations": [
      {
        "language": "AR",
        "text": "\"الاندماج الوظيفي\" هو الالتزام العاطفي بين الموظفين ومكان العمل ورغبتهم في تقديم أفضل ما لديهم وإظهار مستوى أداء عالٍ لتحقيق أهداف العمل."
      }
    ]
  },
  {
    "key": "It has no predetermined definition; however, it is wrapped around employees' connection with their job and place.",
    "text": "It has no predetermined definition; however, it is wrapped around employees' connection with their job and place.",
    "translations": [
      {
        "language": "AR",
        "text": "وبشكل عام، ليس هناك تعريف محدد \"للاندماج الوظيفي\". إلا أنها مرتكزة على ارتباط الموظفين مع عملهم والمكان الذي يعملون فيه."
      }
    ]
  },
  {
    "key": "Employee Engagement plays an essential role in promoting a culture of loyalty and fostering the motivation for employees who take the leap for the work they feel recognizes them.",
    "text": "Employee Engagement plays an essential role in promoting a culture of loyalty and fostering the motivation for employees who take the leap for the work they feel recognizes them.",
    "translations": [
      {
        "language": "AR",
        "text": "يُمثّل \"الاندماج الوظيفي\" دوراً أساسياً في تعزيز ثقافة الولاء وتشجيع الموظفين وتحفيزهم لتقديم أفضل ما عندهم، خصوصاً عند مقابلة مواقفهم بالدعم والتقدير. "
      }
    ]
  },
  {
    "key": "The Employee Engagement Survey applies the IMPACT model to measure the employees' interaction in the workplace, which is displayed in this report through indepth analysis, and scores.",
    "text": "The Employee Engagement Survey applies the IMPACT model to measure the employees' interaction in the workplace, which is displayed in this report through indepth analysis, and scores.",
    "translations": [
      {
        "language": "AR",
        "text": "يُطبق \"استبيان الاندماج الوظيفي\" منهجية “IMPACT” لقياس التفاعل الذي يُحققه ويُنجزه الموظفين في مكان العمل، والذي يتم عرضه في هذا التقرير من خلال التحليل المتعمق في التقييم، والردود."
      }
    ]
  },
  {
    "key": "Objective of this Report",
    "text": "Objective of this Report",
    "translations": [
      {
        "language": "AR",
        "text": "أهداف التقرير"
      }
    ]
  },
  {
    "key": "Compare the overall workplace engagement score of the selected companies",
    "text": "Compare the overall workplace engagement score of the selected companies",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة درجة الاندماج الإجمالية في مكان العمل للشركات المختارة."
      }
    ]
  },
  {
    "key": "Compare the results of the engagement drivers of the selected companies.",
    "text": "Compare the results of the engagement drivers of the selected companies.",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة نتائج الاندماج الوظيفي لعوامل الاندماج للشركات المختارة."
      }
    ]
  },
  {
    "key": "Obtain an overview of companies' performance towards the engagement drivers to highlight areas of improvement of the low scores’ drivers.",
    "text": "Obtain an overview of companies' performance towards the engagement drivers to highlight areas of improvement of the low scores’ drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "الحصول على نظرة عامة على أداء الشركات لكل عوامل الاندماج وتسليط الضوء على مجالات تحسين عوامل الاندماج ذات النتائج المتدنية."
      }
    ]
  },
  {
    "key": "This report is a representation of the workplace engagement of the selected companies. The overall engagement score will help understand how the companies perform.",
    "text": "This report is a representation of the workplace engagement of the selected companies. The overall engagement score will help understand how the companies perform.",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح هذا التقرير مستوى الاندماج الوظيفي للشركات المختارة وسوف تساعد النتيجة الإجمالية للاندماج في فهم كيفية أداء الشركات."
      }
    ]
  },
  {
    "key": "The drivers and their engagement scores displayed in this report are a result of the employees' responses.",
    "text": "The drivers and their engagement scores displayed in this report are a result of the employees' responses.",
    "translations": [
      {
        "language": "AR",
        "text": "إن عوامل الاندماج المبينة في هذا التقرير ومستوى الاندماج الخاص بها هي نتيجة وخلاصة استجابة الموظفين للاستبيانات."
      }
    ]
  },
  {
    "key": "Employee Engagement Levels",
    "text": "Employee Engagement Levels",
    "translations": [
      {
        "language": "AR",
        "text": "مستويات الاندماج الوظيفي"
      }
    ]
  },
  {
    "key": "The below rating scale determines the engagement levels and what each level represents",
    "text": "The below rating scale determines the engagement levels and what each level represents",
    "translations": [
      {
        "language": "AR",
        "text": "يحدد مقياس التقييم أدناه مستويات الاندماج الوظيفي وما يمثله كل مستوى."
      }
    ]
  },
  {
    "key": "Score Range",
    "text": "Score Range",
    "translations": [
      {
        "language": "AR",
        "text": "النسبة المئوية"
      }
    ]
  },
  {
    "key": "AP_T_1_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_T_1_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض التقدم العام، حالة المهام، والتفاصيل الأساسية مثل مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_T_2_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_2_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Drivers.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو عوامل."
      }
    ]
  },
  {
    "key": "AP_T_3_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_T_3_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_T_4_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_T_4_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_T_5_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_T_5_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_T_6_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_T_6_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_T_7_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_7_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders.\nHint: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية.\nتلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_T_8_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_T_8_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      }
    ]
  },
  {
    "key": "AP_T_9_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_T_9_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_T_10_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_T_10_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted.\nHint: Minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات.\nتلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_T_11_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_T_11_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_T_12_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_T_12_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  },
  {
    "key": "AP_S_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost engagement.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى الاندماج الوظيفي."
      }
    ]
  },
  {
    "key": "AP_S_T_2_TITLE",
    "text": "New Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة عمل جديدة"
      }
    ]
  },
  {
    "key": "AP_S_T_2_DESCRIPTION",
    "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تحديد وحدة معيّنة أو اختيار مستوى الشركة بالكامل، انقر على خطة عمل جديدة في وسط الشاشة للبدء، أو استخدم الزر الموجود في أعلى اليسار."
      }
    ]
  },
  {
    "key": "AP_S_T_3_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_S_T_3_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_S_T_4_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_4_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.\nHint: It’s recommended to create an action plan for only one entity at a time.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق.\nتلميح: يُوصى بإنشاء خطة عمل لوحدة واحدة على حدة."
      }
    ]
  },
  {
    "key": "AP_S_T_5_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_5_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_6_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_7_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_7_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_S_T_8_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_8_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_S_T_9_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_9_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_10_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_S_T_10_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_S_T_11_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_S_T_11_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_S_T_12_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_S_T_12_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_13_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_13_DESCRIPTION",
    "text": "Once everything looks good, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد التأكد من أن كل شيء يبدو على ما يرام، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_14_TITLE",
    "text": "Driver Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب العامل"
      }
    ]
  },
  {
    "key": "AP_S_T_14_DESCRIPTION",
    "text": "Based on the selected engagement drivers, choose the ones you want to focus on. Hint: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى عوامل الاندماج المحددة، اختر العوامل التي ترغب في التركيز عليها. تلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      }
    ]
  },
  {
    "key": "AP_S_T_15_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_S_T_15_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_S_T_16_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_16_DESCRIPTION",
    "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد التأكد من مجالات التركيز المختارة، اضغط على “التالي” للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_17_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_17_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your initiatives!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المبادرات المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_18_TITLE",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_S_T_18_DESCRIPTION",
    "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر مجال التركيز، ثم حدّد المبادرة المربع بجانبها.\nملاحظة: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_19_TITLE",
    "text": "Custom Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مخصصة"
      }
    ]
  },
  {
    "key": "AP_S_T_19_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_S_T_20_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_20_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_21_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_21_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_22_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_22_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_S_T_23_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_23_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_24_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_24_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على“✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_S_T_25_TITLE",
    "text": "Edit Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المبادرة"
      }
    ]
  },
  {
    "key": "AP_S_T_25_DESCRIPTION",
    "text": "Edit or delete the Initiative. Note: predefined initiatives cannot be edited/deleted.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف المبادرة.  تلميح: لا يمكن تعديل/حذف المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_26_TITLE",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "مسح"
      }
    ]
  },
  {
    "key": "AP_S_T_26_DESCRIPTION",
    "text": "You can delete any initiative by clicking on the three vertical dots",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_S_T_27_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_27_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرات، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_28_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_28_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your tasks!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المهام المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_29_TITLE",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_29_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرة، حدِّد المهام بوضع علامة في المربع المجاور لها.\nتلميح: لا يمكن تعديل المهام المحددة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_30_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_S_T_30_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_S_T_31_TITLE",
    "text": "Edit Task",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_31_DESCRIPTION",
    "text": "You can update the task by clicking on the pen icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث المهمة بالنقر على أيقونة القلم."
      }
    ]
  },
  {
    "key": "AP_S_T_32_TITLE",
    "text": "Delete Task",
    "translations": [
      {
        "language": "AR",
        "text": "مسح المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_32_DESCRIPTION",
    "text": "You can delete any task by clicking on the delete icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح أي مهمة بالنقر على أيقونة المسح."
      }
    ]
  },
  {
    "key": "AP_S_T_33_TITLE",
    "text": "AI- Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_33_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة للمبادرة!"
      }
    ]
  },
  {
    "key": "AP_S_T_34_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_34_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_35_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_35_DESCRIPTION",
    "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المهام، اضغط على التالي للمتابعة.\nملاحظة: يجب أن تحتوي كل مبادرة على مهمة واحدة على الأقل ومالك واحد"
      }
    ]
  },
  {
    "key": "AP_S_T_36_TITLE",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_36_DESCRIPTION",
    "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع تفاصيل خطة العمل بما في ذلك مجالات التركيز والمبادرات والمهام والمسؤولين والجداول الزمنية."
      }
    ]
  },
  {
    "key": "AP_S_T_37_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_S_T_37_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  }
]